const zhTC = {
  // 登入相關
  login: {
    title: 'SS.AI 客服',
    platformTitle: 'CUI 工作平台',
    platformTitlePrefix: '中小企的 ',
    platformTitleHighlight: 'CUI',
    platformTitleSuffix: ' 工作平台',
    userId: '使用者 ID',
    email: 'Email',
    accountOrEmail: '帳號或 Email',
    password: '密碼',
    loginButton: '登入',
    loginSuccess: '登入成功！',
    loginFailed: '登入失敗',
    userIdRequired: '請輸入使用者 ID！',
    passwordRequired: '請輸入密碼！',
    accountPasswordError: '帳號或密碼錯誤',
    networkError: '登入失敗，請檢查網路連線',
    welcome: '歡迎使用 SS.AI 客服，{name}！',
    userIdLabel: '使用者 ID',
    logout: '登出',
    logoutSuccess: '已登出'
  },
  wpaLogin: {
    loginName: '登入帳號',
    password: '密碼',
    passwordPlaceholder: '請輸入密碼',
    rememberLogin: '自動登入',
    rememberLoginHint: '會記住此裝置上的登入帳號（密碼不會由網頁儲存，請用瀏覽器密碼管理或自行輸入）。若上次未登出，進入此頁將自動進入商店。',
    sessionRestoring: '正在恢復登入…',
    forgotPassword: '忘記密碼',
    forgotPasswordTitle: '忘記密碼',
    login: '登入',
    loggingIn: '登入中...',
    validatingWhatsappLink: '正在驗證 WhatsApp 連結...',
    otpSentTo: '驗證碼已發送至',
    otpCode: '驗證碼 (OTP)',
    verify: '驗證',
    verifying: '驗證中...',
    useAccountPassword: '改用帳號密碼登入',
    backToLogin: '返回登入',
    selectCompany: '請選擇公司',
    whatsappOtpLogin: 'WhatsApp 驗證登入',
    networkError: '網路錯誤，請稍後再試',
    loginFailed: '登入失敗，請確認帳號密碼',
    otpFailed: 'OTP 驗證失敗，請重新輸入',
    companySelectFailed: '公司選擇失敗',
    linkValidateFailed: '連結驗證失敗，請重新從 WhatsApp 開啟',
    enterLoginNameFirst: '請先輸入登入帳號，再按忘記密碼',
    forgotPasswordGuide: '請先在登入頁輸入「登入帳號」，再選擇下方重設方式（僅顯示您帳號已登記的 WhatsApp 電話或電郵）。',
    forgotPasswordNoChannels: '此帳號未登記電話或電郵，無法重設密碼。請聯絡管理員。',
    forgotPasswordChooseMethod: '選擇重設方式',
    forgotPasswordPhoneOnlyHint: '請輸入登入帳號後，系統將以已登記電話發送 OTP 驗證碼',
    forgotPasswordByEmail: '電郵收取驗證碼',
    forgotPasswordEmailUnavailable: '此帳號不存在、未綁定電郵，或電郵 OTP 模板尚未設定。請改試 WhatsApp 或聯絡管理員。',
    forgotPasswordByPhone: '電話接收驗證碼',
    forgotPasswordEmailDone: '若此帳號存在且已登記電郵，您將收到重設密碼連結。',
    forgotPasswordPhoneUnavailable: '此帳號不存在、未綁定電話，或無法發送驗證碼。請改試電郵或聯絡管理員。',
    forgotPasswordNewPassword: '新密碼',
    forgotPasswordConfirmPassword: '確認新密碼',
    forgotPasswordSubmitPhone: '驗證並重設密碼',
    forgotPasswordPhoneSuccess: '密碼已重設，請返回登入。',
    forgotPasswordMismatch: '兩次輸入的密碼不一致',
    resetPasswordTitle: '重設密碼',
    resetPasswordSubmit: '設定新密碼',
    resetPasswordSuccess: '密碼已更新，請返回登入。',
    resetPasswordBackToLogin: '返回登入',
    resetPasswordTokenMissing: '連結無效或已過期，請重新申請重設。',
    passwordMinLength: '密碼至少需 8 個字元',
    brandSubtitle: 'WhatoCommerce',
    languageAria: '介面語言',
    otpLoginSeparator: '或透過以下方式登入',
    sendWhatsappOtp: '以 WhatsApp 傳送驗證碼',
    sendEmailOtp: '以電郵傳送驗證碼',
    emailOtpLogin: '電郵驗證碼登入',
    sendingOtp: '正在發送...',
    emailOtpSentTo: '驗證碼已發至電郵',
  },
  wpa: {
    changePassword: {
      title: '修改密碼',
      currentPassword: '目前密碼',
      newPassword: '新密碼',
      confirmPassword: '確認新密碼',
      submit: '儲存新密碼',
      success: '密碼已成功更新。',
      errorMismatch: '兩次輸入的密碼不一致',
      errorMinLength: '密碼至少需 8 個字元',
      errorWrongCurrent: '目前密碼不正確',
      errorNetwork: '網路錯誤，請稍後再試',
    },
    common: {
      loading: '載入中...',
      loadMore: '載入更多...',
      noProducts: '暫無商品',
      noCategories: '暫無分類',
      noOrders: '暫無訂單',
      priceInquire: '價格請詢',
      outOfStock: '沒有庫存',
      noStock: '沒有庫存',
      addToCartAria: '加入購物車',
      search: '搜尋',
      allCategories: '所有分類',
      searchPlaceholder: '搜尋商品...',
      noSearchResults: '查無商品',
      cannotOrderOutOfStock: '此商品庫存為「沒有庫存」，無法下單。',
      cannotOrderInactiveStatus: '此商品狀態為「{status}」，無法下單。',
      catalogStatusDisplay: '狀態：{status}',
      catalogStatusLabels: {
        outOfStock: '斷貨',
        stopOrdering: '停止訂購',
        suspend: '暫停',
      },
      emDash: '—',
      forbiddenAction: '無權限執行此操作',
      requestFailedStatus: '請求失敗（{status}）',
      customerSuspendedBlock:
        '很抱歉，您的帳戶已暫停，請聯絡業務人員了解詳情。\n\n業務：{sales}\n業務代碼：{code}\nWhatsApp：{whatsapp}\n\n錯誤代碼：C',
      cannotAddToCartTitle: '無法加入購物車',
      moqSubmitBlocked: '以下品項數量未達最少訂購量（MOQ），請調整後再提交：',
      moqSubmitLineFmt: '{label}：最少 {moq}，目前 {qty}',
      moqSubmitDocPrefix: '單據 {cartNo}',
    },
    titles: {
      home: '首頁',
      categories: '商品分類',
      products: '商品列表',
      cart: '購物車',
      cartDetail: '訂單資料',
      orders: '訂單記錄',
      account: '帳戶資訊',
      orderDetail: '訂單詳情',
    },
    layout: {
      menuHome: '首頁',
      menuCategories: '分類',
      menuCart: '購物車',
      menuOrders: '訂單記錄',
      menuAccount: '帳戶資訊',
      menuChangePassword: '修改密碼',
      ariaMenu: '選單',
      ariaBack: '返回',
      ariaSearch: '搜尋',
      ariaCart: '購物車',
      logout: '登出',
      selectCustomer: '選擇客戶身份',
      current: '當前',
      cancel: '取消',
      installTitle: '安裝 WhatoCommerce 到手機桌面',
      installBodyAndroid: '為了最佳操作體驗，請先安裝到主畫面。點擊下方「立即安裝」。',
      installBodyIos: '為了最佳操作體驗，請先安裝到主畫面。iPhone 請使用 Safari 的分享按鈕，選擇「加入主畫面」。',
      installBodyAndroidManual: '若未出現「立即安裝」，請點 Chrome 右上角 ⋮ →「安裝應用程式」或「新增至主畫面」。安裝後會從本商店登入頁開啟。',
      installLater: '稍後',
      installNow: '立即安裝',
      installGotIt: '我知道了',
    },
    home: {
      banner: '精選推薦商品',
      recommended: '推薦商品',
      allCategoriesBtn: '所有商品分類',
      toastAddedLatest: '已加入最新購物車: {name} x{qty}',
      toastNewCart: '已建立新購物車並加入: {name} x{qty}',
      promoClose: '關閉',
      promoAddToCart: '加入購物車',
      promoNoProduct: '此廣告未連結可購買商品',
      promoOutOfStock: '暫不可加購',
      ariaFullscreenAd: '全螢幕廣告',
      promoCarouselDots: '廣告輪播',
      promoPrev: '上一張廣告',
      promoNext: '下一張廣告',
      recommendDelete: '刪除',
      recommendDeleted: '已從推薦列表移除：{name}',
      recommendDeleteFailed: '無法刪除推薦價格表',
      recommendDeleteConfirmTitle: '確認刪除？',
      recommendDeleteConfirmMsg: '確定要從推薦列表移除「{name}」嗎？此操作無法復原。',
      recommendDeleteConfirmBtn: '確認刪除',
    },
    addToCart: {
      defaultUnit: '件',
      perQtyFmt: '每{unit} {price}',
      qtyWithUnitFmt: '{qty} {unit}',
      fastStepMinus: '- {step}',
      fastStepPlus: '+ {step}',
      unitStepMinus: '-1',
      unitStepPlus: '+1',
      createNewOrder: '建立新訂單',
      cancel: '取消',
      addToCart: '加入購物車',
    },
    productList: {
      recommendAdded: '已加入推薦價格表（Order App）：{name}',
      recommendFailed: '加入推薦失敗',
      recommendNeedCustomer: '請先在選單選擇客戶身分',
      addRecommendAria: '加入推薦價格表',
      backToRecommended: '返回推薦商品',
    },
    categories: {
      itemsCount: '{count} 項商品',
      featuredBtn: '推薦商品',
    },
    cartDocs: {
      section: '購物車單據 ({count})',
      notSubmitted: '未提交',
      empty: '尚未建立購物車單據',
      submitAll: '全部提交',
      submitting: '提交中...',
      toastSubmitted: '已提交 {count} 張訂單',
      toastNothing: '沒有可提交的購物車',
      toastFail: '提交失敗，請重試',
    },
    cartDetail: {
      orderSubmitted: '訂單已提交',
      submitFail: '提交失敗',
      notFound: '找不到購物車單據',
      orderNo: '訂單編號',
      total: '總數',
      deliveryDate: '送貨日期',
      poNo: '採購單號',
      remark: '備註',
      address: '地址',
      addressPlaceholder: '送貨地址（可填多行）',
      errorTitle: '無法提交',
      errorOk: '確定',
      updated: '已更新',
      update: '更新',
      submit: '提交',
      submitting: '提交中...',
      deleteOrder: '刪除訂單',
      confirmRemoveItemTitle: '移除此項目？',
      confirmRemoveItemMsg: '是否要將此商品從購物車中移除？',
      confirmDeleteOrderTitle: '將會刪除整張訂單',
      confirmDeleteOrderMsg: '這是訂單中最後一項商品，移除後整張訂單將會刪除。是否繼續？',
      confirmDeleteOrderBtnTitle: '確定刪除訂單？',
      confirmDeleteOrderBtnMsg: '此訂單將會被刪除，且無法復原。',
      confirmLeaveTitle: '尚未儲存變更',
      confirmLeaveMsg: '您剛才的修改尚未點「更新」儲存，離開將會遺失。是否仍要離開？',
      confirmYes: '確定',
      confirmNo: '取消',
      confirmLeave: '離開',
      confirmStay: '繼續編輯',
      confirmRemove: '移除',
      confirmDelete: '刪除',
      confirmKeep: '保留',
    },
    orders: {
      tabAll: '全部',
      tabSubmitted: '已提交',
      tabProcessing: '處理中',
      statusPending: '待確認',
      statusSubmitted: '已提交',
      statusProcessing: '處理中',
      statusCompleted: '已完成',
      statusCancelled: '已取消',
    },
    orderDetail: {
      orderUpdated: '訂單已更新',
      updateFailed: '更新失敗',
      orderSubmitted: '訂單已提交',
      submitFailed: '提交失敗',
      orderDeleted: '訂單已刪除',
      deleteFailed: '刪除失敗',
      loading: '載入中...',
      notFound: '找不到訂單',
      orderInfo: '訂單資訊',
      orderNo: '訂單編號',
      status: '狀態',
      orderDate: '提交時間',
      deliveryDate: '交貨日期',
      customerNo: '客戶編號',
      poNo: 'PO 號碼',
      poPlaceholder: '輸入 PO 號碼',
      remark: '備註',
      remarkPlaceholder: '輸入備註',
      address: '地址',
      addressPlaceholder: '輸入地址',
      orderLines: '訂單明細',
      lineSubtotal: '小計',
      deleteLineAria: '刪除品項',
      total: '合計',
      processing: '處理中...',
      updateOrder: '更新訂單',
      submitOrder: '提交訂單',
      deleteOrder: '刪除訂單',
      confirmDelete: '確認刪除',
      confirmDeleteMsg: '確定要刪除此訂單嗎？此操作無法復原。',
      cancel: '取消',
      confirmDeleteBtn: '確認刪除',
      titleWithNo: '訂單 {orderNo}',
      lineSubtotalFmt: '小計: {amount}',
      errorTitle: '無法操作',
      errorOk: '確定',
    },
    account: {
      basicInfo: '基本資料',
      customerNo: '客戶編號',
      name1: '名稱',
      name2: '分店名稱',
      displayName: '顯示名稱（目前語系）',
      nameEn: '英文名稱',
      nameCn: '繁體名稱',
      nameSc: '簡體名稱',
      deliveryAddress: '送貨地址',
      addressEn: '英文地址',
      addressCn: '中文地址',
      salesman: '業務員',
      deliveryDays: '送貨日',
      holiday: '假日',
      loadFailed: '無法載入帳戶資訊',
      sectionDelivery: '送貨地址',
      sectionSales: '業務員',
      sectionDeliveryDays: '送貨日',
      weekdays: {
        Mon: '一', Tue: '二', Wed: '三', Thu: '四', Fri: '五', Sat: '六', Sun: '日',
      },
    },
    legacyCart: {
      cartItems: '購物車商品 ({count})',
      pendingOrders: '待確認訂單 ({count})',
      pendingConfirm: '待確認',
      subtotal: '小計',
      empty: '購物車是空的',
      submitAll: '提交所有訂單',
      submitting: '提交中...',
      toastNoCustomer: '無法取得客戶資料，請聯繫管理員',
      toastNoLink: '未設定關聯客戶，請聯繫管理員',
      toastCreateFail: '建立訂單失敗',
      toastSuccess: '訂單已提交成功！',
      toastFail: '提交失敗，請重試',
    },
  },
  
  // 選單項目
  menu: {
    dashboard: '儀表板',
    application: '應用',
    publishedApps: '已發布應用',
    pendingTasks: '運行中的表單',
    adminTools: '管理工具',
    contactList: '聯絡人管理',
    broadcastGroups: '廣播群組',
    hashtags: '標籤管理',
    studio: '工作室',
    unsigned: '已送貨未簽收',
    customerSigned: '客戶已簽收',
    signedPending: '已簽收待確認',
    logout: '登出',
    dashboardRecentActivity: '最近活動',
    whatsappWorkflow: '工作流程設計',
    companyUserAdmin: '公司/用戶管理',
    eformList: '表單管理',
    whatsappTemplates: '訊息模版',
    workflowMonitor: '運行中的應用', // 新增這個翻譯鍵
    runningApps: '運行中的應用',
    chatBotInbox: 'ChatBot 對話',
    calendar: '日曆',
    documentLibrary: '文檔中心',
    phoneVerificationAdmin: '電話號碼驗證',
    permissionManagement: '權限管理',
    apiProviders: 'API 管理',
    commerce: '商務管理',
    commerceCustomers: '客戶主檔',
    commercePriceCards: '價格表',
    commerceSalesOrders: '銷售訂單',
    commerceCollections: '商品集合',
    commerceProducts: '商品清單',
    commerceWpaHomePromotions: 'PWA 首頁廣告',
    commerceImport: '資料交換',
    commerceImportSchedule: '匯入排程',
    commerceCatalogAdmin: 'Mete 目錄管理',
    commerceWpaPermissions: 'PWA 權限管理',
    commerceDeliveryRules: '送貨截單規則',
    reports: '報表',
    dailyReports: '每日報表',
    monthlyReports: '每月報表',
    realtimeReports: '實時報表',
    appsMediaReports: '應用媒體報表',
    eformInstanceReports: '表單實例報表',
    eformPivotReports: '表單樞紐分析',
    commerceReports: '商務管理報表',
    reportsBillingSystem: '全系統用量計費',
    usageBillingSettings: '用量計費單價',
    aiEmployeeProfiles: 'AI 員工檔案',
    dataSets: '數據集管理',
    buildApp: 'Build App',
    workflowPackage: 'CUI 應用套件',
    knowledgeBase: '知識庫',
    reportTemplates: '報表範本庫',
    templateReport: '範本報表',
  },

  buildApp: {
    welcomeTitle: '你想建立什麼流程？',
    welcomeSubtitle: '描述業務場景、渠道需求或目標，AI 將引導你逐步完成建置',
    inputPlaceholder: '例如：建立一個 WhatsApp 客服流程，自動分流詢問，並在需要人手時通知同事審批…',
    inputPlaceholder2: '輸入回覆（Enter 送出，Shift+Enter 換行）',
    planFirst: 'Plan First',
    planFirstHelp: '開啟後 AI 收集完需求會先展示計劃讓你確認，再開始生成',
    startBtn: '開始建立',
    suggestionLabel: '快速開始：',
    suggestion1: 'WhatsApp 客服自動回覆流程',
    suggestion2: '訂單多步驟審批工作流',
    suggestion3: '新員工入職資料收集表單',
    suggestion4: '電郵通知 + 任務分派流程',
    suggestion5: 'Meta Flow 引導式問卷',
    suggestion6: 'WhatsApp × 電郵混合通知',
    chatTitle: 'Build App',
    newApp: '新建應用',
    appsHistory: 'Apps 歷史',
    aiThinking: 'AI 思考中…',
    uploadImage: '上傳參考圖片',
    planCardTitle: '建置計劃',
    planChannel: '渠道',
    planWorkflowNodes: '流程節點',
    planEformFields: '表單欄位',
    planWizardSteps: '建置嚮導步驟',
    planModify: '修改計劃',
    planConfirm: '確認並開始生成',
    buildingMsg: 'AI 正在生成應用，請稍候…',
    completeMsg: '應用已生成！點擊下方按鈕進入建置嚮導，按步驟完善各項設定。',
    openDesigner: '開啟設計器',
    openWorkflowDesigner: '① 開啟流程設計器',
    openFormDesigner: '開啟表單設計器',
    openMetaflowDesigner: '開啟 MetaFlow 設計器',
    wizardStart: '下一步：進入建置嚮導',
    wizardTitle: '建置嚮導',
    wizardBackToChat: '返回 Build App',
    wizardPrev: '上一步',
    wizardNext: '確認，下一步',
    wizardFinish: '完成建置',
    wizardDone: '建置完成！',
    wizardLoading: '載入中…',
    wizardLoadFail: '載入失敗',
    wizardSaved: '已儲存',
    wizardPreFinalizing: '正在套用選用設定到流程節點，請稍候…',
    wizardPreFinalizeDone: '已將選用設定套用到流程節點',
    wizardFinalizeFail: '部分資源自動關聯失敗，可在流程設計器中手動設定節點屬性',
    wizardPickLabel: '選用於流程：',
    wizardPickPlaceholder: '選擇要用於流程的項目（可先在下方新增再重新整理）',
    wizardPickSelected: '已選用',
    wizardPickRefresh: '重新整理',
    wizardStep: {
      eform: '表單',
      metaflow: 'Meta Flow',
      template: '訊息模板',
      dataset: 'Dataset',
      aiStaff: 'AI 員工',
      kb: '知識庫',
      workflow: '工作流程',
    },
    wizardHint: {
      eform: '在此調整表單欄位與版面，確認後進入下一步。',
      metaflow: '在此調整 Meta Flow 畫面，確認後進入下一步。',
      template: '在此建立或修改 WhatsApp 訊息模板（24 小時外推送需 Meta Template）。',
      dataset: '在此設定 Dataset 欄位與資料來源，確認後進入下一步。',
      aiStaff: '在此設定 AI 員工檔案，確認後進入下一步。',
      kb: '在此上傳知識庫文件，確認後進入下一步。',
      workflow: '在此完善流程節點，eForm 節點已自動關聯。',
    },
    generateFailMsg: '生成過程中發生錯誤，請描述需求後重試。',
    modifyPlanPrompt: '好的，請告訴我你想調整哪些部分？',
    suggChangeChannel: '更換渠道',
    suggAddApproval: '加入審批步驟',
    suggRemoveForm: '不需要表單',
  },

  usageBilling: {
    title: '用量計費',
    joinDate: '計費週期起點（加入日）',
    period: '計費期間',
    workflowExecution: '流程執行',
    metaOutbound: 'Meta 對外',
    aiCall: 'AI 調用',
    rates: '單價',
    totalAmount: '小計',
    loadFailed: '無法載入用量',
    noPermission: '無權限檢視此報表',
    systemReportTitle: '全系統用量計費',
    settingsTitle: '用量計費單價設定',
    selectCompany: '選擇公司',
    currency: '幣別',
    metaTemplatePrice: 'Meta 對外（每條）',
    aiCallPrice: 'AI（每次）',
    workflowExecPrice: '流程執行（每次）',
    saveSuccess: '已儲存',
    saveFailed: '儲存失敗',
    loadCompaniesFailed: '無法載入公司列表',
    loadSettingsFailed: '無法載入計價設定',
  },

  commerceDeliveryRules: {
    hint: '特殊送貨日以列表為準；未列日期則依每週截單秒數。公司時區請於公司資料設定（IANA timezone）。PWA 下單時會依公司時區與上表驗證截單。',
    companyFilter: '公司',
    tabCalendar: '特殊送貨日／截單',
    tabWeekly: '每週截單（秒）',
    addWeekday: '新增星期',
    colDeliveryDate: '送貨日',
    colDeliveryWeekday: '星期',
    yearFilter: '送貨日年份',
    yearFilterAll: '全部年份',
    colHoliday: '假日',
    colCutoff: '截單日時',
    colWeekday: '星期',
    descriptionEn: '英文說明',
    descriptionZh: '中文說明',
    noPermission: '無權限',
    loadFailed: '載入失敗',
    saved: '已儲存',
    deleted: '已刪除',
    orderCutoffDate: '截單日',
    orderCutoffTime: '截單時間',
    editWeek: '編輯週截單',
    addWeekdayTitle: '新增星期截單',
    cutoffOffsetSeconds: '截單偏移（秒）',
    weekdayField: '星期（0=週日～6=週六）',
    weekdaySelectPlaceholder: '0=週日 … 6=週六',
    deleteCalendarConfirm: '確定刪除此特殊送貨日？',
  },

  aiEmployeeProfiles: {
    title: 'AI 員工檔案',
    loadFailed: '載入失敗',
    searchPlaceholder: '搜尋姓名、編號、部門',
    viewList: '列表',
    viewTile: '圖磚',
    create: '新增',
    createTitle: '新增 AI 員工',
    editTitle: '編輯 AI 員工',
    employeeNumber: '員工編號',
    employeeNumberAuto: '員工編號將於建立後自動產生',
    avatar: '頭像',
    gender: '性別',
    genderMale: '男',
    genderFemale: '女',
    genderOther: '其他',
    displayName: '姓名',
    nameRequired: '請輸入姓名',
    department: '部門',
    jobTitle: '職位',
    jobDescription: '職務說明',
    responsibilities: '職責（技能擬人化）',
    responsibilitiesHint: '輸入後按 Enter 或逗號新增',
    birthDate: '生日',
    age: '年紀',
    birthplace: '出生地',
    industry: '行業',
    background: '背景',
    workExperience: '工作經驗',
    professionalSkills: '專業能力',
    personality: '性格',
    tabWork: '職務與頭像',
    tabPersonal: '個人資料',
    tabMemory: '我的回憶',
    memoryLabel: '回憶／日誌（Markdown）',
    memoryHelp:
      '此欄會累積此 AI 員工的互動脈絡：包含流程中 wait 驗證、eForm 填表、HTML／Office 產生等每次成功 AI 調用的輸入／輸出摘要，以及擴寫、生成頭像等操作。內容會在下次組裝角色 prompt 時一併帶入，亦可手動編修。',
    memoryPlaceholder: '尚無紀錄。流程與 AI 填表成功後會自動附加摘要；擴寫或生成頭像亦會寫入；您也可自行貼上備註。',
    memoryWizardHint: '建立完成後，可在編輯模式的「我的回憶」分頁查看與維護互動日誌。',
    loadDetailPartial: '無法載入完整明細，已顯示列表資料（回憶可能未同步）。',
    createdAt: '建立時間',
    actions: '操作',
    save: '儲存',
    saved: '已儲存',
    created: '已建立',
    deleted: '已刪除',
    confirmDelete: '確定刪除此員工檔案？',
    randomAvatar: 'AI 生成頭像',
    avatarProvider: '頭像用 AI Provider',
    expandProvider: '擴寫用 Provider',
    selectAiProvider: '請先選擇 AI Provider',
    avatarOk: '頭像已更新',
    aiModalTitle: 'AI 依欄位擴寫',
    aiHintPlaceholder: '簡短說明期望（可留空）',
    aiApplied: '已套用 AI 內容',
    prev: '上一步',
    next: '下一步',
    submitCreate: '建立',
    wizardStepOrg: '部門與職位',
    wizardStepProfile: '理想同事',
    wizardStepBio: '背景與特質',
    wizardStepRole: '職務內容',
    wizardReviewHint: '確認無誤後按下「建立」。',
    /** 與 public/ai-employee-lookups.json 的 value 一致；繁中顯示 */
    lookupLabels: {
      departments: {
        客服部: '客服部',
        營運部: '營運部',
        資訊部: '資訊部',
        人資部: '人資部',
        財務部: '財務部',
        行銷部: '行銷部',
        業務部: '業務部',
        產品部: '產品部',
        研發部: '研發部',
        法務部: '法務部',
        總經理室: '總經理室'
      },
      jobTitles: {
        專員: '專員',
        資深專員: '資深專員',
        主任: '主任',
        副理: '副理',
        經理: '經理',
        副總經理: '副總經理',
        顧問: '顧問',
        實習生: '實習生',
        助理: '助理',
        組長: '組長',
        課長: '課長',
        總監: '總監'
      },
      birthplaces: {
        香港: '香港',
        台北: '台北',
        新北: '新北',
        桃園: '桃園',
        台中: '台中',
        台南: '台南',
        高雄: '高雄',
        新加坡: '新加坡',
        上海: '上海',
        北京: '北京',
        深圳: '深圳',
        廣州: '廣州',
        東京: '東京',
        首爾: '首爾',
        吉隆坡: '吉隆坡',
        倫敦: '倫敦',
        雪梨: '雪梨'
      },
      industries: {
        金融服務: '金融服務',
        保險: '保險',
        地產與物業: '地產與物業',
        建築與工程: '建築與工程',
        物流與運輸: '物流與運輸',
        零售與批發: '零售與批發',
        餐飲與酒店: '餐飲與酒店',
        科技與資訊: '科技與資訊',
        電訊: '電訊',
        專業服務: '專業服務',
        醫療與健康: '醫療與健康',
        教育與培訓: '教育與培訓',
        政府與公共機構: '政府與公共機構',
        傳媒與廣告: '傳媒與廣告',
        製造業: '製造業',
        能源與公用事業: '能源與公用事業',
        非牟利與社福: '非牟利與社福',
        航空與旅遊: '航空與旅遊',
        其他: '其他'
      }
    }
  },

  // Dashboard 儀表板
  dashboard: {
    applicationTitle: '應用',
    applicationDescription: '已發布的工作流程應用，可直接啟動使用',
    studioTitle: '工作室',
    studioDescription: '管理和設計工具，打造您的專屬工作流程',
    adminToolsTitle: '管理工具',
    adminToolsDescription: '系統管理和用戶管理工具',
    contactManagement: '聯絡人管理',
    contactManagementDescription: '管理 WhatsApp 聯絡人資料',
    broadcastGroups: '廣播群組',
    broadcastGroupsDescription: '管理廣播群組和成員',
    hashtagManagement: '標籤管理',
    hashtagManagementDescription: '管理系統標籤和分類',
    companyUserManagement: '公司/用戶管理',
    companyUserManagementDescription: '管理公司帳戶和用戶權限',
    totalContacts: '總聯絡人',
    totalGroups: '總群組',
    totalMembers: '總成員',
    totalHashtags: '總標籤',
    hashtagUsage: '使用次數',
    totalUsers: '總用戶',
    admins: '管理員',
    totalCompanies: '總公司',
    publishedApps: '已發布應用',
    publishedAppsDescription: '可用的工作流程應用',
    runningApps: '運行中的應用',
    runningAppsDescription: '當前正在執行的流程實例',
    pendingTasks: '待處理事項',
    pendingTasksDescription: '需要您處理的審批和回覆',
    formManagement: '表單管理',
    formManagementDescription: '電子表單設計與管理',
    messageTemplates: '訊息模板',
    messageTemplatesDescription: 'WhatsApp 訊息模板管理',
    workflowDesign: '工作流程設計',
    workflowDesignDescription: '設計和配置工作流程',
    datasetManagement: '數據集管理',
    datasetManagementDescription: '數據源和數據集管理',
    aiEmployeeProfiles: 'AI 員工檔案',
    aiEmployeeProfilesDescription: '虛擬 AI 同事人事檔與頭像',
    userManagement: '用戶管理',
    userManagementDescription: '公司用戶和權限管理',
    systemMonitoring: '系統監控',
    systemMonitoringDescription: '流程執行監控和分析',
    workflowMonitor: '運行中的應用',
    workflowMonitorDescription: '工作流程執行監控和分析',
    totalCount: '總數',
    recentlyAdded: '最近新增',
    loading: '載入中...',
    loadingDashboard: '載入儀表板中...',
    active: '活躍',
    draft: '草稿',
    disabled: '停用',
    running: '運行中',
    completed: '已完成',
    failed: '失敗',
    pendingApproval: '待審批',
    processed: '已處理',
    today: '今日',
    enabled: '啟用',
    inactive: '停用',
    published: '已發布',
    test: '測試',
    totalDatasets: '總數據集',
    error: '錯誤',
    totalUsers: '總用戶',
    online: '在線',
    admin: '管理員',
    successRate: '成功率',
    averageTime: '平均時間',
    minutes: '分',
    // 數據分析相關
    dataAnalysis: '數據分析',
    dataAnalysisDescription: '系統運行數據即時概覽',
    messageTrend: '訊息趨勢',
    hotWorkflows: '熱門流程',
    formStatus: '表單狀態',
    systemHealth: '系統健康',
    messageSuccessRate: '訊息成功率',
    workflowSuccessRate: '流程成功率',
    avgExecutionTime: '平均執行時間',
    pendingTasksCount: '待處理任務',
    seconds: '秒',
    past7Days: '過去 7 天',
    executionCount: '執行次數',
    pending: '待處理',
    approved: '已批准',
    rejected: '已拒絕'
  },

  // 待處理事項頁面
  pendingTasks: {
    // 展開列雙區塊（Form 字段 / 流程資料）
    expandedSection: {
      formFields: 'Form 字段',
      processVariables: '流程資料'
    },
    title: '待處理事項',
    description: '處理等待決策的表單申請',
    totalPending: '總待處理',
    pendingApproval: '待審批',
    overdueItems: '逾期項目',
    urgentItems: '緊急項目',
    formName: '表單名稱',
    processInstanceId: '流程實例 ID',
    workflowInstanceId: '工作流程實例 ID',
    status: '狀態',
    fillType: '填寫類型',
    priority: '優先級',
    applicant: '申請人',
    applicationTime: '申請時間',
    dueDate: '截止時間',
    action: '操作',
    approve: '批准',
    reject: '拒絕',
    approveTooltip: '批准',
    rejectTooltip: '拒絕',
    submitForm: '提交表單',
    submitFormTooltip: '提交表單',
    submitFormMessage: '表單提交功能開發中...',
    formOpenedForSubmission: '表單已在新標籤頁中打開，請填寫並提交',
    resubmitForm: '重新提交',
    searchPlaceholder: '搜尋表單名稱、申請人...',
    priorityPlaceholder: '優先級',
    all: '全部',
    high: '高',
    medium: '中',
    low: '低',
    manualFill: '手動填寫',
    aiFill: 'AI 填寫',
    dataFill: '數據填寫',
    aiDataFill: 'AI/數據填寫',
    inhouseForm: 'In-house Form',
    inhouseFormDescription: '認證電話號碼或登入操作<br/>例如：內部系統運作',
    publicForm: 'Public Form',
    publicFormDescription: '一般電話號碼，不需登入操作<br/>例如：推廣、意見收集',
    manualPendingForms: '待回應表單',
    manualRespondedForms: '已收到回應表單',
    noManualPendingForms: '暫無待回應的手動填寫表單',
    noManualRespondedForms: '暫無已收到回應的手動填寫表單',
    overdue: '逾期',
    pending: '待處理',
    approved: '已批准',
    rejected: '已拒絕',
    submitted: '已提交',
    changeToApproved: '更改為已批准',
    changeToRejected: '更改為已拒絕',
    statusChangeConfirmation: '狀態更改確認',
    statusChangeWarning: '狀態更改警告',
    currentStatus: '當前狀態',
    decidedBy: '決定人',
    decidedAt: '決定時間',
    changeTo: '更改為',
    confirmStatusChange: '確認更改',
    confirmStatusChangeQuestion: '您確定要更改此表單的狀態嗎？',
    noPendingTasks: '暫無待處理事項',
    approveApplication: '批准申請',
    rejectApplication: '拒絕申請',
    confirmApprove: '確認批准',
    confirmReject: '確認拒絕',
    cancel: '取消',
    confirmApproval: '確認批准',
    confirmRejection: '確認拒絕',
    applicantLabel: '申請人：',
    applicationTimeLabel: '申請時間：',
    approvalNote: '批準備註',
    approvalNotePlaceholder: '請輸入批準備註（可選）',
    rejectionReason: '拒絕原因',
    rejectionReasonPlaceholder: '請輸入拒絕原因（必填）',
    rejectionReasonRequired: '請輸入拒絕原因',
    operationSuccess: '操作成功',
    operationFailed: '操作失敗',
    approveSuccess: '批准成功',
    rejectSuccess: '拒絕成功',
    approveFailed: '批准失敗',
    rejectFailed: '拒絕失敗',
    save: '保存',
    saveSuccess: '表單內容已保存',
    saveFailed: '保存失敗',
    loadPendingTasksFailed: '載入待處理事項失敗',
    loadStatisticsFailed: '載入統計數據失敗',
    refresh: '刷新',
    clearFilters: '清空',
    exportExcel: '匯出 Excel',
    exportDisabledTip: '請先在下拉選單選擇一種表單定義（Process Definition），才能匯出 Excel',
    noDataToExport: '沒有可匯出的資料',
    exportSuccess: '匯出成功',
    exportFailed: '匯出失敗',
    definitionPlaceholder: '選擇表單定義',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    approvalAt: '核准時間',
    pendingTasksList: '待處理表單',
    pendingForms: '待處理表單',
    approvedForms: '已批准表單',
    rejectedForms: '已拒絕表單',
    approvedBy: '已批准',
    rejectedBy: '已拒絕',
    noApprovedForms: '沒有已批准的表單',
    noRejectedForms: '沒有已拒絕的表單',
    pageRange: '第 {start}-{end} 項，共 {total} 項',
    itemsPerPage: '條/頁',
    jumpTo: '跳至',
    page: '頁',
    confirm: '確定',
    loading: '載入中...',
    error: '錯誤',
    success: '成功',
    viewFormInstance: '查看表單實例',
    loadingFormInstance: '載入表單實例中...',
    close: '關閉',
    openInNewTab: '在新標籤頁中打開',
    noFormData: '無表單數據',
    userMessage: '用戶訊息',
    
    // 批量處理相關翻譯
    select: '選擇',
    selectAll: '全選',
    deselectAll: '取消全選',
    selectedItems: '已選擇 {count} 項',
    clearSelection: '清除選擇',
    batchApprove: '批量批准',
    batchReject: '批量拒絕',
    batchChangeToApproved: '批量改為批准',
    batchChangeToRejected: '批量改為拒絕',
    batchOperationConfirmation: '批量操作確認',
    batchOperationType: '操作類型',
    selectedFormsCount: '選擇的表單數量',
    formsList: '表單列表',
    confirmBatchOperation: '確認執行此批量操作嗎？',
    operationNote: '操作備註',
    operationNotePlaceholder: '請輸入操作原因...',
    confirmExecute: '確認執行',
    batchOperationSuccess: '批量操作成功',
    batchOperationFailed: '批量操作失敗',
    batchApprovalSuccess: '成功批准 {count} 個表單',
    batchRejectionSuccess: '成功拒絕 {count} 個表單',
    batchStatusChangeSuccess: '成功更改 {count} 個表單狀態'
  },
  
  // 未簽收管理
  unsigned: {
    title: '已送貨未簽收',
    totalRecords: '總記錄數',
    totalProcessed: '總處理量',
    currentPageRecords: '當前頁記錄數',
    search: '搜尋',
    searchPlaceholder: '搜尋發票號、客戶名稱、電話...',
    filterAll: '全部',
    filterUnconfirmed: '未確定',
    filterConfirmed: '已確定',
    confirm: '確認',
    confirmSelected: '確認選中',
    confirmSuccess: '確認成功',
    confirmFailed: '確認失敗',
    downloadPdf: '下載 PDF',
    previewImage: '預覽圖片',
    customerTel: '客戶電話',
    invoiceNo: '發票號',
    customerName: '客戶名稱',
    orderLines: '訂單明細',
    noData: '暫無資料',
    loading: '載入中...',
    pageSize: '每頁筆數',
    manualReview: '客服手動確認',
    customerSignedPending: '已簽收待確認',
    customerSignedConfirmed: '已確認',
    customerNo: '客戶編號',
    receiptDate: '收據日期',
    uploadDate: '上傳日期',
    remarks: '備註',
    status: '狀態',
    action: '操作',
    confirmed: '已確認',
    unconfirmed: '未確認',
  },
  
  // Workflow
  workflow: {
    title: '流程管理',
    add: '新增流程',
    name: '流程名稱',
    createdBy: '建立人',
    createdAt: '建立日期',
    updatedAt: '最後修改',
    status: '狀態',
    action: '操作',
    design: '設計',
    copy: '複製',
    delete: '刪除',
    confirmDeleteTitle: '確定要刪除此流程嗎？',
    confirmDeleteContent: '流程名稱：{name}',
    confirmDeleteOk: '刪除',
    confirmDeleteCancel: '取消',
    copySuccess: '已複製流程',
    deleteSuccess: '已刪除流程',
    deleteFailed: '刪除失敗',
    copyFailed: '複製失敗',
    save: '儲存流程',
    saveSuccess: '流程已儲存！',
    saveFailed: '儲存失敗',
    nameRequired: '請輸入流程名稱',
    mustHaveStartEnd: '流程必須包含 Start 與 End 節點',
    mustHaveEdge: '請建立節點連線',
    description: '描述（可選）',
    back: '返回列表',
    new: '新增流程',
    edit: '編輯流程',
    searchPlaceholder: '搜尋流程名稱、建立人...',
    search: '搜尋',
    nodeTypes: '節點類型',
    to: '收件人',
    message: '訊息內容',
    sql: 'SQL 查詢',
    apiUrl: 'API 網址',
    formName: '表單名稱',
    result: '結果',
    approved: '已核准',
    rejected: '已拒絕',
    deleteEdge: '刪除連線',
    startNodeCannotEdit: 'Start 節點無法編輯'
  },
  
  // 通用
  common: {
    loading: '載入中...',
    error: '錯誤',
    success: '成功',
    cancel: '取消',
    confirm: '確認',
    save: '儲存',
    delete: '刪除',
    edit: '編輯',
    add: '新增',
    search: '搜尋',
    configure: '設置',
    configured: '已配置',
    notConfigured: '未配置',
    all: '全部',
    action: '操作',
    refresh: '重新整理',
    clear: '清除',
    submit: '提交',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    close: '關閉',
    open: '開啟',
    on: '開',
    off: '關',
    yes: '是',
    no: '否',
    ok: '確定',
    passwordPolicy: {
      generatePassword: '自動產生',
      generateSuccess: '已產生密碼',
      generateFailed: '無法產生密碼',
    },
    required: '必填',
    minLength: '至少 {min} 碼',
    pageRange: '第 {start}-{end} 項，共 {total} 項',
    status: '狀態',
    actions: '操作',
    every: '每',
    minutes: '分鐘',
    active: '啟用',
    inactive: '停用',
    paused: '已暫停',
    activate: '啟用',
    deactivate: '停用',
    systemDefault: '系統默認',
    editingCompany: '編輯公司',
    export: '匯出',
    exportExcel: '匯出 Excel',
    exportPdf: '匯出 PDF',
    formName: '表單名稱',
    instanceName: '實例名稱',
    fillType: '填寫類型',
    createdAt: '創建時間',
    createdDate: '建立日期',
    createdBy: '建立人',
    updatedAt: '更新時間',
    updatedDate: '更新日期',
    updatedBy: '更新人',
    recipientName: '收件人姓名',
    recipientWhatsApp: '收件人 WhatsApp',
    userMessage: '用戶訊息',
    dueDate: '到期日期',
    startDate: '開始日期',
    endDate: '結束日期',
    today: '今天',
    last7Days: '最近7天',
    selectMonth: '選擇月份',
    minutes: '分鐘',
    pending: '待處理',
    submitted: '已提交',
    approved: '已審批',
    rejected: '已拒絕',
    aiFill: 'AI 填寫',
    dataFill: '數據填寫',
    manualFill: '手動填寫',
    unauthorized: '未授權',
    reset: '重置'
  },

  // 收件人選擇器
  recipientSelector: {
    title: '選擇收件人',
    placeholder: '選擇收件人',
    clearAll: '清除全部',
    confirmSelection: '確認選擇',
    clear: '清除',
    
    // Tabs
    users: '用戶',
    contacts: '聯絡人',
    processVariables: '流程資料',
    initiators: '流程啟動人',
    
    // Search placeholders
    searchUsers: '搜尋用戶...',
    searchContacts: '搜尋聯絡人...',
    
    // Selected recipients display
    selectedRecipients: '已選收件人',
    usersCount: '{count} 位用戶',
    contactsCount: '{count} 個聯絡人',
    groupsCount: '{count} 個群組',
    hashtagsCount: '{count} 個標籤',
    variablesCount: '{count} 個變量',
    processInitiator: '流程啟動人',
    
    // Users tab
    usersTab: {
      title: '用戶',
      noUsersFound: '找不到用戶',
      userPhone: '電話：{phone}',
      userEmail: '郵箱：{email}'
    },
    
    // Contacts tab
    contactsTab: {
      title: '聯絡人',
      broadcastGroups: '廣播群組',
      noGroupsData: '無廣播群組資料',
      hashtags: '標籤',
      noHashtagsData: '無標籤資料',
      contactList: '聯絡人清單',
      totalContacts: '共 {count} 個聯絡人',
      noContactsFound: '找不到聯絡人',
      whatsAppNumber: 'WhatsApp：{number}',
      email: '郵箱：{email}',
      pageRange: '第 {start}-{end} 項，共 {total} 項'
    },
    
    // Process Variables tab
    processVariablesTab: {
      title: '流程資料',
      description: '選擇流程資料，系統將在執行時自動替換為實際值（建議選擇包含電話號碼的變量）',
      noVariablesFound: '找不到流程資料',
      value: '值：{value}',
      dataType: '類型：{type}',
      instructions: {
        title: '使用說明',
        items: [
          '顯示所有類型的流程資料',
          '建議選擇包含電話號碼的變量',
          '選中的變量將以 ${variableName} 格式保存',
          '系統將在工作流執行時自動替換為實際值',
          '適合與外部系統（如 ERP）集成'
        ]
      }
    },
    
    // Process Initiator tab
    initiatorsTab: {
      title: '流程啟動人',
      useInitiator: '使用流程啟動人',
      description: '勾選後，系統將在執行時自動使用啟動此工作流實例的用戶作為收件人',
      instructions: {
        title: '使用說明',
        items: [
          '此選項將在工作流執行時自動替換為實際的流程啟動人',
          '適合需要向流程啟動人發送消息或等待其回覆的場景',
          '系統將自動從 workflow_executions 表的 InitiatedBy 字段獲取啟動人信息'
        ]
      }
    },
    
    // Tags and labels
    tagLabels: {
      user: '用戶',
      contact: '聯絡人',
      group: '群組',
      hashtag: '標籤',
      variable: '變量',
      initiator: '流程啟動人'
    },
    
    // Fallback texts
    fallbackTexts: {
      unknownGroup: '未知群組',
      unknownTag: '未知標籤',
      unknownVariable: '未知變量',
      autoReplace: '運行時自動替換',
      noBroadcastGroupsData: '無廣播群組資料',
      noHashtagsData: '無標籤資料',
      noUsersData: '無用戶資料',
      noContactListsData: '無聯絡人清單資料'
    }
  },

  // 聯絡人管理
  contactList: {
    title: '聯絡人管理',
    management: '聯絡人管理',
    description: '管理您的聯絡人列表和廣播群組',
    searchPlaceholder: '搜尋聯絡人...',
    allGroups: '所有群組',
    allTags: '所有標籤',
    reset: '重置',
    import: '匯入',
    addContact: '新增聯絡人',
    editContact: '編輯聯絡人',
    deleteContact: '刪除聯絡人',
    batchDelete: '批量刪除',
    selectedContacts: '已選擇 {count} 個聯絡人',
    noContactsFound: '找不到聯絡人',
    noContactsDescription: '請新增聯絡人或調整搜尋條件',
    name: '姓名',
    title: '職稱',
    contactInfo: '聯絡資訊',
    company: '公司/部門',
    group: '群組',
    tags: '標籤',
    createdAt: '創建時間',
    updatedAt: '更新時間',
    actions: '操作',
    edit: '編輯',
    delete: '刪除',
    confirmDelete: '確認刪除',
    confirmDeleteMessage: '您確定要刪除聯絡人 "{name}" 嗎？此操作無法復原。',
    cancel: '取消',
    deleteSuccess: '聯絡人刪除成功',
    deleteError: '刪除聯絡人失敗',
    batchDeleteSuccess: '成功刪除 {count} 個聯絡人',
    batchDeleteError: '批量刪除聯絡人失敗',
    loadError: '載入聯絡人列表失敗',
    updateSuccess: '聯絡人已更新',
    createSuccess: '聯絡人已創建',
    updateError: '更新聯絡人失敗',
    createError: '創建聯絡人失敗',
    // 表單欄位
    occupation: '職業',
    position: '職位',
    whatsappNumber: 'WhatsApp 號碼',
    email: '電子郵件',
    companyName: '公司名稱',
    department: '部門',
    broadcastGroup: '廣播群組',
    hashtags: '標籤',
    // 表單提示
    namePlaceholder: '請輸入姓名',
    titlePlaceholder: '請輸入職稱',
    occupationPlaceholder: '請輸入職業',
    positionPlaceholder: '請輸入職位',
    whatsappPlaceholder: '請輸入 WhatsApp 號碼',
    emailPlaceholder: '請輸入電子郵件',
    companyPlaceholder: '請輸入公司名稱',
    departmentPlaceholder: '請輸入部門',
    broadcastGroupPlaceholder: '選擇廣播群組',
    hashtagsPlaceholder: '輸入標籤，用逗號分隔',
    // 驗證訊息
    nameRequired: '請輸入姓名',
    whatsappNumberRequired: '請輸入 WhatsApp 號碼',
    broadcastGroupRequired: '請選擇廣播群組',
    formValidationFailed: '表單驗證失敗，請檢查必填欄位',
    // 按鈕
    back: '返回',
    save: '儲存',
    update: '更新',
    create: '創建',
    // 側邊欄
    quickAddTags: '快速添加標籤',
    preview: '預覽',
    currentTags: '當前標籤：',
    tagsLabel: '標籤：',
    tabBasic: '基本',
    tabAttachments: '附件',
    contactAvatar: '聯絡人頭像',
    uploadAvatar: '上傳頭像',
    changeAvatar: '更換頭像',
    attachmentHint: '可上傳證件、證書等個人文件（PNG、JPG、PDF）',
    saveBeforeUpload: '請先儲存聯絡人，即可上傳頭像與附件',
    attachmentUpload: '上傳附件',
    openFile: '開啟',
    removeFile: '移除',
    uploadSuccess: '上傳成功',
    uploadError: '上傳失敗',
    removeSuccess: '已移除',
    removeError: '移除失敗',
    imageOnlyHint: '僅支援圖片（jpg、png、gif、webp）',
    docTypesHint: '僅支援 PNG、JPG、PDF'
  },

  // 廣播群組管理
  broadcastGroups: {
    title: '廣播群組管理',
    description: '管理聯絡人群組，方便分類和廣播',
    addGroup: '新增群組',
    editGroup: '編輯群組',
    deleteGroup: '刪除群組',
    groupName: '群組名稱',
    groupDescription: '群組描述',
    groupColor: '群組顏色',
    contactCount: '聯絡人數量',
    createdAt: '創建時間',
    updatedAt: '更新時間',
    actions: '操作',
    edit: '編輯',
    delete: '刪除',
    confirmDelete: '確認刪除',
    confirmDeleteMessage: '確定要刪除群組「{name}」嗎？此操作無法復原。',
    cancel: '取消',
    create: '創建',
    update: '更新',
    createSuccess: '群組已創建',
    updateSuccess: '群組已更新',
    deleteSuccess: '群組已刪除',
    createError: '創建群組失敗',
    updateError: '更新群組失敗',
    deleteError: '刪除群組失敗',
    loadError: '載入群組列表失敗',
    noGroupsFound: '沒有找到群組',
    noGroupsDescription: '請新增群組',
    quickSelect: '快速選擇：',
    namePlaceholder: '請輸入群組名稱',
    descriptionPlaceholder: '請輸入群組描述',
    nameRequired: '請輸入群組名稱',
    formValidationFailed: '表單驗證失敗，請檢查必填欄位'
  },

  // 聯絡人匯入
  contactImport: {
    title: '聯絡人匯入',
    selectSource: '選擇數據源',
    selectSourceDesc: '選擇要匯入的數據來源',
    mapFields: '字段映射',
    mapFieldsDesc: '將數據字段映射到聯絡人欄位',
    importData: '匯入數據',
    importDataDesc: '確認並開始匯入',
    
    // 數據源選項
    selectDataSource: '選擇數據源',
    excelFile: 'Excel 文件',
    excelFileDesc: '從 Excel 文件匯入數據',
    googleSheets: 'Google Sheets',
    sqlDatabase: 'SQL 數據庫',
    uploadExcel: '上傳 Excel 文件',
    uploadExcelFile: '上傳 Excel 文件',
    connectGoogle: '連接 Google Sheets',
    connectSQL: '連接 SQL 數據庫',
    supportedFormats: '支援 .xlsx, .xls, .csv 格式',
    googleSheetsDesc: '從 Google Sheets 匯入數據',
    sqlDatabaseDesc: '從 SQL 數據庫匯入數據',
    
    // Excel 配置
    excelConfig: 'Excel 文件配置',
    excelFilePath: 'Excel 文件路徑',
    selectSheet: '選擇工作表',
    
    // Google Docs 配置
    googleDocsConfig: 'Google Docs 配置',
    googleDocsUrl: 'Google Docs URL',
    
    // SQL 配置
    sqlConfig: 'SQL 連接配置',
    server: '服務器',
    database: '數據庫',
    username: '用戶名',
    password: '密碼',
    tableName: '表名',
    customQuery: '自定義查詢',
    testConnection: '測試連接',
    loadData: '載入數據',
    sqlPreviewTotalRows: '符合條件的總筆數：{count}',
    sqlPreviewTopNote: '為加快預覽已自動加上 TOP {n}；正式匯入會載入全部符合條件的資料。',
    sqlPreviewWithCteNote: '此查詢含 WITH/CTE，無法自動加 TOP，預覽可能較久。',
    sqlLoadingFullForImport: '正在從 SQL 載入完整資料以執行匯入…',
    sqlFullLoadFailed: '無法載入完整 SQL 資料',
    nextStep: '下一步',
    
    // 字段映射
    dataPreview: '數據預覽',
    fieldMapping: '字段映射',
    selectColumn: '選擇欄位',
    selectGroup: '選擇群組',
    dataSourceType: '數據源類型',
    sheetName: '工作表名稱',
    name: '姓名',
    title: '職稱',
    occupation: '職業',
    position: '職位',
    whatsappNumber: 'WhatsApp 號碼',
    email: '電子郵件',
    companyName: '公司名稱',
    department: '部門',
    hashtags: '標籤',
    broadcastGroup: '廣播群組',
    
    // 匯入過程
    importing: '正在匯入...',
    importSuccess: '匯入成功！',
    successCount: '成功匯入 {count} 筆聯絡人',
    failedCount: '失敗 {count} 筆',
    errors: '錯誤詳情',
    backToList: '返回聯絡人列表',
    importMore: '繼續匯入',
    previous: '上一步',
    startImport: '開始匯入',
    
    // 定時匯入設定
    saveAsSchedule: '保存為定時匯入',
    scheduleNamePlaceholder: '請輸入排程名稱',
    scheduleNameRequired: '請輸入排程名稱',
    everyXMinutes: '每 N 分鐘',
    daily: '每天',
    weekly: '每週',
    scheduleName: '排程名稱',
    manageSchedule: '管理定時匯入',
    scheduleManagement: '聯絡人定時匯入排程',
    executionFrequency: '執行頻率',
    importType: '匯入類型',
    lastExecution: '上次執行',
    nextExecution: '下次執行',
    editSchedule: '編輯排程',
    manualExecute: '手動執行',
    importExecutionProgress: '匯入進度',
    confirmDeleteSchedule: '確定要刪除這個排程嗎？',
    scheduleSaved: '已保存為定時匯入排程！',
    scheduleSavedDesc: '您的匯入已保存為定時任務。您可以在「管理定時匯入」區域中查看和管理。',
    saveScheduleFailed: '保存排程失敗',
    pleaseEnterGoogleSheetsUrl: '請先輸入 Google Sheets URL',
    detectedExcelFile: '檢測到 Excel 文件，將使用默認工作表',
    googleSheetsVerified: 'Google Sheets URL 驗證成功！',
    googleSheetsVerificationFailed: 'Google Sheets URL 驗證失敗：',
    pleaseUploadExcelFile: '請先上傳 Excel 文件',
    urlVerified: 'URL 已驗證',
    fileUploaded: '文件已上傳',
    useDefaultSheet: '系統將自動使用默認工作表進行數據導入，無需選擇工作表名稱。',
    basicSettings: '基本設定',
    loadingPreview: '載入預覽數據中...',
    noPreviewData: '無法載入預覽數據，可以手動編輯字段映射',
    pleaseConnectGoogleSheets: '請先連接 Google Sheets',
    getSheetsList: '請先連接 Google Sheets 獲取工作表列表',
    noMatchingSheet: '沒有找到匹配的工作表',
    scheduleNameExists: '排程名稱已存在，請使用其他名稱',
    
    // 重複確認
    duplicateConfirmation: '重複記錄確認',
    duplicateWarning: '發現重複的 WhatsApp 號碼',
    duplicateDescription: '以下記錄的 WhatsApp 號碼已存在於系統中。如果繼續，將會覆蓋現有記錄。請確認是否要更新這些記錄。',
    confirmUpdate: '確認更新',
    rowNumber: '行號',
    newData: '新數據',
    existingData: '現有數據'
  },

  // 標籤管理
  hashtags: {
    title: '標籤管理',
    description: '管理聯絡人標籤，方便分類和篩選',
    addTag: '新增標籤',
    editTag: '編輯標籤',
    deleteTag: '刪除標籤',
    tagName: '標籤名稱',
    description: '描述',
    color: '顏色',
    usageCount: '使用次數',
    createdAt: '創建時間',
    updatedAt: '更新時間',
    actions: '操作',
    edit: '編輯',
    delete: '刪除',
    confirmDelete: '確認刪除',
    confirmDeleteMessage: '確定要刪除標籤「{name}」嗎？',
    cannotDeleteMessage: '此標籤還有 {count} 位聯絡人使用，無法刪除。',
    cancel: '取消',
    create: '創建',
    update: '更新',
    createSuccess: '標籤已創建',
    updateSuccess: '標籤已更新',
    deleteSuccess: '標籤已刪除',
    createError: '創建標籤失敗',
    updateError: '更新標籤失敗',
    deleteError: '刪除標籤失敗',
    loadError: '載入標籤列表失敗',
    noTagsFound: '沒有找到標籤',
    adjustSearch: '請調整搜尋條件',
    searchPlaceholder: '搜尋標籤...',
    quickSelect: '快速選擇：',
    namePlaceholder: '請輸入標籤名稱',
    descriptionPlaceholder: '請輸入標籤描述',
    nameRequired: '請輸入標籤名稱',
    formValidationFailed: '表單驗證失敗，請檢查必填欄位'
  },
  
  // 語言切換
  language: {
    zhTC: '繁體中文',
    zhSC: '簡體中文', 
    en: 'English',
    language: '語言'
  },
  
  // 用戶偏好設定
  preferences: {
    title: '我的偏好設定',
    basicInfo: '基本資料',
    usageBillingTab: '用量計費',
    avatar: '頭像',
    uploadAvatar: '上傳頭像',
    account: '帳號',
    name: '名稱',
    email: 'Email',
    phone: '電話',
    language: '語言',
    timezone: '時區',
    selectTimezone: '請選擇時區',
    password: '密碼',
    passwordPlaceholder: '如需修改請輸入新密碼',
    isActive: '啟用',
    isOwner: '主帳號',
    save: '儲存',
    cancel: '取消',
    updateSuccess: '個人資料已更新',
    updateFailed: '更新用戶信息失敗',
    avatarUploadSuccess: '頭像上傳成功',
    avatarUploadFailed: '頭像上傳失敗'
  },
  companyUserAdmin: {
    companyName: "公司名稱",
    email: "Email",
    address: "地址",
    phone: "電話",
    website: "網站",
    createdAt: "建立時間",
    updatedAt: "更新時間",
    action: "操作",
    edit: "編輯",
    delete: "刪除",
    name: "名稱",
    account: "帳號",
    isActive: "啟用",
    isOwner: "主帳號",
    active: "啟用",
    inactive: "停用",
    owner: "主",
    addUser: "新增用戶",
    searchUser: "搜尋帳號、Email、名稱...",
    batchEnable: "批量啟用",
    batchDisable: "批量停用",
    timezone: "時區",
    selectTimezone: "請選擇時區",
    language: "語言",
    addCompany: "新增公司",
    platformWabaBadge: "Platform WABA",
    platformWabaTooltip: "此公司為平台 WABA：其 WhatsApp／WABA 相關設定會作為新註冊公司複製設定的來源。",
    roles: "角色",
    selectRoles: "選擇角色",
    roleManagement: "角色管理",
    tenantAdmin: "租戶管理員",
    companyAdmin: "公司管理員",
    designer: "設計師",
    approver: "審批者",
    addRole: "新增角色",
    removeRole: "移除角色",
    noRoles: "無角色",
    currentRoles: "當前角色",
    selectedRoles: "已選角色",
    userInfo: "用戶信息",
    avatar: "頭像",
    status: "狀態",
    isMainAccount: "是否為主帳號",
    enabled: "啟用",
    disabled: "停用",
    yes: "是",
    no: "否",
    editUser: "編輯用戶",
    mainAccountNote: "（在 SaaS 版本中，主帳號是指付款帳號）",
    password: "密碼",
    passwordPlaceholder: "如需修改請輸入新密碼（留空則不修改）",
    confirmPassword: "確認密碼",
    company: "公司",
    selectCompany: "請選擇公司",
    companyRequired: "請選擇公司",
    confirmPasswordPlaceholder: "請再次輸入密碼",
    confirmPasswordRequired: "請再次輸入密碼以確認",
    passwordMismatch: "兩次輸入的密碼不一致",
    passwordMinLength: "密碼長度至少為 6 個字符",
    phoneDuplicate: "手機號碼已存在，請使用其他號碼",
    emailDuplicate: "Email 已存在，請使用其他 Email",
    userCreateSuccess: "用戶信息創建成功",
    userUpdateSuccess: "用戶信息更新成功",
    roleUpdateSuccess: "角色更新成功",
    roleUpdateFailed: "角色更新失敗",
    userCreateSuccessButRoleFailed: "用戶創建成功，但角色設置失敗，請稍後手動設置"
  },
  companyEdit: {
    uploadLogo: "點擊上傳公司頭像",
    basicInfo: "公司基本資料",
    companyId: "公司 ID",
    copyCompanyId: "複製公司 ID",
    companyIdCopied: "公司 ID 已複製到剪貼簿",
    name: "公司名稱",
    nameLocalesHint: "主欄位與 JSON 內 en 同步；繁／簡可選填。",
    nameLocaleZhTc: "公司名稱（繁體）",
    nameLocaleZhSc: "公司名稱（簡體）",
    email: "Email",
    address: "地址",
    phone: "電話",
    website: "網站",
    createdAt: "建立時間",
    updatedAt: "更新時間",
    timezone: "時區",
    timezonePlaceholder: "選擇時區",
    whatsappSetting: "WhatsApp 設定",
    waApiKey: "wA_API_Key",
    waPhoneNoId: "wA_PhoneNo_ID",
    waVerifyToken: "wA_VerifyToken",
    back: "返回",
    save: "儲存",
    cancel: "取消",
    saveSuccess: "儲存成功",
    saveFailed: "儲存失敗",
    uploadSuccess: "上傳成功",
    uploadFailed: "上傳失敗",
    // WhatsApp API 設定
    waBusinessAccountId: "WhatsApp Business Account ID",
    waBusinessAccountIdTooltip: "用於管理 Meta 官方模板",
    waBusinessAccountIdSuffix: "模板管理",
    waMetaBusinessId: "Meta Business ID（商家資產管理組合編號）",
    waMetaBusinessIdPlaceholder: "例如: 1420491162404755",
    waMetaBusinessIdTooltip: "用於目錄管理：建立新目錄、列出 Business 底下所有目錄。可於 Meta 企業管理平台 > 企業設定 > 商家資訊 查看",
    waMetaBusinessIdSuffix: "目錄管理",
    phoneNoIdPlaceholder: "例如: 690383010830837",
    businessAccountIdPlaceholder: "例如: 1102096678464098",
    configWarningTitle: "⚠️ 重要配置提醒",
    configWarningDescription: "請確保 Phone Number ID 屬於 Business Account ID 指定的 WABA：",
    configWarningPhoneIdUse: "• Phone Number ID 用於發送消息（必須屬於正確的 WABA）",
    configWarningBusinessIdUse: "• Business Account ID 用於查詢模板列表",
    configWarningMismatchTitle: "⚠️ 如果這兩個 ID 不匹配，會導致：",
    configWarningMismatchItem1: "能看到模板列表，但發送消息時找不到模板",
    configWarningMismatchItem2: "模板屬於不同的 WABA 而無法使用",
    configWarningSolution: "💡 解決方法：在 Meta Business Suite 中確認 Phone Number ID 屬於哪個 WABA，然後更新 Business Account ID 為該 WABA 的 ID",
    validateTokenButton: "驗證 Token 權限",
    validateTokenHint: "輸入 API Key 和 Business Account ID 後點擊驗證",
    validateTokenLoading: "正在驗證 Token 權限...",
    subscribeWebhookButton: "訂閱 Webhook",
    subscribeWebhookLoading: "正在訂閱 Webhook...",
    subscribeWebhookSuccessTitle: "Webhook 訂閱結果",
    subscribeWebhookSuccess: "Webhook 訂閱成功，Meta 將把通知發送到您的回呼網址。",
    subscribeWebhookErrorTitle: "Webhook 訂閱失敗",
    subscribeWebhookError: "無法訂閱 Webhook，請確認 Access Token、Business Account ID 及權限設定。",
    validateTokenError: "❌ 驗證失敗",
    validateTokenFailed: "❌ 權限檢查失敗",
    validateTokenErrorMsg: "無法驗證 Token 權限，請檢查您的設定",
    validateTokenCheckResult: "🔐 Token 權限檢查結果",
    tokenStatus: "Token 狀態：",
    tokenValid: "✅ 有效",
    tokenInvalid: "❌ 無效",
    companyLabel: "公司：",
    capabilitiesTitle: "功能權限：",
    sendMessageLabel: "發送訊息：",
    available: "✅ 可用",
    unavailable: "❌ 不可用",
    receiveWebhookLabel: "接收 Webhook：",
    manageTemplatesLabel: "管理 Meta 範本：",
    createFlowLabel: "建立 WhatsApp Flow：",
    permissionsTitle: "詳細權限：",
    recommendationsTitle: "建議：",
    permissionCheckFailed: "無法驗證 Token 權限，請檢查您的設定",
    validateTokenPermissionError: "檢查 Token 權限時發生錯誤，請稍後重試",
    validateTokenCheckError: "檢查 Token 權限時發生錯誤，請稍後重試",
    apiKeyRequired: "請先輸入 WA API Key (Access Token)",
    businessAccountIdRequired: "請先輸入 WhatsApp Business Account ID",
    webhookToken: "Webhook Token",
    webhookTokenPlaceholder: "自動生成的唯一 Token",
    regenerateToken: "重新生成",
    tokenGenerated: "新的 Token 已生成，URL 已更新",
    webhookUrl: "Meta Webhook URL",
    webhookUrlPlaceholder: "例如: https://your-domain.com/api/MetaWebhook/your-token",
    copyWebhookUrl: "複製",
    webhookUrlCopied: "Webhook URL 已複製到剪貼簿",
    generateTokenFirst: "請先生成 Webhook Token",
    // WhatsApp 菜單設置
    chatbotMenuConfig: "聊天機器人菜單設置",
    apiSettings: "API 設定",
    menuConfigHint: "這些設定用於自定義 WhatsApp 聊天機器人的菜單文字。留空將使用系統默認值。",
    welcomeMessage: "歡迎訊息",
    welcomeMessageTooltip: "用戶首次使用時顯示的歡迎文字",
    noFunctionMessage: "無功能提示",
    noFunctionMessageTooltip: "當沒有可用工作流程時顯示的訊息",
    menuTitle: "菜單標題",
    menuTitleTooltip: "WhatsApp 列表菜單的標題",
    menuButton: "查看按鈕",
    menuButtonTooltip: "菜單的查看選項按鈕文字",
    menuFooter: "菜單底部文字",
    menuFooterTooltip: "WhatsApp 列表菜單的底部提示",
    sectionTitle: "區段標題",
    sectionTitleTooltip: "服務選項的分類標題",
    defaultOptionDescription: "預設選項描述",
    defaultOptionDescriptionTooltip: "工作流程沒有描述時的預設文字",
    inputErrorMessage: "輸入錯誤提示",
    inputErrorMessageTooltip: "用戶輸入格式錯誤時的提示訊息",
    fallbackMessage: "回退提示",
    fallbackMessageTooltip: "當 WhatsApp 互動式消息失敗時的回退提示",
    systemErrorMessage: "系統錯誤提示",
    systemErrorMessageTooltip: "系統發生錯誤時的一般性提示訊息",
    // Placeholders
    welcomeMessagePlaceholder: "歡迎使用我們的服務！\n\n請選擇您需要的功能：",
    noFunctionMessagePlaceholder: "歡迎使用我們的服務！\n\n目前沒有可用的功能，請聯繫管理員。",
    menuTitlePlaceholder: "服務選單",
    menuButtonPlaceholder: "查看選項",
    menuFooterPlaceholder: "請選擇您需要的服務",
    sectionTitlePlaceholder: "服務選項",
    defaultOptionDescriptionPlaceholder: "點擊選擇此服務",
    inputErrorMessagePlaceholder: "輸入不正確，請重新輸入。",
    fallbackMessagePlaceholder: "\n\n回覆數字選擇功能，或輸入「選單」重新顯示選單。",
    systemErrorMessagePlaceholder: "系統錯誤：無法找到 QR Code 節點配置。",
    // 破冰問題 / 指令
    iceBreakersTab: '破冰問題',
    commandsTab: '指令',
    iceBreakersDesc: '破冰問題是用戶輕鬆詢問你的常見問題，會在首次開啟對話時顯示為可點選的提示。',
    commandsDesc: '指令是可用來指示 WhatsApp Bot 採取動作的特殊關鍵字。你必須在每個關鍵字之前使用「/」。',
    convNotSaved: '請先儲存公司資料後再設定對話元件',
    iceBreakersLabel: '破冰問題 {index}',
    iceBreakersInputPlaceholder: '輸入破冰問題（最多 80 字，不支援 Emoji）',
    addIceBreaker: '新增破冰問題',
    saveIceBreakersSuccess: '破冰問題已儲存至 WhatsApp',
    cmdNameLabel: '指令文字',
    cmdNamePlaceholder: '範例：/imagine、/generate',
    cmdDescLabel: '指令說明',
    cmdDescPlaceholder: '為這個指令新增說明。(範例：產生圖像)',
    addCommand: '新增指令',
    saveCommandsSuccess: '指令已儲存至 WhatsApp',
    convLoadFailed: '載入對話元件失敗',
    convSaveFailed: '儲存失敗',
    delete: "刪除公司",
    deleteTenantAdminOnly: "只有 Tenant_Admin 可以刪除公司",
    deleteConfirmTitle: "刪除公司前請小心確認",
    deleteConfirmOk: "我已備份並確認刪除",
    deleteConfirmCancel: "取消",
    deleteBackupWarningTitle: "此操作可能永久刪除或影響此公司的相關資料",
    deleteBackupWarningDesc: "刪除前請先完成資料庫及檔案備份，並確認不再需要此公司的流程、表單、商務及 WhatsApp 記錄。部分資料表可能因外鍵限制而阻止刪除，系統會回報錯誤。",
    deleteImpactTitle: "可能受影響的資料範圍：",
    deleteImpactUsers: "公司使用者、角色、權限設定",
    deleteImpactWorkflows: "工作流程定義、執行記錄、步驟記錄",
    deleteImpactForms: "電子表單、表單實例、審批、報表及文件輸出",
    deleteImpactDatasets: "DataSet、資料列、匯入排程及處理記錄",
    deleteImpactContacts: "聯絡人、廣播群組、標籤、日曆事件及相關資源",
    deleteImpactWhatsapp: "WhatsApp 模板、訊息、Webhook / Flow 相關設定",
    deleteImpactCommerce: "Commerce 客戶、商品、目錄、訂單、價格卡及 WPA 權限資料",
    deleteImpactAiBilling: "AI 員工、API Provider 設定、用量計費、Wix 開通記錄",
    deleteImpactKnowledge: "知識庫分類、文件及版本",
    deleteTypeCompanyName: "請輸入公司名稱「{name}」以確認刪除。",
    deleteConfirmTextMismatch: "確認文字不正確，已取消刪除",
    deleteFailed: "刪除失敗",
    deleteSuccess: "已刪除"
  },

  // Commerce 客戶主檔
  commerceCustomers: {
    title: '客戶主檔管理',
    addCustomer: '新增客戶',
    editCustomer: '編輯客戶',
    customerNo: '客戶編號',
    branchNo: '分店編號',
    nameCn: '中文名稱',
    nameEn: '英文名稱',
    nameCn1: '中文名稱 1',
    nameCn2: '中文名稱 2',
    nameCn3: '中文名稱 3',
    nameEn1: '英文名稱 1',
    nameEn2: '英文名稱 2',
    nameEn3: '英文名稱 3',
    customerNameCol: '客戶名稱（介面語系）',
    nameLine: '客戶名稱',
    nameLocaleZhTc: '客戶名稱（繁體）',
    nameLocaleZhSc: '客戶名稱（簡體）',
    customerNameLocalesHint: '各行下方可填繁體、簡體；英文以上方欄位為準（對應後端 en）。',
    contactName: '聯絡人',
    tel: '電話',
    fax: '傳真',
    email: '電郵',
    whatsappNo: 'WhatsApp',
    salesmanName: '銷售員',
    salesmanCode: '銷售員代碼',
    salesmanCodePlaceholder: '與 ERP／內部編號核對用',
    salesmanWhatsapp: '銷售員 WhatsApp',
    creditLimit: '信用額度',
    priceType: '價格類型',
    priceTypePlaceholder: '自由輸入',
    paymentTerm: '付款條款',
    paymentTermPlaceholder: 'COD / 30日數期月結 / 60日數期月結 …',
    remark: '備註',
    remarkPlaceholder: '客戶備註',
    customerStatus: '客戶狀態',
    statusActive: '啟用',
    statusSuspended: '暫停',
    statusPending: '待審',
    tabBasic: '基本資料',
    tabAddress: '地址',
    tabDeliverySchedule: '車期設置',
    tabSalesman: '銷售員',
    billingAddressCn: '帳單地址（中文）',
    billingAddressEn: '帳單地址（英文）',
    deliveryAddressCn: '送貨地址（中文）',
    deliveryAddressEn: '送貨地址（英文）',
    addressLine1: '地址行 1',
    addressLine2: '地址行 2',
    addressLine3: '地址行 3',
    deliveryMon: '一',
    deliveryTue: '二',
    deliveryWed: '三',
    deliveryThu: '四',
    deliveryFri: '五',
    deliverySat: '六',
    deliverySun: '日',
    deliveryScheduleHolidayTag: '假',
    deliveryHoliday: '公眾假期送貨',
    importExcel: '匯入 Excel',
    importPreview: '匯入預覽',
    confirmImport: '確認匯入',
    importSuccess: '匯入成功',
    search: '搜尋客戶...',
    deleteConfirm: '確定刪除此客戶？',
    created: '已建立',
    updated: '已更新',
    noData: '尚無客戶資料',
    subtitle: '管理客戶主檔、地址與車期設置',
    loadFailed: '載入客戶資料失敗',
    saved: '客戶已更新',
    saveFailed: '儲存失敗',
    deleted: '客戶已刪除',
    deleteFailed: '刪除失敗',
    importParseFailed: '匯入檔案解析失敗',
    importFailed: '匯入失敗',
    whatsapp: 'WhatsApp',
    actions: '操作',
    edit: '編輯',
    delete: '刪除',
    confirmDelete: '確定刪除此客戶？',
    required: '必填',
    addressLine: '地址行',
    deliveryScheduleHint: '請勾選可送貨日子',
    holidayDelivery: '公眾假期送貨',
    import: '匯入',
    refresh: '重新整理',
    searchPlaceholder: '搜尋客戶編號 / 名稱 / 聯絡人',
    filterByCompany: '按公司篩選',
    company: '公司',
    selectCompany: '請選擇公司',
    cancel: '取消',
    save: '儲存',
  },

  // Commerce 價格表
  commercePriceCards: {
    title: '價格表管理',
    addPriceCard: '新增價格卡',
    editPriceCard: '編輯價格卡',
    customerNo: '客戶編號',
    branchNo: '分店編號',
    itemNo: '產品編號',
    unitPrice: '單價',
    showPrice: '顯示價格',
    validFrom: '生效日期',
    validTo: '結束日期',
    source: '來源',
    priceType: '價格類型',
    priceTypePlaceholder: '自由輸入',
    importCsv: '匯入 CSV',
    importPreview: '匯入預覽',
    confirmImport: '確認匯入',
    importSuccess: '匯入成功',
    deleteConfirm: '確定刪除此價格卡？',
    overlapError: '日期範圍與已有價格卡重疊',
    yes: '是',
    no: '否',
    noData: '尚無價格表資料',
    description: '管理客戶分店商品的價格與生效日期',
    loadFailed: '載入價格表失敗',
    created: '價格卡已新增',
    saved: '價格卡已更新',
    saveFailed: '儲存失敗',
    deleted: '價格卡已刪除',
    deleteFailed: '刪除失敗',
    importEmpty: '沒有可匯入資料',
    importParseFailed: 'CSV 解析失敗',
    importFailed: '匯入失敗',
    actions: '操作',
    edit: '編輯',
    delete: '刪除',
    confirmDelete: '確定刪除此價格卡？',
    refresh: '重新整理',
    filterCustomerNo: '篩選客戶編號',
    filterCustomerName: '篩選客戶名稱（含各語系）',
    filterBranchNo: '篩選分店編號',
    filterItemNo: '篩選商品編號',
    filterByCompany: '按公司篩選',
    company: '公司',
    required: '必填',
    selectCompany: '請選擇公司',
    selectCompanyFirst: '請先選擇公司',
    customerPickerTitle: '選擇客戶',
    customerPickerSearchPlaceholder: '搜尋客戶編號、分店、公司名、聯絡人、電話',
    customerPickerLoadFailed: '載入客戶列表失敗',
    openCustomerList: '查詢',
    chooseCustomer: '選擇',
    productPickerTitle: '選擇商品',
    productPickerSearchPlaceholder: '搜尋 Content ID／品名／說明',
    productPickerLoadFailed: '載入商品列表失敗',
    openProductList: '查詢',
    chooseProduct: '選擇',
    customerName: '客戶名稱',
    productName: '產品名稱',
    productNameColUiLocale: '商品名稱（介面語系）',
    productNameList: '品名',
    productListPrice: '原價（商品標價）',
    pickerNameCn: '公司名稱（中）',
    pickerContactName: '聯絡人',
    pickerContactTel: '電話',
    customerNoPlaceholder: '可手動輸入或從列表選擇',
    branchNoPlaceholder: '選擇客戶後會自動帶入，可再修改',
    importPreviewTitle: '價格卡匯入預覽',
    cancel: '取消',
    save: '儲存',
  },

  // Commerce 銷售訂單
  commerceSalesOrders: {
    title: '銷售訂單管理',
    addOrder: '新增訂單',
    editOrder: '編輯訂單',
    orderNo: '訂單編號',
    orderDate: '訂單日期',
    customerNo: '客戶編號',
    branchNo: '分店編號',
    companyNameCn: '公司名稱（中文）',
    companyNameEn: '公司名稱（英文）',
    billingAddress: '帳單地址',
    deliveryAddress: '送貨地址',
    deliveryDate: '送貨日期',
    contactName: '聯絡人',
    contactTel: '聯絡電話',
    salesmanName: '銷售員',
    purchaseOrderNo: 'PO 號碼',
    paymentTerm: '付款條款',
    paymentTermPlaceholder: 'COD / 30日數期月結 / 60日數期月結 …',
    remark: '備註',
    currency: '幣別',
    totalAmount: '總金額',
    status: '狀態',
    thirdPartyReadStatus: '第三方讀取',
    thirdPartyReadPending: '未處理',
    thirdPartyReadDone: '已讀入',
    source: '來源',
    statusPending: '待處理',
    statusConfirmed: '已確認',
    statusProcessing: '處理中',
    statusCompleted: '已完成',
    statusCancelled: '已取消',
    sourceManual: '手動',
    sourceWhatsapp: 'WhatsApp',
    confirm: '確認',
    complete: '完成',
    cancel: '取消',
    customerInfo: '客戶資訊',
    anonymousOrder: '匿名 WhatsApp 下單',
    waId: 'WhatsApp 號碼',
    remark: '備註',
    deliverySchedule: '車期表',
    orderDetails: '訂單明細',
    seq: '序號',
    itemNo: '產品編號',
    productName: '品名',
    unitPrice: '單價',
    quantity: '數量',
    unit: '單位',
    amount: '金額',
    addLine: '新增明細',
    selectCustomer: '選擇客戶',
    search: '搜尋訂單...',
    deleteConfirm: '確定刪除此訂單？',
    noData: '尚無訂單資料',
    allStatus: '所有狀態',
    deliveryMon: '一',
    deliveryTue: '二',
    deliveryWed: '三',
    deliveryThu: '四',
    deliveryFri: '五',
    deliverySat: '六',
    deliverySun: '日',
    deliveryHoliday: '公眾假期',
    subtitle: '管理銷售訂單 Header / Details',
    loadFailed: '載入訂單失敗',
    loadDetailFailed: '載入訂單詳情失敗',
    customerRequired: '請先選擇客戶',
    created: '訂單已新增',
    saved: '訂單已更新',
    saveFailed: '儲存失敗',
    statusUpdated: '狀態已更新',
    statusUpdateFailed: '更新狀態失敗',
    deleted: '訂單已刪除',
    deleteFailed: '刪除失敗',
    confirmCancel: '確定要取消此訂單？',
    lineRemark: '明細備註',
    confirmDeleteLine: '確定刪除此明細？',
    customer: '客戶',
    companyName: '公司名稱',
    detail: '詳情',
    actions: '操作',
    delete: '刪除',
    confirmDelete: '確定刪除此訂單？',
    refresh: '重新整理',
    searchPlaceholder: '搜尋訂單編號 / 客戶 / 公司',
    filterByStatus: '按狀態篩選',
    filterByCompany: '按公司篩選',
    deliveryDateFrom: '交貨日 由',
    deliveryDateTo: '交貨日 至',
    close: '關閉',
    create: '建立',
    save: '儲存',
    orderDetail: '訂單詳情',
    newOrder: '新建訂單',
    selectCustomerPlaceholder: '請選擇客戶',
    customerPickerTitle: '選擇客戶',
    customerPickerSearchPlaceholder: '搜尋客戶編號、分店、公司名、聯絡人、電話',
    customerPickerLoadFailed: '載入客戶列表失敗',
    openCustomerList: '開啟列表',
    clearCustomer: '清除',
    chooseCustomer: '選擇',
    selectCompanyFirst: '請先選擇公司（租戶管理員）',
    searchProductPlaceholder: '搜尋或選擇商品（Content ID）',
    searchMoreProducts: '搜尋更多…',
    productPickerTitle: '搜尋商品',
    productPickerSearchPlaceholder: '搜尋 Content ID／品名／說明',
    productPickerLoadFailed: '載入商品失敗',
    chooseProduct: '選擇',
    productListPrice: '標價',
    holidayFlag: '公眾假期可送',
    purchaseOrderNoPlaceholder: '輸入 PO 號碼',
    remarkPlaceholder: '輸入備註',
  },

  // Commerce 商品／目錄相關頁面
  commerceCatalogAdmin: {
    title: "Meta 目錄管理（目錄 CRUD）",
    alertInfo: "此頁僅供具備「目錄管理」權限的用戶（如 Tenant_Admin）使用。可建立新目錄、列出 Business 底下所有目錄並選擇連結至目前公司 WABA；已連結的目錄可於下方查看。刪除／取消連結請至 Meta Commerce Manager 操作（API 未提供 unlink/delete）。",
    alertMetaPermission: "Meta 目錄 API 所需權限",
    alertMetaPermissionDesc: "建立目錄、列出 Business 底下目錄需 Meta Access Token 具備：business_management、catalog_management。若出現「Missing Permission」或「Requires business_management permission」，請至 Meta 應用程式後台（App Dashboard）為此應用加入上述權限並重新取得／更新公司設定的 WA API Key（Access Token）。",
    cardCreate: "1. 建立新目錄",
    metaBusinessId: "Meta Business ID",
    catalogName: "目錄名稱",
    catalogNamePlaceholder: "例如：我的商品目錄",
    required: "必填",
    createCatalog: "建立目錄",
    metaBusinessIdHint: "Meta Business ID 可於企業管理平台 > 企業設定 > 帳戶 中查看。",
    cardOwned: "2. Business 底下所有目錄（可選連結至 WABA）",
    inputMetaBusinessId: "輸入 Meta Business ID",
    loadCatalogs: "載入目錄",
    catalogId: "目錄 ID",
    name: "名稱",
    action: "操作",
    linkToWaba: "連結至 WABA",
    emptyOwned: "請輸入 Business ID 並點「載入目錄」，或先於上方建立新目錄。",
    cardLinked: "3. 已連結至目前公司 WABA 的目錄",
    reload: "重新載入",
    emptyLinked: "目前沒有已連結的目錄。若此 WABA 為測試帳號，Meta 可能尚未提供目錄 API；或請先在 Meta 商家資產管理組合中建立並連結目錄。",
    noPermission: "無目錄管理權限",
    loadCatalogsFailed: "載入目錄失敗",
    catalogCreated: "目錄已建立",
    createFailed: "建立失敗",
    catalogIdEmpty: "目錄 ID 為空",
    linkSuccess: "已連結目錄至 WABA",
    linkFailed: "連結失敗",
    wabaMaxOneCatalog: "此 WABA 已連結一個目錄。Meta 規定每個 WhatsApp Business Account 最多只能連結一個商品目錄。若要改連結其他目錄，請先至 Meta Commerce Manager 取消連結現有目錄。",
    unlinkHint: "取消連結目錄須在 Meta 後台操作（公開 API 不提供 unlink）。",
    openMetaCommerceManager: "開啟 Meta Commerce Manager",
    unlinkAction: "前往 Meta 取消連結",
    pleaseEnterMetaBusinessId: "請先輸入 Meta Business ID",
    loadedCount: "已載入 {count} 個目錄"
  },
  commerceCollections: {
    title: "Commerce / Collections",
    description: "管理商品集合，並可把商品關聯到指定 collection。",
    refresh: "重新整理",
    addCollection: "新增集合",
    name: "名稱",
    nameColUiLocale: "集合名稱（介面語系）",
    company: "公司",
    phoneNumberId: "電話號碼 ID",
    filterByCompany: "篩選公司",
    selectCompany: "請選擇公司",
    externalKey: "External Key",
    metaProductSet: "Meta Product Set",
    itemCount: "商品數",
    actions: "操作",
    edit: "編輯",
    linkProducts: "關聯商品",
    sync: "上傳至 Meta",
    delete: "刪除",
    confirmDelete: "確定刪除此集合？",
    editCollection: "編輯集合",
    addCollectionModal: "新增集合",
    collectionName: "集合名稱（英文／主欄）",
    nameLocaleZhTc: "集合名稱（繁體）",
    nameLocaleZhSc: "集合名稱（簡體）",
    nameLocalesHint: "主欄位與 JSON 內 en 同步；繁／簡可選填。",
    description: "描述",
    externalCollectionKey: "External Collection Key",
    metaProductSetId: "Meta Product Set ID",
    metaCatalogId: "Meta Catalog ID",
    selectCatalog: "請選擇目錄（由 Meta API 取得）",
    noCatalog: "無目錄，請確認公司已設定 WABA 與 API Key",
    linkedCatalogDefault: "已連結目錄（預設，WABA 僅能連結一個）",
    noCatalogLinkedHint: "目前公司 WABA 尚未連結目錄，請至「目錄管理」連結。",
    loading: "載入中...",
    linkProductsTitle: "關聯商品：{name}",
    linkProductsHint: "上方為已關聯商品，可移除；下方可搜尋並勾選要新增關聯的商品（不會顯示已關聯項目）。僅列出與此集合相同電話號碼（WABA）的商品。",
    linkProductsLinkedSection: "已關聯商品",
    linkProductsAvailableSection: "可新增關聯",
    linkProductsLinkedEmpty: "尚未關聯任何商品",
    linkProductsRemove: "移除",
    linkProductsSearchPlaceholder: "搜尋名稱、Content ID、描述、品牌、類別…",
    linkProductsSelectedCount: "已選 {n} 項商品",
    selectProducts: "選擇要放入此集合的商品",
    loadFailed: "載入集合資料失敗",
    saved: "集合已更新",
    created: "集合已新增",
    saveFailed: "保存失敗",
    deleted: "集合已刪除",
    deleteFailed: "刪除失敗",
    syncSuccess: "已加入上傳佇列（scheduler_executions）",
    syncFailed: "上傳至 Meta 失敗",
    syncEmptyHint: "此集合尚無關聯商品，請先「關聯商品」加入至少一項後再上傳至 Meta。",
    selectAtLeastOne: "請至少勾選一筆集合",
    batchUploadToMeta: "批量上傳至 Meta",
    batchUploadQueued: "已將 {count}/{total} 筆加入上傳佇列",
    batchUploadQueuedSkipped: "已將 {count}/{total} 筆加入上傳佇列（跳過 {skipped} 筆無商品的集合）",
    loadLinkFailed: "載入關聯商品失敗",
    linkSaved: "商品關聯已更新",
    linkSaveFailed: "保存關聯失敗"
  },
  commerceImport: {
    title: "Commerce 資料交換",
    description: "支援 Excel / Google Sheets / SQL 匯入與銷售訂單匯出。",
    uploadText: "點擊或拖曳檔案到這裡",
    uploadHint: "首行請包含欄位標題；匯入目標公司請在上方選擇（Tenant_Admin）。",
    clear: "清空",
    startImport: "開始匯入",
    loadedRows: "已載入 {count} 筆，缺少必填（name）: {missing} 筆",
    parseSuccess: "已載入 {count} 筆資料",
    parseFailed: "載入失敗",
    pleaseUpload: "請先上載檔案",
    companyRequired: "請選擇匯入目標公司（Tenant_Admin 必選）。",
    rowMissing: "第 {row} 筆缺少必填欄位",
    rowMissingName: "第 {row} 筆缺少名稱",
    rowFailed: "第 {row} 筆失敗",
    importDone: "匯入完成，共 {count} 筆",
    importDoneTitle: "匯入完成",
    importFailed: "匯入失敗",
    importResult: "匯入完成，成功 {success} / 失敗 {failed}",
    importResultDetail: "匯入結果：成功 {success}，失敗 {failed}",
    allSuccess: "全部成功",
    importTarget: "匯入對象",
    company: "公司",
    selectCompany: "選擇公司",
    minutes: "分鐘",
    total: "總計",
    created: "新增",
    updated: "更新",
    added: "新增",
    linked: "關聯",
    skipped: "略過",
    errorsCount: "錯誤",
    errorDetails: "錯誤詳情",
    exportDone: "匯出完成",
    exportFailed: "匯出失敗",
    exportResult: "匯出結果",
    tabImport: "資料匯入",
    tabExport: "銷售訂單匯出",
    domainCommerce: "商務主檔",
    domainWpa: "PWA 權限",
    targetCustomers: "客戶主檔",
    targetPriceCards: "價格表",
    targetProducts: "商品清單",
    targetCollections: "商品集合（主檔）",
    targetCollectionLinks: "集合—商品關聯",
    targetWpaGroupMembers: "PWA 群組成員",
    targetWpaGroupCustomers: "PWA 群組客戶",
    targetWpaContactOverrides: "PWA Contact 覆寫",
    targetWpaIdentities: "PWA 登入帳號",
    stepSource: "選擇來源",
    stepSourceDesc: "設定資料來源",
    stepMapping: "欄位對應",
    stepMappingDesc: "預覽與對應",
    stepResult: "執行結果",
    stepResultDesc: "匯入完成",
    sourceExcel: "Excel 文件",
    sourceGoogle: "Google Sheets",
    sourceSql: "SQL 數據庫",
    exportTitle: "銷售訂單匯出",
    exportModeSplit: "Header + Detail 分開",
    exportModeFlat: "扁平合併",
    exportQuery: "查詢並匯出",
    exportDownloadCsv: "下載 CSV",
    exportAllStatus: "全部",
    exportDateRange: "日期範圍",
    exportMode: "對應模式",
    scheduleTitle: "Commerce 匯入排程管理",
    scheduleName: "排程名稱",
    scheduleTarget: "匯入目標",
    scheduleFrequency: "執行頻率",
    scheduleLastRun: "上次執行",
    scheduleNextRun: "下次執行",
    scheduleEdit: "編輯",
    scheduleEditTitle: "編輯 Commerce 匯入排程",
    schedulePause: "暫停",
    scheduleResume: "啟用",
    scheduleActive: "執行中",
    schedulePaused: "已暫停",
    scheduleResumed: "已啟用",
    scheduleDeleted: "排程已刪除",
    scheduleDeleteFailed: "刪除失敗",
    scheduleDeleteConfirm: "確定刪除此排程？",
    scheduleDelete: "刪除",
    scheduleUpdated: "排程已更新",
    scheduleUpdateFailed: "更新失敗",
    scheduleSaved: "排程已儲存！",
    scheduleSavedDesc: "您的匯入已保存為定時任務，可在排程管理頁面查看。",
    scheduleSaveFailed: "排程儲存失敗",
    scheduleGotoManage: "前往排程管理",
    scheduleLoadFailed: "載入排程列表失敗",
    schedulePreviewFailed: "無法載入預覽",
    schedulePreviewFailedManual: "預覽載入失敗，可手動編輯對應",
    scheduleToggleFailed: "操作失敗",
    scheduleBasicSettings: "基本設定",
    scheduleIntervalLabel: "間隔（分鐘）",
    scheduleEnable: "啟用",
    scheduleSourceConfig: "來源設定",
    scheduleFile: "檔案",
    scheduleSheet: "工作表",
    scheduleStatus: "狀態",
    scheduleActions: "操作",
    scheduleCompany: "公司",
    scheduleExecuteNow: "執行",
    scheduleExecuteSuccess: "已執行匯入",
    importProgress: "匯入進度",
    importRunningBackground: "匯入已在背景執行，請查看進度欄",
    importAlreadyRunning: "此排程匯入正在執行中，請稍候",
    scheduleExecuteFailed: "執行失敗",
    scheduleTotalCount: "共 {count} 筆排程",
    reloadPreview: "重新載入預覽",
    sqlPreviewTotalRows: "符合條件的總筆數：{count}",
    sqlPreviewTopNote: "為加快預覽已自動加上 TOP {n}；正式匯入會載入全部符合條件的資料。",
    sqlPreviewWithCteNote: "此查詢含 WITH/CTE，無法自動加 TOP，預覽可能較久。",
    sqlLoadingFullForImport: "正在從 SQL 載入完整資料以執行匯入…",
    sqlConfigIncomplete: "請填寫伺服器、資料庫，以及表名或自訂查詢至少一項",
    googleSpreadsheetId: "試算表 ID（Spreadsheet ID）",
    googleSpreadsheetIdPlaceholder: "選填；已驗證後可與 URL 並存",
    noPreviewData: "無預覽資料",
    freqEveryNMin: "每 {n} 分鐘",
    wpaAllowPasswordUpdate: "允許更新已存在帳號的密碼",
    fieldCustomerNo: "客戶編號",
    fieldBranchNo: "分店編號",
    fieldCustomerName1: "客戶名稱 1（英文／預設 en）",
    fieldCustomerName2: "客戶名稱 2（英文／預設 en）",
    fieldCustomerName3: "客戶名稱 3（英文／預設 en）",
    fieldCustomerNameLine1ZhTc: "客戶名稱 1 繁體（zh-TC）",
    fieldCustomerNameLine1ZhSc: "客戶名稱 1 簡體（zh-SC）",
    fieldCustomerNameLine2ZhTc: "客戶名稱 2 繁體",
    fieldCustomerNameLine2ZhSc: "客戶名稱 2 簡體",
    fieldCustomerNameLine3ZhTc: "客戶名稱 3 繁體",
    fieldCustomerNameLine3ZhSc: "客戶名稱 3 簡體",
    fieldContactName: "聯絡人",
    fieldTel: "電話",
    fieldEmail: "電郵",
    fieldWhatsappNo: "WhatsApp",
    fieldSalesmanName: "銷售員",
    fieldSalesmanCode: "銷售員代碼（核對用）",
    fieldSalesmanWhatsapp: "銷售員電話 / WhatsApp",
    fieldCreditLimit: "信用額度",
    fieldPriceType: "價格類型（price_type）",
    fieldBillingAddressEn1: "帳單地址（英文）行 1",
    fieldBillingAddressEn2: "帳單地址（英文）行 2",
    fieldBillingAddressEn3: "帳單地址（英文）行 3",
    fieldBillingAddressCn1: "帳單地址（中文）行 1",
    fieldBillingAddressCn2: "帳單地址（中文）行 2",
    fieldBillingAddressCn3: "帳單地址（中文）行 3",
    fieldDeliveryAddressEn1: "送貨地址（英文）行 1",
    fieldDeliveryAddressEn2: "送貨地址（英文）行 2",
    fieldDeliveryAddressEn3: "送貨地址（英文）行 3",
    fieldDeliveryAddressCn1: "送貨地址（中文）行 1",
    fieldDeliveryAddressCn2: "送貨地址（中文）行 2",
    fieldDeliveryAddressCn3: "送貨地址（中文）行 3",
    fieldDeliveryDayMon: "車期：週一可送貨",
    fieldDeliveryDayTue: "車期：週二可送貨",
    fieldDeliveryDayWed: "車期：週三可送貨",
    fieldDeliveryDayThu: "車期：週四可送貨",
    fieldDeliveryDayFri: "車期：週五可送貨",
    fieldDeliveryDaySat: "車期：週六可送貨",
    fieldDeliveryDaySun: "車期：週日可送貨",
    fieldDeliveryDayHoliday: "車期：公眾假期可送貨",
    fieldItemNo: "產品編號",
    fieldUnitPrice: "單價",
    fieldShowPrice: "顯示價格",
    fieldValidFrom: "生效日期",
    fieldValidTo: "結束日期",
    fieldSource: "來源",
    fieldName: "名稱",
    fieldNameLocaleEn: "名稱（英文 JSON en，選填覆寫）",
    fieldNameLocaleZhTc: "名稱（繁體 zh-TC）",
    fieldNameLocaleZhSc: "名稱（簡體 zh-SC）",
    fieldRetailerId: "Content ID (Product ID)",
    fieldDescription: "描述",
    fieldLinkUrl: "連結",
    fieldImageUrl: "圖片 URL",
    fieldBrand: "品牌",
    fieldPrice: "價格",
    fieldProductPrice1: "區間一單價 (price_1)",
    fieldProductValidFrom1: "區間一起日 (valid_from_1)",
    fieldProductValidTo1: "區間一迄日 (valid_to_1)",
    fieldProductPrice2: "區間二單價 (price_2)",
    fieldProductValidFrom2: "區間二起日 (valid_from_2)",
    fieldProductValidTo2: "區間二迄日 (valid_to_2)",
    fieldCurrency: "幣別",
    fieldStatus: "狀態",
    fieldAvailability: "庫存狀態",
    fieldUnitOfMeasure: "數量單位",
    fieldUnitOfMeasureLocaleEn: "數量單位（JSON en 覆寫，選填）",
    fieldUnitOfMeasureLocaleZhTc: "數量單位（繁體中文）",
    fieldUnitOfMeasureLocaleZhSc: "數量單位（簡體中文）",
    fieldUnitOfBrokenPackLocaleEn: "散裝單位（JSON en 覆寫，選填）",
    fieldUnitOfBrokenPackLocaleZhTc: "散裝單位（繁體中文）",
    fieldUnitOfBrokenPackLocaleZhSc: "散裝單位（簡體中文）",
    fieldQtyPerUnit: "每單位數量",
    fieldMinOrderQuantity: "最小訂單數量（MOQ）",
    fieldOqm: "Original Quality Manufacturer（OQM）",
    fieldCondition: "狀況",
    fieldColor: "顏色",
    fieldSize: "尺寸",
    fieldGender: "性別",
    fieldMaterial: "材質",
    fieldPattern: "樣式",
    fieldCustomLabel0: "內容編號",
    fieldProductionCategory: "生產分類",
    fieldMetaCatalogId: "Meta Catalog ID",
    fieldExternalKey: "External Key",
    fieldCollectionKey: "集合 Key",
    fieldGroupName: "群組名稱",
    fieldWhatsappNumber: "WhatsApp 號碼",
    fieldRoleKey: "角色 Key",
    fieldDefaultCustomerNo: "預設客戶編號",
    fieldDefaultBranchNo: "預設分店編號",
    fieldCustomerNos: "可下單客戶（逗號分隔）",
    fieldPhoneNo: "電話號碼",
    fieldDisplayName: "顯示名稱",
    fieldPassword: "密碼",
    hintCustomers: "必填：customerNo。branchNo 預設為 0000。以 customerNo+branchNo 匹配，存在則更新。名稱建議 name1～name3（英文 en）；繁／簡請用 nameLocaleLine1ZhTc、nameLocaleLine1ZhSc 等。選填：salesmanName／salesmanCode（銷售員與代碼，對應 ERP 核對）。價格類型 priceType／price_type 為選填。帳單／送貨地址（英、中各三行）為選填，欄位鍵 billingAddressEn1…deliveryAddressCn3（或 billing_address_en_1 等 snake_case）。車期（週一至日、公眾假期）為選填，可對應 Y/N、1/0、是/否、TRUE/FALSE；更新時未對應欄位則保留原值。",
    hintPriceCards: "必填：customerNo、itemNo、unitPrice。日期範圍有重疊會略過。可選：priceType／price_type（價格類型）。",
    hintProducts: "紅色欄位為必填：name、Content ID (Product ID)（資料欄 productRetailerId；新增必須有值，已存在則更新）。可選：區間一／二單價與起迄日 price1、validFrom1、validTo1、price2…（或 price_1、valid_from_1 等 snake_case）；與主欄 price 並存。可選：最小訂單量 minOrderQuantity（別名如 moq、min_order_quantity）。",
    fieldMappingColumnRequired: "請選擇對應的來源欄位",
    noColumnMapping: "（不對應來源欄）",
    fieldMappingFormIncomplete: "請完成紅色必填欄位對應後再匯入",
    mappingExport: "匯出欄位映射",
    mappingImport: "匯入欄位映射",
    mappingImportSuccess: "欄位映射已成功匯入",
    mappingImportFailed: "匯入失敗，請確認 JSON 格式是否正確",
    hintCollections: "必填：name。若有 externalCollectionKey 且已存在則更新。",
    hintCollectionLinks: "必填：collectionKey、Content ID (Product ID)（productRetailerId）。兩者對應的集合／商品須已存在於系統中。",
    fieldLoginId: "PWA 登入帳號 (loginId)",
    downloadImportTemplate: "下載匯入模版",
    downloadAllImportTemplatesZh: "下載全部模版（中文）",
    downloadAllImportTemplatesEn: "下載全部模版（英文）",
    templateDownloaded: "已下載目前 Master 匯入模版",
    templateAllDownloaded: "已下載全部 Master 匯入模版（含說明工作表）",
    selectImportSheet: "選擇工作表（共 {count} 個分頁）",
    multiSheetPickHint: "此 Excel 含 {count} 個工作表，已自動預選資料分頁，請確認下方「選擇工作表」",
    sqlTenantAdminOnly: "SQL 資料庫匯入僅限 Tenant_Admin 使用",
    templateGoogleSheetsHint: "可下載 Excel 模版，將欄位結構複製到 Google Sheets，或上傳模版後以 Google Sheets 開啟同一檔案。",
    hintWpaGroupMembers: "必填：groupName、loginId（PWA 登入帳號）。群組與帳號須已存在。",
    hintWpaGroupCustomers: "必填：groupName、customerNo。branchNo 預設 0000。",
    hintWpaContactOverrides: "必填：loginId、roleKey。customerNos 可用逗號分隔多筆（格式：編號/分店）。",
    hintWpaIdentities: "必填：loginId（PWA 登入帳號，可沿用 email 欄）。新建時 password 必填；更新密碼需勾選「允許更新密碼」。",
  },
  commerceProducts: {
    title: "Commerce / Products",
    description: "管理商品，並可關聯至 Collection、同步至 Meta。",
    refresh: "重新整理",
    addProduct: "新增商品",
    image: "圖片",
    titleLabel: "標題",
    nameColUiLocale: "商品名稱（介面語系）",
    productName: "商品名稱（英文／主欄）",
    nameLocaleZhTc: "商品名稱（繁體）",
    nameLocaleZhSc: "商品名稱（簡體）",
    nameLocalesHint: "主欄位與 JSON 內 en 同步；繁／簡可選填。",
    description: "描述",
    descriptionPrimary: "描述（英文／主欄）",
    descriptionLocalesHint: "主欄位與 description_locales 內 en 同步；繁／簡可選填。",
    descriptionLocaleZhTc: "描述（繁體）",
    descriptionLocaleZhSc: "描述（簡體）",
    link: "連結",
    company: "公司",
    filterByCompany: "篩選公司",
    filterByCollectionsPlaceholder: "依集合篩選（可多選）",
    phoneNumberId: "電話號碼 ID",
    contentId: "Content ID (Product ID)",
    searchKeywordPlaceholder: "搜尋名稱／描述／Content ID (Product ID)",
    fbCategory: "Facebook 商品類別",
    brand: "品牌",
    contentNumber: "內容編號",
    color: "顏色",
    size: "尺寸",
    gender: "性別",
    price: "價格",
    tabBasic: "基本資料",
    tabSellingPrice: "出售單價",
    sellingPriceTabHint: "至少設定「價格1」或「價格2」一組（含生效起迄，UTC），或僅填帳面價格。PWA／購物車以價格表為優先，無價格表時依此處區間生效價。",
    legacyPrice: "帳面價格（選填，舊資料相容）",
    price1: "價格1",
    validFrom1: "生效起（1）",
    validTo1: "生效迄（1）",
    price2: "價格2",
    validFrom2: "生效起（2）",
    validTo2: "生效迄（2）",
    effectivePriceCol: "生效價（目前）",
    previewEffectiveAtServer: "預覽生效價（伺服器 UTC）",
    status: "狀態",
    availability: "庫存狀態",
    unitOfMeasure: "數量單位",
    unitOfMeasureLocaleZhTc: "數量單位（繁體中文）",
    unitOfMeasureLocaleZhSc: "數量單位（簡體中文）",
    unitOfBrokenPack: "散裝單位",
    unitOfBrokenPackLocaleZhTc: "散裝單位（繁體中文）",
    unitOfBrokenPackLocaleZhSc: "散裝單位（簡體中文）",
    unitOfBrokenPackPlaceholder: "例如：件、包、袋",
    unitOfBrokenPackHint: "拆箱／散賣時使用的單位（非整箱／整包）",
    qtyPerUnit: "每單位數量",
    qtyPerUnitHint: "每一單位含多少件。例如 1 箱 = 12 件，填 12",
    moq: "MOQ（最小訂單量）",
    oqm: "Original Quality Manufacturer（OQM）",
    oqmHint: "選填",
    oqmPlaceholder: "例如：製造商或品質來源",
    unitOfMeasurePlaceholder: "例如：件、箱、公斤",
    condition: "狀況",
    currency: "幣別",
    material: "材質",
    pattern: "樣式",
    actions: "操作",
    edit: "編輯",
    sync: "同步",
    delete: "刪除",
    confirmDelete: "確定刪除此商品？",
    addProductModal: "新增商品",
    editProductModal: "編輯商品",
    loadFailed: "載入商品失敗",
    loadCollectionsFailed: "載入集合列表失敗",
    addToCollection: "加入集合",
    addToCollectionHint: "已選 {count} 項商品，請選擇加入現有集合或建立新集合。",
    addToExistingCollection: "加入現有集合",
    createNewCollection: "建立新集合",
    selectCollection: "選擇集合",
    selectCollectionPlaceholder: "請選擇集合",
    selectCollectionFirst: "請先選擇要加入的集合",
    selectCollectionsFirst: "請至少選擇一個集合",
    addToCollectionSearchPlaceholder: "依名稱、描述、外部鍵、公司搜尋",
    addToCollectionsSelectedCount: "已選 {n} 個集合",
    addToCollectionMixedWaba: "已選商品對應不同的 WhatsApp 號碼（WABA），請只勾選同一組電話號碼 ID 的商品。",
    addToCollectionNoCompatibleCollections: "沒有與已選商品相同 WABA 的集合。可建立新集合，或在集合端綁定相同電話號碼。",
    formBasicSection: "基本資料",
    selectAtLeastOne: "請至少勾選一項商品",
    newCollectionNameRequired: "請輸入新集合名稱",
    newCollectionNamePlaceholder: "輸入新集合名稱",
    newCollectionDescriptionPlaceholder: "選填描述",
    confirmAddToCollection: "確定",
    cancel: "取消",
    drawerClose: "關閉",
    addToCollectionSuccess: "已加入集合",
    addToCollectionFailed: "加入集合失敗",
    saveFailed: "保存失敗",
    saved: "商品已更新",
    created: "商品已新增",
    deleted: "商品已刪除",
    deleteFailed: "刪除失敗",
    syncSuccess: "已寫入同步紀錄（scheduler_executions）",
    syncFailed: "同步失敗",
    uploadToMeta: "上傳至 Meta",
    uploadQueued: "已加入上傳佇列（僅上傳至 Meta，不從 Meta 下載）",
    uploadFailed: "加入上傳佇列失敗",
    batchUploadToMeta: "批量上傳至 Meta",
    batchUploadQueued: "已將 {count}/{total} 筆加入上傳佇列",
    batchUploadFailed: "批量上傳失敗",
    copy: "複製",
    batchCopy: "批量複製",
    copySuccess: "已複製為新商品（名稱已自動加 (1)、(2)...）",
    copyFailed: "複製失敗",
    batchCopySuccess: "已複製 {count}/{total} 筆為新商品",
    batchCopyFailed: "批量複製失敗",
    nameRequired: "名稱不可為空",
    inlineSaveFailed: "行內儲存失敗",
    saveMediaFirst: "請先儲存商品，再上載圖片/影片",
    imageVideoOnly: "只支援圖片或影片檔案",
    imageSizeLimit: "圖片不可超過 8MB",
    videoSizeLimit: "影片不可超過 100MB",
    mediaUploadSuccess: "媒體上載成功",
    uploadFailed: "上載失敗",
    setPrimary: "已設為主圖片",
    setPrimaryFailed: "設定主圖片失敗",
    altUpdated: "alt_text 已更新",
    altUpdateFailed: "更新 alt_text 失敗",
    mediaDeleted: "媒體已刪除",
    reorderFailed: "排序失敗",
    loadMediaFailed: "載入媒體失敗",
    loadCatalogFailed: "載入 Meta 目錄列表失敗",
    selectCategory: "選擇分類",
    noCategory: "沒有分類，請先同步",
    save: "儲存",
    inlineEdit: "行內編輯",
    detail: "詳細",
    media: "圖片/影片",
    metaProductId: "Meta Product ID",
    customLabel0Label: "內容編號（custom_label_0）",
    linkUrlPlaceholder: "https://...",
    mediaFormHint: "改用附圖管理 UI（主圖會自動同步到列表顯示）。",
    openMediaManager: "打開附圖 / 影片管理",
    productImage: "產品圖片",
    productImageUploadHint: "點擊上載或管理",
    creatingProductForMedia: "正在建立商品...",
    mediaModalTitle: "圖片 / 影片管理",
    mediaModalHint: "圖片大小不可超過 8MB；影片不可超過 100MB。可設定主圖片與排序。",
    mediaUploadDragText: "拖放檔案或點擊上載",
    mediaUploadHint: "支援 image/video，盡量重現 Meta 商品媒體管理流程",
    mediaTypeImage: "圖片",
    mediaTypeVideo: "影片",
    mediaTagPrimary: "主圖",
    batchUploadProgress: "批次上載進度",
    retry: "重試",
    copyImageUrl: "複製完整網址",
    copyImageUrlSuccess: "已複製完整網址（Base URL + 路徑）",
    metaAttributes: "Meta 屬性",
    productType: "product_type",
    loadingMedia: "載入媒體中...",
    noMediaUploaded: "尚未上載媒體",
    altTextPlaceholder: "alt_text",
    saveAlt: "儲存 alt",
    primaryImage: "主圖片",
    confirmDeleteMedia: "確定刪除此媒體？",
    taxonomySyncSuccess: "{provider} 分類已同步：{count} 筆",
    taxonomySyncFailed: "同步 {provider} 分類失敗",
    syncFacebookTaxonomy: "同步 Facebook 分類",
    linkedCatalogDefault: "已連結目錄（預設，WABA 僅能連結一個）",
    noCatalogLinkedHint: "目前公司 WABA 尚未連結目錄，請至「目錄管理」連結。",
    linkRequired: "必填（Meta/WhatsApp 顯示商品需填寫連結）",
    priceRequired: "必填（Meta/WhatsApp 顯示商品需填寫價格）",
    metaRequiredHint: "Meta / WhatsApp 顯示商品需填寫「連結」與「價格」，未填會出現「缺少商品連結」「缺少價格」等錯誤。",
    collectionsSection: "所屬集合",
    productCollectionsLabel: "所屬集合（一對多）",
    productCollectionsTooltip: "選擇此商品所屬的集合，可選多個；儲存時將同步更新各集合的商品關聯",
    productCollectionsPlaceholder: "選擇集合...",
    noCollectionFound: "無集合"
  },

  commerceWpaHomePromotions: {
    title: 'PWA 首頁廣告',
    selectCompany: '選擇公司',
    refresh: '重新整理',
    add: '新增',
    loadFailed: '載入失敗',
    saveOk: '已儲存',
    saveFailed: '儲存失敗',
    deleteConfirm: '確定刪除此則廣告？',
    deleteOk: '已刪除',
    deleteFailed: '刪除失敗',
    colSort: '排序',
    colBanner: '橫幅',
    colFullscreen: '全螢幕',
    colProduct: '連結商品',
    colActive: '啟用',
    colSchedule: '檔期',
    colActions: '操作',
    yes: '是',
    no: '否',
    create: '新增廣告',
    edit: '編輯廣告',
    sortOrder: '排序（數字越小越前）',
    active: '啟用',
    validFrom: '檔期開始（選填）',
    validTo: '檔期結束（選填）',
    bannerPath: '橫幅圖路徑',
    fullscreenPath: '全螢幕圖路徑',
    uploadBanner: '建議 16:10（例如 1920×1200），PWA 以寬度全滿顯示',
    uploadFullscreen: '建議 9:16（例如 1080×1920），注意底部安全區',
    uploadBannerBtn: '上傳橫幅',
    uploadFullscreenBtn: '上傳全螢幕圖',
    uploadOk: '上傳成功',
    linkedProduct: '連結商品（選填）',
    searchProduct: '輸入關鍵字搜尋商品',
    noLinkedProduct: '未選擇商品',
    pickProductBtn: '選擇商品',
    pickProductTitle: '選擇連結商品',
    clearLinkedProduct: '清除',
    productSearchPlaceholder: '搜尋名稱、編號或說明',
    filterBrand: '品牌（含文字）',
    pickerOk: '確定',
    pickerCancel: '取消',
    pickerNeedSelect: '請選擇一筆商品',
    sizeHintTitle: '圖檔建議',
    sizeHintBody: '橫幅：16:10（如 1920×1200）。全螢幕：9:16（如 1080×1920）；重要內容勿貼邊，底部預留給按鈕。',
  },
  
  // EForm 相關
  eform: {
    title: "電子表單管理",
    name: "名稱",
    description: "描述",
    formType: "表單類型",
    status: "狀態",
    createdAt: "建立時間",
    updatedAt: "更新時間",
    action: "操作",
    edit: "編輯",
    delete: "刪除",
    add: "新增表單",
    search: "搜尋",
    searchPlaceholder: "搜尋表單名稱、描述...",
    enabled: "啟用",
    disabled: "停用",
    deleted: "刪除",
    confirmDeleteTitle: "確定要刪除這個表單嗎？",
    confirmDeleteContent: "此操作無法撤銷",
    confirmDeleteOk: "確定",
    confirmDeleteCancel: "取消",
    deleteSuccess: "刪除成功",
    deleteFailed: "刪除失敗",
    saveSuccess: "儲存成功",
    saveFailed: "儲存失敗",
    batchDeleteTitle: "批量刪除",
    batchDeleteContent: "確定要刪除選中的 {count} 個表單嗎？",
    batchDeleteSuccess: "批量刪除成功",
    batchDeleteFailed: "批量刪除失敗",
    batchEnableTitle: "批量啟用",
    batchEnableContent: "確定要啟用選中的 {count} 個表單嗎？",
    batchEnableSuccess: "批量啟用成功",
    batchDisableTitle: "批量停用",
    batchDisableContent: "確定要停用選中的 {count} 個表單嗎？",
    batchDisableSuccess: "批量停用成功",
    noData: "暫無資料",
    loading: "載入中...",
    totalRecords: "總記錄數",
    currentPageRecords: "當前頁記錄數",
    pleaseSelectForms: "請選擇要操作的表單",
    cannotGetCompanyInfo: "無法獲取用戶的公司信息",
    updateFailed: "更新失敗",
    createFailed: "創建失敗",
    eformUpdateSuccess: "表單更新成功",
    eformCreateSuccess: "表單創建成功",
    batchEnable: "批量啟用",
    batchDisable: "批量停用",
    batchDelete: "批量刪除",
    refresh: "刷新",
    eformManagement: "表單管理",
    searchNameDescription: "搜尋名稱、描述...",
    clearFilter: "清除篩選",
    pageRange: "第 ",
    total: " 項，共 ",
    batchDeleteForms: "批量刪除表單",
    cancel: "取消",
    confirmDelete: "確定刪除",
    forms: " 個表單",
    batchDeleteWarning: "批量刪除警告",
    batchDeleteWarningContent: "您即將刪除 ",
    cannotBeUndone: " 個表單，此操作無法撤銷。請確認要刪除的表單。",
    pleaseConfirm: "請確認要刪除的表單",
    batchEnableForms: "批量啟用表單",
    batchDisableForms: "批量停用表單",
    confirm: "確定",
    enable: "啟用",
    disable: "停用",
    confirmStatusChangeTitle: "確認更改狀態",
    confirmStatusChangeContent: "確定要將表單「{name}」的狀態更改為「{action}」嗎？",
    statusChangeSuccess: "狀態更改成功",
    statusChangeFailed: "狀態更改失敗",
    batchStatusContent: "您即將",
    enableAfter: " 個表單。啟用後表單將可以正常使用。",
    disableAfter: " 個表單。停用後表單將無法使用，但可以重新啟用。",
    unknownError: "未知錯誤",
    batchStatusSuccess: "成功",
    batchStatusFailed: "批量操作失敗",
    copy: "複製",
    copyForm: "複製表單",
    copyFormInfo: "複製表單信息",
    copyFormContent: "您即將複製表單",
    copyFormContent2: "，複製後將創建一個新的表單副本。",
    newFormName: "新表單名稱",
    newFormDescription: "新表單描述",
    pleaseEnterFormName: "請輸入表單名稱",
    formNameTooLong: "表單名稱不能超過100個字符",
    enterNewFormName: "請輸入新表單名稱",
    enterNewFormDescription: "請輸入新表單描述（可選）",
    copySuccess: "複製成功",
    copyFailed: "複製失敗"
  },
  
  // EForm Designer 相關
  eformDesigner: {
    title: "表單設計器",
    formInfo: "表單信息",
    formName: "表單名稱",
    formDescription: "表單描述",
    formNamePlaceholder: "請輸入表單名稱",
    formDescriptionPlaceholder: "請輸入表單描述",
    save: "儲存",
    back: "返回",
    preview: "預覽",
    code: "程式碼",
    form: "表單",
    edit: "編輯",
    upload: "上傳",
    generate: "生成",
    toolbar: "工具列",
    collapse: "收合",
    expand: "展開",
    wordUpload: "Word 文件上傳",
    excelUpload: "Excel 文件上傳",
    pdfUpload: "PDF 文件上傳",
    imageUpload: "圖片上傳",
    uploadFormImage: "上傳表單圖片（可選）",
    uploadFormDocumentOptional: "上傳 Word/Excel/PDF（可選）",
    clickOrDragDocHere: "點擊或拖拽 Word/Excel/PDF 到此處",
    documentConvertedToHtmlForAi: "將依系統設定以 LibreOffice 轉為 HTML 或 FODG（Flat ODF XML）供 AI 辨識欄位，與圖片一併分析可得到更準確表單",
    uploadWordExcelPdfOnly: "僅支援 Word (.doc/.docx)、Excel (.xls/.xlsx)、PDF (.pdf)",
    documentSizeLimit: "文件大小不能超過 50MB",
    remove: "移除",
    aiGenerate: "AI 生成",
    aiGenerateForm: "AI 生成表單",
    tabBasicInfo: "基本資訊",
    tabFileUpload: "文件上傳",
    tabAIAssistant: "AI 表單助理",
    aiPrompt: "AI 提示詞",
    includeCurrentHtml: "包含當前 HTML",
    aiProvider: "AI 提供商",
    aiProviderPlaceholder: "選擇要使用的 AI 提供商",
    aiProviderRequired: "請選擇一個 AI 提供商",
    loadAiProvidersFailed: "無法載入 AI 提供商，請稍後再試",
    sendDefaultSystemPrompt: "傳送系統預設 prompt",
    modifySystemPrompt: "修改系統預設 prompt",
    loadDefaultPromptFailed: "無法載入預設系統 prompt",
    loadingDefaultPrompt: "載入預設中...",
    systemPromptPlaceholder: "系統預設 prompt（可編輯）",
    aiFormAssistant: "AI 表單助理",
    chatEmptyHint: "輸入需求或上傳圖片/文件，AI 將協助生成或修改表單",
    chatSaveFailed: "對話紀錄儲存失敗",
    chatSaveHintNewForm: "儲存表單後，對話紀錄將寫入",
    restoreToThisVersion: "還原到此版本",
    restoredToThisVersion: "已還原到此版本",
    uploadedImage: "已上傳圖片",
    uploadImage: "圖片",
    uploadDoc: "Word/PDF",
    aiFormUpdatedSuccess: "已根據您的要求更新表單",
    advancedOptions: "進階選項",
    formStyle: "表單風格",
    formStyleUi: "操作式 UI",
    formStylePrint: "可打印文件",
    formStylePrintHint: "適合上傳圖片/PDF/Word，盡量 1:1 還原原始文件版面",
    pleaseUploadImage: "請上傳圖片文件",
    imageSizeLimit: "圖片大小不能超過 10MB",
    uploadSuccess: "上傳成功",
    uploadFailed: "上傳失敗",
    generateSuccess: "生成成功",
    generateFailed: "生成失敗",
    saveSuccess: "儲存成功",
    saveFailed: "儲存失敗",
    nameRequired: "請輸入表單名稱",
    descriptionRequired: "請輸入表單描述",
    welcomeMessage: "歡迎使用表單設計器",
    
    // Component Editor translations
    editComponent: "編輯組件",
    componentId: "組件 ID",
    editDropdownMenu: "編輯下拉選單",
    editTextInput: "編輯文字輸入框",
    editTextArea: "編輯文字區域",
    editButton: "編輯按鈕",
    editRadioButton: "編輯單選按鈕",
    editCheckbox: "編輯複選框",
    editLabel: "編輯標籤",
    fieldName: "欄位名稱",
    fieldNamePlaceholder: "請輸入欄位名稱",
    placeholderText: "佔位符文字",
    placeholderTextPlaceholder: "請輸入佔位符文字",
    optionList: "選項列表",
    optionValue: "選項值",
    optionText: "選項文字",
    delete: "刪除",
    addOption: "+ 添加選項",
    requiredField: "必填欄位",
    disabled: "禁用",
    readonly: "只讀",
    buttonText: "按鈕文字",
    buttonTextPlaceholder: "請輸入按鈕文字",
    buttonType: "按鈕類型",
    buttonStyle: "按鈕樣式",
    buttonSize: "按鈕大小",
    generalButton: "一般按鈕",
    submitButton: "提交按鈕",
    resetButton: "重置按鈕",
    primaryButton: "主要按鈕",
    secondaryButton: "次要按鈕",
    successButton: "成功按鈕",
    dangerButton: "危險按鈕",
    warningButton: "警告按鈕",
    infoButton: "信息按鈕",
    lightButton: "淺色按鈕",
    darkButton: "深色按鈕",
    smallSize: "小尺寸",
    mediumSize: "中尺寸",
    largeSize: "大尺寸",
    labelText: "標籤文字",
    labelTextPlaceholder: "請輸入標籤文字",
    defaultValue: "預設值",
    defaultValuePlaceholder: "請輸入預設值",
    rows: "行數",
    columns: "列數",
    cols: "列數",
    maxLength: "最大長度",
    minLength: "最小長度",
    inputType: "輸入類型",
    text: "文字",
    email: "電子郵件",
    password: "密碼",
    number: "數字",
    currency: "金額",
    tel: "電話",
    url: "網址",
    date: "日期",
    time: "時間",
    datetime: "日期時間",
    dateFormat: "日期格式",
    dateFormatPlaceholder: "選擇日期格式",
    checkboxText: "複選框文字",
    checkboxTextPlaceholder: "請輸入複選框文字",
    welcomeDescription: "請從左側面板拖拽組件到此處開始設計您的表單。",
    exampleInput: "示例輸入框",
    exampleInputPlaceholder: "請輸入內容...",
    
    // Additional translations for editor components
    pleaseEnterPlaceholderText: '請輸入佔位符文字',
    pleaseEnterFieldName: '請輸入欄位名稱',
    pleaseEnterDefaultValue: '請輸入預設值',
    pleaseEnterDefaultDate: '請輸入預設日期',
    pleaseEnterButtonText: '請輸入按鈕文字',
    pleaseEnterLabelText: '請輸入標籤文字',
    pleaseEnterAssociatedFieldId: '請輸入關聯欄位的 ID',
    associatedField: '關聯欄位',
    labelStyle: '標籤樣式',
    fontSize: '字體大小',
    requiredLabel: '必填標示',
    
    // Label style options
    normal: '一般',
    bold: '粗體',
    italic: '斜體',
    underline: '底線',
    
    // Font size options
    small12px: '小 (12px)',
    medium14px: '中 (14px)',
    large16px: '大 (16px)',
    extraLarge18px: '特大 (18px)',
    
    // Date format options and descriptions
    dateFormatDescription: '選擇日期在表單中顯示的格式，這將影響用戶看到的日期樣式',
    selectedFormat: '選擇的格式: {format}',
    formatPreview: '格式預覽: {preview}',
    tip: '提示: 格式設置會影響 WYSIWYG 編輯器中的顯示效果',
    pleaseEnterDefaultValueAccordingToDateFormat: '請根據選擇的日期格式輸入預設值，例如: {example}',
    
    // GrapesJS component default content
    pleaseEnterYourMessage: '請輸入您的訊息',
    pleaseSelect: '請選擇...',
    option1: '選項 1',
    option2: '選項 2',
    option3: '選項 3',
    pleaseEnterEmail: '請輸入電子郵件',
    pleaseEnterPassword: '請輸入密碼',
    pleaseEnterNumber: '請輸入數字',
    pleaseEnterCurrencyAmount: '請輸入金額',
    pleaseEnterUrl: '請輸入網址',
    pleaseEnterPhoneNumber: '請輸入電話號碼',
    
    // Table Cell Editor translations
    editTableCell: '編輯表格單元格',
    editTableHeader: '編輯表格標題',
    cellContent: '單元格內容',
    pleaseEnterCellContent: '請輸入單元格內容...',

    // Text Block (文字元素) Editor
    editTextBlock: '編輯文字',
    textContent: '文字內容',
    pleaseEnterTextContent: '請輸入文字內容',
    textAlign: '對齊方式',
    textAlignLeft: '靠左',
    textAlignCenter: '置中',
    textAlignRight: '靠右',
    textAlignJustify: '左右對齊',
    fontFamily: '字體',
    fontStyle: '字體樣式',
    boldItalic: '粗體+斜體',
    fontSize20px: '20px',
    fontSize24px: '24px',
    
    // Image Editor translations
    editImage: '編輯圖片',
    imageUrl: '圖片 URL',
    pleaseEnterImageUrl: '請輸入圖片 URL',
    imageUploadHint: '點擊上傳按鈕選擇圖片文件，或直接在 URL 欄位輸入圖片地址',
    altText: '替代文字',
    pleaseEnterAltText: '請輸入替代文字',
    imageWidth: '圖片寬度',
    pleaseEnterWidth: '請輸入寬度（如：100px 或 50%）',
    imageWidthHint: '可輸入像素值（如：100px）或百分比（如：50%）',
    imageHeight: '圖片高度',
    pleaseEnterHeight: '請輸入高度（如：100px 或 50%）',
    imageHeightHint: '可輸入像素值（如：100px）或百分比（如：50%）',
    imagePreview: '圖片預覽',
    uploadImage: '上傳圖片',
    labelText: '標籤文字',
    groupTitle: '群組標題',
    groupInputField: '群組內輸入框',
    unknown: '未知',
    exampleInputPlaceholder: "請輸入...",
    dragComponentsHere: "請從左側面板拖拽組件到此處開始設計您的表單。",
    newForm: "新表單",
    pleaseDragComponents: "請從左側面板拖拽組件到此處開始設計您的表單。",
    exampleInputLabel: "示例輸入框",
    pleaseEnter: "請輸入...",
    grapesJsInitializationFailed: "GrapesJS 編輯器初始化失敗，請檢查控制台錯誤信息",
    wordFileConvertedSuccess: "Word 文件已成功轉換！",
    formCreatedFromWord: "從 Word 創建的表單",
    conversionFailed: "轉換失敗: ",
    unknownError: "未知錯誤",
    requestTimeoutWordFileConversion: "請求超時，Word 文件轉換需要較長時間，請稍後再試或檢查網絡連接",
    requestTimeoutPleaseTryAgain: "請求超時，請稍後再試",
    uploadFailed: "上傳失敗: ",
    excelFileConvertedSuccess: "Excel 文件已成功轉換！",
    formCreatedFromExcel: "從 Excel 創建的表單",
    requestTimeoutExcelFileConversion: "請求超時，Excel 文件轉換需要較長時間，請稍後再試或檢查網絡連接",
    pdfFileConvertedSuccess: "PDF 文件已成功轉換！",
    formCreatedFromPdf: "從 PDF 創建的表單",
    requestTimeoutPdfFileConversion: "請求超時，PDF 文件轉換需要較長時間，請稍後再試或檢查網絡連接",
    imageUploadSuccess: "圖片已成功上傳！",
    requestTimeoutImageUpload: "請求超時，圖片上傳需要較長時間，請稍後再試或檢查網絡連接",
    pleaseEnterYourRequirements: "請輸入您的需求描述",
    aiFormGeneratedSuccess: "AI 已成功生成表單！",
    aiGeneratedForm: "AI 生成的表單",
    generationFailed: "生成失敗: ",
    requestTimeoutAiGeneration: "請求超時，AI 生成需要較長時間，請稍後再試或檢查網絡連接",
    pleaseWriteFormContent: "請先編寫表單內容",
    pleaseEnterFormName: "請輸入表單名稱",
    formSavedSuccessfully: "表單已成功保存",
    formSavedToLocalStorage: "表單已保存到本地存儲",
    saveFailed: "保存失敗: ",
    expandToolbar: "展開工具欄",
    saving: "保存中...",
    saveDesign: "儲存設計",
    aiGenerateForm: "AI 生成表單",
    createFromWordFile: "從 Word 文件創建",
    createFromExcelFile: "從 Excel 文件創建",
    createFromPdfFile: "從 PDF 文件創建",
    uploadImage: "上傳圖片",
    uploadFile: "文件上傳",
    exportImport: "匯出 / 匯入",
    exportHtml: "匯出 HTML",
    importHtml: "匯入 HTML",
    exportSuccess: "已匯出 HTML 檔案",
    importSuccess: "已匯入 HTML",
    importFailed: "匯入失敗",
    collapseToolbar: "收合工具欄",
    createFormFromWordFile: "從 Word 文件創建表單",
    wordFileConversion: "Word 文件轉換",
    uploadWordFileDescription: "上傳 Word 文件 (.doc, .docx)，系統會自動轉換為 HTML 格式並載入到編輯器中。支持文字、表格、圖片等內容。",
    converting: "正在轉換...",
    clickOrDragWordFileHere: "點擊或拖拽 Word 文件到此處",
    supportsDocAndDocxFormats: "支持 .doc 和 .docx 格式，文件大小不超過 50MB",
    processingWordFile: "正在處理 Word 文件，請稍候...",
    createFormFromExcelFile: "從 Excel 文件創建表單",
    excelFileConversion: "Excel 文件轉換",
    uploadExcelFileDescription: "上傳 Excel 文件 (.xls, .xlsx)，系統會自動轉換為 HTML 格式並載入到編輯器中。支持表格、圖表等內容。",
    clickOrDragExcelFileHere: "點擊或拖拽 Excel 文件到此處",
    supportsXlsAndXlsxFormats: "支持 .xls 和 .xlsx 格式，文件大小不超過 50MB",
    processingExcelFile: "正在處理 Excel 文件，請稍候...",
    createFormFromPdfFile: "從 PDF 文件創建表單",
    pdfFileConversion: "PDF 文件轉換",
    uploadPdfFileDescription: "上傳 PDF 文件 (.pdf)，系統會自動轉換為 HTML 格式並載入到編輯器中。支持文字、圖片等內容。",
    clickOrDragPdfFileHere: "點擊或拖拽 PDF 文件到此處",
    supportsPdfFormat: "支持 .pdf 格式，文件大小不超過 50MB",
    processingPdfFile: "正在處理 PDF 文件，請稍候...",
    imageUpload: "圖片上傳",
    uploadImageDescription: "上傳圖片文件，系統會自動將圖片插入到編輯器中。支持 JPG、PNG、GIF 等格式。",
    uploading: "正在上傳...",
    clickOrDragImageHere: "點擊或拖拽圖片到此處",
    supportsJpgPngGifBmpWebpFormats: "支持 JPG、PNG、GIF、BMP、WebP 格式，文件大小不超過 10MB",
    uploadingImage: "正在上傳圖片，請稍候...",
    aiSmartGeneration: "AI 智能生成",
    describeTheFormTypeAndRequirements: "描述您需要的表單類型和要求，AI 將為您生成相應的 HTML 表單。適合用於審批流程、申請表單等。",
    cancel: "取消",
    generating: "生成中...",
    generateForm: "生成表單",
    requirementsDescription: "需求描述",
    placeholderExample: "例如：我需要一個請假申請表單，包含員工信息、請假類型、開始日期、結束日期、請假原因等欄位...",
    exampleRequirementsDescription: "例如：我需要一個請假申請表單，包含員工信息、請假類型、開始日期、結束日期、請假原因等欄位...",
    basedOnCurrentContentModified: "將基於當前內容修改",
    generatingNewForm: "將生成全新表單",
    aiWillModifyAndOptimizeBasedOnYourCurrentFormContent: "AI 將基於您當前的表單內容進行修改和優化。當前內容長度",
    characters: "字符",
    aiWillGenerateANewFormBasedOnYourDescription: "AI 將根據您的描述生成全新的表單，不會使用當前編輯器中的內容",
    aiGeneratingForm: "AI 正在生成表單，請稍候...",
    loadingGrapesJsEditor: "正在載入 GrapesJS 編輯器...",
    editorType: "編輯器類型",
    container: "容器",
    ready: "已準備",
    notReady: "未準備",
    pleaseTryAgainLaterOrCheckNetworkConnection: "請稍後再試或檢查網絡連接",
    
    // GrapesJS 編輯器界面元素翻譯
    grapesJs: {
      // 左側 Blocks 面板
      blocks: "組件",
      layout: "佈局",
      basic: "基本",
      forms: "表單",
      section: "區塊",
      div: "分區",
      container: "容器",
      text: "文字",
      heading: "標題",
      paragraph: "段落",
      form: "表單",
      input: "輸入框",
      button: "按鈕",
      textarea: "文字區域",
      select: "下拉選單",
      radio: "單選框",
      checkbox: "複選框",
      fileUpload: "檔案上傳",
      email: "電子郵件",
      password: "密碼",
      number: "數字",
      date: "日期",
      time: "時間",
      url: "網址",
      tel: "電話",
      label: "標籤",
      fieldset: "欄位群組",
      
      // 右側面板
      layers: "圖層",
      styles: "樣式",
      traits: "屬性",
      settings: "設定",
      tableConfig: "表格設置",
      selectParentTable: "選中整個表格",
      tableColWidths: "列寬設置:",
      tableColWidthValue: "寬度（留空為自動）",
      tableColWidthUnit: "單位",
      tableColLabel: "列",
      tableColWidthAuto: "自動",
      
      // 工具列
      viewCode: "查看程式碼",
      preview: "預覽",
      fullscreen: "全螢幕",
      undo: "復原",
      redo: "重做",
      clear: "清除",
      export: "匯出",
      import: "匯入",
      
      // 屬性面板
      id: "ID",
      class: "CSS 類別",
      style: "樣式",
      attributes: "屬性",
      content: "內容",
      placeholder: "預設文字",
      required: "必填",
      disabled: "停用",
      readonly: "唯讀",
      maxlength: "最大長度",
      minlength: "最小長度",
      pattern: "格式",
      title: "標題",
      alt: "替代文字",
      src: "來源",
      href: "連結",
      target: "目標",
      rel: "關聯",
      
      // 樣式面板
      dimensions: "尺寸",
      positioning: "定位",
      typography: "字體",
      background: "背景",
      border: "邊框",
      effects: "效果",
      extra: "其他",
      
      // 通用
      width: "寬度",
      height: "高度",
      margin: "外邊距",
      padding: "內邊距",
      borderWidth: "邊框寬度",
      borderStyle: "邊框樣式",
      borderColor: "邊框顏色",
      borderRadius: "圓角",
      borderCollapse: "邊框合併",
      backgroundColor: "背景顏色",
      color: "文字顏色",
      fontSize: "字體大小",
      fontWeight: "字體粗細",
      fontFamily: "字體",
      textAlign: "文字對齊",
      lineHeight: "行高",
      letterSpacing: "字距",
      textDecoration: "文字裝飾",
      opacity: "透明度",
      boxShadow: "陰影",
      transform: "變形",
      
      // 提示訊息
      dragToAdd: "拖拽到此處新增",
      clickToEdit: "點擊編輯",
      doubleClickToEdit: "雙擊編輯",
      selectComponent: "選擇組件",
      deleteComponent: "刪除組件",
      copyComponent: "複製組件",
      pasteComponent: "貼上組件",
      moveUp: "上移",
      moveDown: "下移",
      moveLeft: "左移",
      moveRight: "右移",
      
      // 編輯提示
      editTip: "請點擊組件上方的編輯按鈕來修改此輸入框的屬性。",
      deselectTip: "按 ESC 鍵或點擊空白區域取消選中",
      
      // 設備視圖
      device: "設備",
      desktop: "桌面",
      tablet: "平板",
      mobileLandscape: "手機橫向",
      mobilePortrait: "手機直向",
      
      // 工具列提示
      viewComponents: "查看組件",
      preview: "預覽",
      fullscreen: "全螢幕",
      viewCode: "查看程式碼",
      
      // 樣式面板詳細
      classes: "類別",
      general: "通用",
      display: "顯示",
      float: "浮動",
      position: "定位",
      top: "上",
      right: "右",
      left: "左",
      bottom: "下",
      none: "無",
      block: "區塊",
      inline: "行內",
      inlineBlock: "行內區塊",
      flex: "彈性",
      grid: "網格",
      static: "靜態",
      relative: "相對",
      absolute: "絕對",
      fixed: "固定",
      auto: "自動",
      
      // 狀態和選擇
      state: "狀態",
      selected: "已選中",
      componentSet: "組件集合",
      
      // 其他界面元素
      add: "新增",
      remove: "移除",
      close: "關閉",
      open: "開啟",
      expand: "展開",
      collapse: "收合",
      refresh: "重新整理",
      loading: "載入中...",
      error: "錯誤",
      success: "成功",
      warning: "警告",
      info: "資訊"
    },
    
    // 上傳相關翻譯
    upload: {
      authTokenNotFound: "未找到認證 token，請重新登入"
    },
    
    // 字段顯示設定相關翻譯
    fieldDisplaySetting: {
      modalTitle: "表單字段顯示設定",
      tableColumns: {
        fieldType: "字段類型",
        originalLabel: "原始標籤",
        displayLabel: "顯示標籤",
        showInList: "在列表中顯示",
        fieldId: "字段ID",
        actions: "操作"
      },
      placeholders: {
        displayLabel: "輸入顯示標籤",
        jsonKey: "輸入 JSON Key"
      },
      actions: {
        moveUp: "上移",
        moveDown: "下移",
        addJsonRow: "新增 JSON 子列",
        convertToJson: "轉為 JSON 模式",
        removeJsonRow: "移除 JSON 子列"
      },
      buttons: {
        cancel: "取消",
        confirm: "確定"
      },
      helperText: "系統已自動掃描表單中的所有輸入字段，您可以自定義顯示標籤、調整順序，並選擇是否在列表中顯示。對 JSON 類型欄位可加入多個 JSON Key 子列。",
      helperTextNoJson: "系統已自動掃描表單中的所有輸入字段，您可以自定義顯示標籤、調整順序，並選擇是否在列表中顯示。",
      messages: {
        saveSuccess: "字段顯示設定已保存",
        saveFailed: "保存失敗: ",
        unnamedField: "未命名字段",
        noFieldsFound: "未找到表單字段"
      }
    }
  },
  
  // EForm Instance 相關
  eformInstance: {
    title: "表單實例",
    status: "狀態",
    submittedAt: "提交時間",
    approvedAt: "核准時間",
    rejectedAt: "拒絕時間",
    approvedBy: "核准人",
    rejectedBy: "拒絕人",
    approvalNote: "核准備註",
    rejectNote: "拒絕備註",
    approve: "核准",
    reject: "拒絕",
    back: "返回",
    loading: "載入中...",
    error: "錯誤",
    noData: "暫無資料",
    pending: "待處理",
    approved: "已核准",
    rejected: "已拒絕",
    confirmApprove: "確定要核准這個表單嗎？",
    confirmReject: "確定要拒絕這個表單嗎？",
    approveSuccess: "核准成功",
    rejectSuccess: "拒絕成功",
    approveFailed: "核准失敗",
    rejectFailed: "拒絕失敗",
    noteRequired: "請輸入備註",
    loginRequired: "請先登入",
    loginExpired: "登入已過期，請重新登入",
    fetchFailed: "獲取表單實例失敗",
    formApproved: "表單已批准",
    formRejected: "表單已拒絕",
    pendingApproval: "待審批",
    formInstanceNotFound: "找不到表單實例",
    formInfo: "表單信息",
    instanceName: "實例名稱",
    createdAt: "創建時間",
    userInput: "用戶輸入",
    approver: "審批人",
    approvalTime: "審批時間",
    formContent: "表單內容",
    approveForm: "批准表單",
    cancel: "取消",
    confirmApprove: "確定批准",
    confirmApproveForm: "您確定要批准這個表單嗎？",
    approvalNotePlaceholder: "審批備註（可選）",
    rejectForm: "拒絕表單",
    confirmReject: "確定拒絕",
    confirmRejectForm: "您確定要拒絕這個表單嗎？",
    rejectReasonPlaceholder: "拒絕原因（可選）",
    rejectionReasonRequired: "請輸入拒絕原因",
    receivedMedia: "已接收的媒體"
  },

  eformValidation: {
    pleaseFillRequiredFields: "請填寫所有必填欄位",
    pleaseFillField: "請填寫「{field}」",
    pleaseUploadField: "請上傳「{field}」",
    pleaseCheckField: "請勾選「{field}」",
    pleaseSelectField: "請選擇「{field}」"
  },
  
  // WhatsApp Template 相關
  whatsappTemplate: {
    title: "訊息模版管理",
    name: "名稱",
    description: "描述",
    category: "分類",
    status: "狀態",
    type: "類型",
    createdAt: "建立時間",
    updatedAt: "更新時間",
    action: "操作",
    add: "新增模板",
    edit: "編輯",
    delete: "刪除",
    copy: "複製",
    preview: "預覽",
    import: "導入",
    search: "搜尋",
    searchPlaceholder: "搜尋模板名稱、描述...",
    enabled: "啟用",
    disabled: "停用",
    draft: "草稿",
    text: "文字",
    image: "圖片",
    video: "影片",
    audio: "音訊",
    document: "文件",
    location: "位置",
    contact: "聯絡人",
    interactive: "互動式",
    button: "按鈕",
    list: "清單",
    confirmDeleteTitle: "確定要刪除這個模板嗎？",
    confirmDeleteContent: "此操作無法撤銷",
    confirmDelete: "確定",
    confirmDeleteOk: "確定",
    confirmDeleteCancel: "取消",
    deleteSuccess: "刪除成功",
    deleteFailed: "刪除失敗",
    copySuccess: "複製成功",
    copyFailed: "複製失敗",
    saveSuccess: "儲存成功",
    saveFailed: "儲存失敗",
    importSuccess: "導入成功",
    importFailed: "導入失敗",
    batchDeleteTitle: "批量刪除",
    batchDeleteContent: "確定要刪除選中的 {count} 個模板嗎？",
    batchDeleteSuccess: "批量刪除成功",
    batchDeleteFailed: "批量刪除失敗",
    noData: "暫無資料",
    loading: "載入中...",
    totalRecords: "總記錄數",
    currentPageRecords: "當前頁記錄數",
    messageContent: "訊息內容",
    mediaUrl: "媒體網址",
    caption: "標題",
    latitude: "緯度",
    longitude: "經度",
    address: "地址",
    phoneNumber: "電話號碼",
    displayName: "顯示名稱",
    buttonText: "按鈕文字",
    buttonType: "按鈕類型",
    listTitle: "清單標題",
    listDescription: "清單描述",
    listItems: "清單項目",
    variables: "變數",
    addVariable: "新增變數",
    variableName: "變數名稱",
    variableValue: "變數值",
    removeVariable: "移除變數",
    metaTemplates: "Meta 模板",
    importFromMeta: "從 Meta 導入",
    createMetaTemplate: "建立 Meta 模板",
    deleteMetaTemplate: "刪除 Meta 模板",
    metaTemplateName: "Meta 模板名稱",
    metaTemplateCategory: "Meta 模板分類",
    customName: "自訂名稱",
    filterAll: "全部",
    filterEnabled: "啟用",
    filterDisabled: "停用",
    templateName: "模板名稱",
    templateDescription: "模板描述",
    templateType: "模板類型",
    templateStatus: "模板狀態",
    templateLanguage: "模板語言",
    templateVersion: "模板版本",
    templateUpdateTime: "模板更新時間",
    templateOperation: "模板操作",
    templatePreview: "模板預覽",
    templateEdit: "模板編輯",
    templateCopy: "模板複製",
    templateDelete: "模板刪除",
    templateDeleteMeta: "刪除 Meta 模板",
    templateDeleteConfirm: "確定要從 Meta 刪除這個模板嗎？",
    templateDeleteConfirmLocal: "確定要刪除這個模板嗎？",
    templateConfirm: "確定",
    templateCancel: "取消",
    templateBatchDelete: "批量刪除",
    templateBatchDeleteConfirm: "確定要刪除選中的 {count} 個模板嗎？此操作無法撤銷。",
    templateBatchDeleteConfirmCount: "確定要刪除選中的",
    templateBatchDeleteConfirmSuffix: "個模板嗎？此操作無法撤銷。",
    templateBatchDeleteOk: "確定刪除",
    templateBatchDeleteCancel: "取消",
    templateAdd: "新增模板",
    templateEditTitle: "編輯模板",
    templateAddTitle: "新增模板",
    templateSave: "保存",
    templateCancel: "取消",
    templateNameRequired: "請輸入模板名稱",
    templateNamePlaceholder: "請輸入模板名稱",
    templateDescriptionPlaceholder: "請輸入模板描述",
    templateCategoryRequired: "請選擇分類",
    templateCategoryPlaceholder: "請選擇分類",
    templateTypeRequired: "請選擇模板類型",
    templateTypePlaceholder: "請選擇模板類型",
    templateStatusRequired: "請選擇狀態",
    templateStatusPlaceholder: "請選擇狀態",
    templateLanguageRequired: "請選擇語言",
    templateLanguagePlaceholder: "請選擇語言",
    language: "語言",
    templateMessageContent: "訊息內容",
    templateMessageContentRequired: "請輸入訊息內容",
    templateMessageContentPlaceholder: "請輸入訊息內容，可使用 {{變數名}} 格式插入變數",
    templateMediaType: "媒體類型",
    templateMediaTypeRequired: "請選擇媒體類型",
    templateMediaUrl: "媒體檔案 URL",
    templateMediaUrlRequired: "請輸入媒體檔案 URL",
    templateMediaUrlPlaceholder: "請輸入媒體檔案 URL",
    templateMediaCaption: "媒體說明",
    templateMediaCaptionPlaceholder: "請輸入媒體說明（可選）",
    templateInteractiveType: "互動類型",
    templateInteractiveTypeRequired: "請選擇互動類型",
    templateHeader: "標題",
    templateHeaderPlaceholder: "請輸入標題（可選）",
    templateBody: "主要內容",
    templateBodyRequired: "請輸入主要內容",
    templateBodyPlaceholder: "請輸入主要內容",
    templateFooter: "底部文字",
    templateFooterPlaceholder: "請輸入底部文字（可選）",
    templateLatitude: "緯度",
    templateLatitudeRequired: "請輸入緯度",
    templateLatitudePlaceholder: "請輸入緯度",
    templateLongitude: "經度",
    templateLongitudeRequired: "請輸入經度",
    templateLongitudePlaceholder: "請輸入經度",
    templateLocationName: "位置名稱",
    templateLocationNameRequired: "請輸入位置名稱",
    templateLocationNamePlaceholder: "請輸入位置名稱",
    templateLocationAddress: "地址",
    templateLocationAddressRequired: "請輸入地址",
    templateLocationAddressPlaceholder: "請輸入完整地址",
    templateContactName: "聯絡人姓名",
    templateContactNameRequired: "請輸入聯絡人姓名",
    templateContactNamePlaceholder: "請輸入聯絡人姓名",
    templateContactPhone: "聯絡人電話",
    templateContactPhoneRequired: "請輸入聯絡人電話",
    templateContactPhonePlaceholder: "請輸入聯絡人電話",
    templateContactEmail: "聯絡人 Email",
    templateContactEmailPlaceholder: "請輸入聯絡人 Email（可選）",
    templateVariables: "變數設定",
    templateVariableName: "變數名稱",
    templateVariableNamePlaceholder: "變數名稱",
    templateVariableType: "類型",
    templateVariableTypePlaceholder: "類型",
    templateVariableDescription: "描述",
    templateVariableDescriptionPlaceholder: "描述",
    templateVariableRequired: "必填",
    templateAddVariable: "添加變數",
    
    // 模板變數配置相關
    addTemplateVariable: "添加模板變數",
    parameterName: "參數名稱",
    variableSource: "變數來源",
    processVariable: "流程資料",
    datasetField: "數據集欄位",
    selectVariable: "選擇變數",
    availableVariables: "可用變數",
    processVariables: "流程資料",
    datasetFields: "數據集欄位",
    metaTemplateVariableHint: "Meta 模板變數配置",
    metaTemplateVariableDescription: "Meta 官方模板使用數字參數 (1, 2, 3...) 或命名參數。請根據模板定義配置對應的變數來源。",
    metaParameterHint: "Meta 模板參數：使用數字 (1, 2, 3...) 或變數名 (customer_name, order_id)",
    templateFromMetaImport: "從 Meta 導入",
    templateBatchDelete: "批量刪除",
    templateWhatsAppMessageTemplateManagement: "WhatsApp 訊息模板管理",
    
    // 複製相關翻譯
    templateCopySuccess: "模板複製成功",
    templateCopyFailed: "模板複製失敗",
    templateCopying: "正在複製模板...",
    templateSearchPlaceholder: "搜索模板名稱、描述或分類",
    templateCategorySelect: "選擇分類",
    templateStatusSelect: "選擇狀態",
    templateClearFilter: "清除篩選",
    templatePageRange: "第",
    templatePageTotal: "項，共",
    templatePageItems: "項",
    templateBasicInfo: "基本信息",
    templateContent: "模板內容",
    templateVariableDefinition: "變數定義",
    templateWelcome: "歡迎",
    templateOrder: "訂單",
    templateMarketing: "行銷",
    templateSupport: "客服",
    templateGeneral: "一般",
    templateMedia: "媒體",
    templateInteractive: "互動",
    templateLocation: "位置",
    templateContact: "聯絡人",
    templateActive: "啟用",
    templateInactive: "停用",
    templateDraft: "草稿",
    templateTraditionalChinese: "繁體中文",
    templateSimplifiedChinese: "簡體中文",
    templateEnglish: "English",
    templateString: "文字",
    templateNumber: "數字",
    templateDate: "日期",
    templateID: "ID",
    templateRefreshMetaTemplates: "刷新 Meta 模板",
    templateImportFromMeta: "從 Meta 導入模板",
    templateImport: "導入",
    templateGetMetaTemplatesFailed: "獲取 Meta 模板失敗",
    templateImportSuccess: "模板導入成功",
    templateImportFailed: "導入失敗",
    templateCreateMetaTemplateSuccess: "Meta 模板創建成功",
    templateCreateFailed: "創建失敗",
    templateDeleteMetaTemplateSuccess: "Meta 模板刪除成功",
    templateDeleteFailed: "刪除失敗",
    templateGetTemplateListFailed: "獲取模板列表失敗",
    templatePleaseSelectTemplates: "請選擇要刪除的模板",
    templateSuccessDelete: "成功刪除",
    templateTemplates: "個模板",
    templateDeleteSuccess: "模板刪除成功",
    templateUpdateSuccess: "模板更新成功",
    templateUpdateFailed: "更新失敗",
    templateCreateSuccess: "模板創建成功",
    templateCreateFailed: "創建失敗",
    templateSaveFailed: "保存模板失敗",
    templateParseContentFailed: "解析模板內容失敗",
    templateConfirmDeleteSelected: "確定要刪除選中的",
    templateConfirmDeleteSelectedSuffix: "個模板嗎？此操作無法撤銷。",
    confirm: "確定",
    cancel: "取消",
    statusSelect: "選擇狀態",
    enabled: "啟用",
    disabled: "停用",
    draft: "草稿",
    traditionalChinese: "繁體中文",
    simplifiedChinese: "簡體中文",
    english: "English",
    welcome: "歡迎",
    order: "訂單",
    marketing: "行銷",
    support: "客服",
    general: "一般",
    save: "保存",
    addTitle: "新增模板",
    editTitle: "編輯模板",
    nameRequired: "請輸入模板名稱",
    namePlaceholder: "請輸入模板名稱",
    descriptionPlaceholder: "請輸入模板描述（可選）",
    categoryRequired: "請選擇分類",
    categoryPlaceholder: "請選擇分類",
    typeRequired: "請選擇模板類型",
    typePlaceholder: "請選擇模板類型",
    statusRequired: "請選擇狀態",
    statusPlaceholder: "請選擇狀態",
    languageRequired: "請選擇語言",
    languagePlaceholder: "請選擇語言",
    text: "文字",
    media: "媒體",
    interactive: "互動",
    location: "位置",
    contact: "聯絡人",
    basicInfo: "基本信息",
    content: "模板內容",
    variableDefinition: "變數定義",
    templateName: "模板名稱",
    templateDescription: "模板描述",
    templateType: "模板類型",
    templateStatus: "模板狀態",
    templateLanguage: "模板語言",
    templateVersion: "模板版本",
    templateUpdateTime: "模板更新時間",
    templateOperation: "模板操作",
    searchPlaceholder: "搜索模板名稱、描述...",
    categorySelect: "選擇分類",
    batchDeleteTitle: "批量刪除",
    templateGetTemplateListFailed: "獲取模板列表失敗",
    templatePleaseSelectTemplates: "請選擇要刪除的模板",
    templateSuccessDelete: "成功刪除",
    templateTemplates: "個模板",
    templateDeleteFailed: "刪除失敗",
    templateDeleteSuccess: "刪除成功",
    templateUpdateSuccess: "更新成功",
    templateUpdateFailed: "更新失敗",
    templateCreateSuccess: "創建成功",
    templateCreateFailed: "創建失敗",
    templateSaveFailed: "保存失敗",
    templateParseContentFailed: "解析模板內容失敗",
    templateDeleteConfirmLocal: "確定要刪除這個模板嗎？",
    preview: "預覽",
    edit: "編輯",
    copy: "複製",
    delete: "刪除",
    category: "分類",
    type: "類型",
    status: "狀態",
    updatedAt: "更新時間",
    action: "操作",
    add: "新增",
    title: "訊息模版管理",
    templateLanguage: "模板語言",
    templateVersion: "模板版本",
    
    // 地圖相關翻譯
    mapSelection: "地圖選擇",
    searchAddressOrDragMarker: "搜索地址或拖拽標記到合適位置",
    enterAddressToSearch: "輸入地址或地名進行搜索",
    search: "搜索",
    getCurrentLocation: "獲取當前位置",
    advancedSearch: "高級搜索",
    latitude: "緯度",
    longitude: "經度",
    locationName: "位置名稱",
    address: "地址",
    pleaseEnterLatitude: "請輸入緯度",
    pleaseEnterLongitude: "請輸入經度",
    pleaseEnterLocationName: "請輸入位置名稱",
    pleaseEnterAddress: "請輸入地址",
    pleaseEnterCompleteAddress: "請輸入完整地址",
    variables: "變數設定",
    addVariable: "添加變數",
    searchAddress: "搜索地址",
    selectThisLocation: "選擇此位置",
    
    // 訊息類型相關翻譯
    messageContent: "訊息內容",
    pleaseEnterMessageContent: "請輸入訊息內容",
    pleaseEnterMessageContentWithVariables: "請輸入訊息內容，可使用 {{變數名}} 格式插入變數",
    mediaType: "媒體類型",
    pleaseSelectMediaType: "請選擇媒體類型",
    image: "圖片",
    video: "影片",
    audio: "音訊",
    document: "文件",
    mediaFileUrl: "媒體檔案 URL",
    pleaseEnterMediaFileUrl: "請輸入媒體檔案 URL",
    mediaCaption: "媒體說明",
    pleaseEnterMediaCaption: "請輸入媒體說明（可選）",
    interactiveType: "互動類型",
    pleaseSelectInteractiveType: "請選擇互動類型",
    button: "按鈕",
    list: "選單",
    product: "商品",
    header: "標題",
    pleaseEnterHeader: "請輸入標題（可選）",
    mainContent: "主要內容",
    pleaseEnterMainContent: "請輸入主要內容",
    footer: "底部文字",
    pleaseEnterFooter: "請輸入底部文字（可選）",
    contactName: "聯絡人姓名",
    pleaseEnterContactName: "請輸入聯絡人姓名",
    contactPhone: "聯絡人電話",
    pleaseEnterContactPhone: "請輸入聯絡人電話",
    contactEmail: "聯絡人 Email",
    pleaseEnterContactEmail: "請輸入聯絡人 Email（可選）",
    
    // 變數相關翻譯
    variableName: "變數名稱",
    type: "類型",
    description: "描述",
    required: "必填",
    text: "文字",
    number: "數字",
    date: "日期",
    
    // 缺少的翻譯鍵
    languageRequired: "請選擇語言",
    languagePlaceholder: "請選擇語言",
    traditionalChinese: "繁體中文",
    simplifiedChinese: "簡體中文",
    english: "English",
    pleaseEnterMessageContent: "請輸入訊息內容",
    pleaseEnterMessageContentWithVariables: "請輸入訊息內容，可使用 {{變數名}} 格式插入變數",
    pleaseSelectMediaType: "請選擇媒體類型",
    pleaseEnterMediaFileUrl: "請輸入媒體檔案 URL",
    pleaseEnterMediaCaption: "請輸入媒體說明（可選）",
    pleaseSelectInteractiveType: "請選擇互動類型",
    pleaseEnterHeader: "請輸入標題（可選）",
    pleaseEnterMainContent: "請輸入主要內容",
    pleaseEnterFooter: "請輸入底部文字（可選）",
    pleaseEnterLatitude: "請輸入緯度",
    pleaseEnterLongitude: "請輸入經度",
    pleaseEnterLocationName: "請輸入位置名稱",
    pleaseEnterAddress: "請輸入地址",
    pleaseEnterCompleteAddress: "請輸入完整地址",
    pleaseEnterContactName: "請輸入聯絡人姓名",
    pleaseEnterContactPhone: "請輸入聯絡人電話",
    pleaseEnterContactEmail: "請輸入聯絡人 Email（可選）",
    searchAddress: "搜索地址",
    selectThisLocation: "選擇此位置",
    
    // Meta 模板相關翻譯
    metaTemplate: {
      // 按鈕和操作
      createMetaTemplate: "創建 Meta 模板",
      preview: "預覽",
      edit: "編輯",
      delete: "刪除",
      editTitle: "編輯 Meta 模板",
      update: "更新",
      updating: "更新中...",
      updateSuccess: "Meta 模板已更新並重新提交審核",
      updateFailed: "更新失敗",
      confirm: "確定",
      cancel: "取消",
      insert: "插入",
      search: "搜索",
      refresh: "刷新",
      clearFilter: "清空篩選",
      submit: "提交到 Meta 審核",
      
      // 格式化按鈕提示
      boldTooltip: "粗體 (*文字*)",
      italicTooltip: "斜體 (_文字_)",
      strikethroughTooltip: "刪除線 (~文字~)",
      codeTooltip: "代碼 (```文字```)",
      insertVariableTooltip: "插入變數",
      
      // 表單標籤
      templateName: "模板名稱",
      category: "類別",
      language: "語言",
      headerOptional: "媒體範例 · 選填",
      headerNone: "無",
      headerText: "文字",
      headerImage: "圖像",
      headerVideo: "影片",
      headerDocument: "文件",
      headerLocation: "位置（GPS）",
      locationHeaderHelp: "僅限 UTILITY / MARKETING。可不填座標僅建立範本；若填寫審核範例，請同時填緯度與經度。名稱與地址選填。",
      locationLatitude: "緯度",
      locationLongitude: "經度",
      locationName: "地點名稱",
      locationAddress: "地址",
      locationLatitudePlaceholder: "例如：25.0330",
      locationLongitudePlaceholder: "例如：121.5654",
      locationNamePlaceholder: "例如：台北 101",
      locationAddressPlaceholder: "選填，完整地址",
      locationCoordsIncomplete: "若填寫位置範例，請同時填寫緯度與經度，或全部留空。",
      locationLatitudeInvalid: "緯度須為 -90～90 之間的數字。",
      locationLongitudeInvalid: "經度須為 -180～180 之間的數字。",
      locationOpenMap: "在地圖中開啟",
      locationPreviewHint: "建立範本後若曾儲存範例座標，預覽會顯示於此。",
      locationSearchPlaceholder: "搜尋地點或地址…",
      locationSearch: "搜尋",
      locationMapHint: "地圖來源：OpenStreetMap（免費）。點擊地圖選點，或拖曳圖釘微調；亦可搜尋後自動帶入約略名稱與地址。",
      bodyContent: "正文內容",
      footerOptional: "頁腳 (可選)",
      
      // 表單提示和幫助
      templateNameHelp: "只能使用小寫字母、數字和下劃線。建立時系統會自動在名稱後加上「_」與公司識別碼（12 位十六進位），合計最長 200 字元，故基底名稱請勿超過 187 字元。",
      templateNameMaxBase: "基底名稱最多 187 個字元（建立時會自動加上後綴）",
      templateNamePlaceholder: "例如：welcome_message",
      categoryPlaceholder: "選擇模板類別",
      languagePlaceholder: "選擇語言",
      headerPlaceholder: "例如：重要通知",
      dragOrClickToUpload: "拖放檔案即可上載，或從你的裝置選擇檔案",
      imageUploadHint: "支援 JPG、PNG、GIF、BMP、WEBP 格式",
      videoUploadHint: "支援 MP4、AVI、MOV、WMV 格式",
      documentUploadHint: "支援 PDF、DOC、DOCX、TXT 格式",
      orEnterUrl: "或輸入檔案 URL",
      urlHelp: "如果檔案已上傳到其他地方，可以直接輸入 URL",
      enterFileUrl: "請輸入檔案 URL（例如：https://example.com/image.jpg）",
      fileUploadInDevelopment: "檔案上傳功能開發中，請先使用 URL 方式",
      pleaseUploadFileOrUrl: "請上傳檔案或提供檔案 URL",
      dataUrlNotSupported: "Meta API 不接受 data URL (base64) 格式，請使用實際的 HTTP/HTTPS URL",
      urlMustBeHttp: "URL 必須是 HTTP 或 HTTPS 協議",
      invalidUrlFormat: "URL 格式無效",
      uploadingFile: "正在上傳檔案...",
      fileUploadFailed: "檔案上傳失敗",
      localhostNotAccessible: "警告：Meta API 無法訪問 localhost 或本地 IP 地址。請使用公開可訪問的 URL，或將檔案上傳到公開服務器。",
      bodyPlaceholder: "例如：您的訂單 {{1}} 已確認\n金額：*${{2}}*\n預計送達：_{{3}}_",
      bodyHelp: "支持格式：*粗體* _斜體_ ~刪除線~ ```代碼```",
      footerPlaceholder: "例如：感謝您的使用",
      
      // 狀態選項
      approved: "已通過",
      pending: "審核中",
      rejected: "已拒絕",
      paused: "已暫停",
      
      // 類別選項
      marketing: "營銷",
      utility: "實用",
      authentication: "驗證",
      marketingFull: "營銷 (MARKETING)",
      utilityFull: "實用 (UTILITY)",
      authenticationFull: "驗證 (AUTHENTICATION)",
      
      // 語言選項
      traditionalChinese: "繁體中文",
      simplifiedChinese: "簡體中文",
      english: "英文",
      
      // 操作確認
      deleteConfirmTitle: "確定要刪除此 Meta 模板嗎？",
      deleteConfirmDescription: "此操作將從 Meta 平台永久刪除該模板",
      
      // 按鈕類型
      quickReply: "快速回覆",
      url: "網址",
      phoneNumber: "電話",
      
      // 變數相關
      addVariable: "新增變數",
      insertVariable: "插入變數",
      variableType: "變數類型",
      numberVariable: "數字變數",
      nameVariable: "命名變數",
      recommended: "推薦",
      variableName: "變數名稱",
      variableNamePlaceholder: "例如：customer_name, order_id, amount",
      variableNameHelp: "建議使用小寫英文字母和下劃線，例如：customer_name",
      autoNumberHelp: "系統會自動找到下一個可用編號並插入",
      
      // 標題和描述
      createTitle: "創建 Meta 模板",
      previewTitle: "模板預覽",
      insertVariableTitle: "插入變數",
      basicInfo: "基本信息",
      contentComponents: "內容組件",
      buttonsOptional: "按鈕 (可選)",
      
      // 分類說明
      categoryDescription: "類別說明（Meta 會根據內容自動調整）：",
      marketingDescription: "促銷、優惠、新品推薦、歡迎訊息",
      utilityDescription: "訂單確認、發貨通知、帳戶更新、預約提醒",
      authenticationDescription: "僅用於 OTP 驗證碼",
      utilityWarning: "內容必須是交易性通知，不能含促銷語言，否則會被改為 MARKETING",
      
      // 格式化說明
      formatHelp: "WhatsApp 格式化語法：",
      formatExamples: "• *文字* = 粗體 • _文字_ = 斜體 • ~文字~ = 刪除線 • ```文字``` = 等寬字體",
      variableHelp: "使用 新增變數 按鈕插入 {{1}} {{2}} 等變數",
      
      // 按鈕配置
      buttonText: "按鈕文字",
      buttonTextPlaceholder: "按鈕文字",
      buttonType: "按鈕類型",
      urlPlaceholder: "https://example.com",
      phonePlaceholder: "+852 1234 5678",
      addButton: "添加按鈕",
      buttonCount: "添加按鈕 ({count}/3)",
      
      // 變數示例
      variableExamples: "變數示例：",
      variableExampleLabel: "變數 {{{index}}} 的示例值",
      variableExamplePlaceholder: "例如：張三、12345 等",
      
      // 搜索和篩選
      searchPlaceholder: "搜索模板名稱",
      selectStatus: "選擇狀態",
      selectCategory: "選擇類別",
      selectLanguage: "選擇語言",
      query: "查詢",
      
      // 提示卡片
      metaOfficialTemplates: "Meta 官方模板：",
      metaDescription: "需要提交到 Meta 審核，審核通過後才能使用。",
      applicableScenarios: "適用場景：",
      applicableScenariosDesc: "主動發送營銷活動、訂單通知、客戶服務訊息",
      sessionWindow: "24 小時會話窗口限制：",
      withinWindowLabel: "窗口內",
      withinWindow: "（客戶最後訊息起 24 小時內）：可發送任何訊息（模板或自由格式）",
      outsideWindowLabel: "窗口外",
      outsideWindow: "（超過 24 小時）：只能發送已審核通過的模板訊息",
      tip: "提示：",
      tipDescription: "建議為常用場景預先創建並審核模板，以便隨時主動聯絡客戶",
      
      // 狀態標籤
      statusApproved: "已通過",
      statusPending: "審核中",
      statusRejected: "已拒絕",
      statusPaused: "已暫停",
      
      // 語言標籤
      langTraditionalChinese: "繁體中文",
      langSimplifiedChinese: "簡體中文",
      langEnglish: "英文",
      
      // 類別標籤
      categoryMarketing: "營銷",
      categoryUtility: "實用",
      categoryAuthentication: "驗證",
      
      // 基本信息
      basicInfoTitle: "基本信息",
      templateContent: "模板內容",
      
      // 操作結果
      submitSuccess: "Meta 模板已提交審核！",
      submitFailed: "提交失敗",
      deleteSuccess: "Meta 模板已刪除",
      deleteFailed: "刪除失敗",
      loading: "正在提交到 Meta 審核...",
      deleting: "正在刪除...",
      
      // 表單驗證
      nameRequired: "請輸入模板名稱",
      namePattern: "只能使用小寫字母、數字和下劃線",
      categoryRequired: "請選擇類別",
      languageRequired: "請選擇語言",
      bodyRequired: "請輸入正文內容",
      
      // 表格列標題
      templateName: "模板名稱",
      category: "類別",
      language: "語言",
      reviewStatus: "審核狀態",
      metaId: "Meta ID",
      updatedTime: "更新時間",
      action: "操作",
      
      // 狀態文本
      approved: "已通過",
      pending: "審核中",
      rejected: "已拒絕",
      paused: "已暫停",
      
      // 類別文本
      marketing: "營銷",
      utility: "實用",
      authentication: "驗證",
      
      // 語言文本
      traditionalChinese: "繁體中文",
      simplifiedChinese: "簡體中文",
      english: "英文",
      
      // 錯誤和警告消息
      cannotGetInputElement: "無法獲取輸入框元素，請重試",
      pleaseSelectTextToFormat: "請先選擇要格式化的文字",
      cannotInsertVariable: "無法插入變數，請重試",
      pleaseEnterVariableName: "請輸入變數名稱",
      maxButtonsWarning: "最多只能添加 3 個按鈕",
      variableInserted: "已插入變數",
      
      // 字符計數
      characters: "字元",
      
      // 分類說明
      categoryDescriptionTitle: "類別說明（Meta 會根據內容自動調整）：",
      marketingDescription: "促銷、優惠、新品推薦、歡迎訊息",
      utilityDescription: "訂單確認、發貨通知、帳戶更新、預約提醒",
      authenticationDescription: "僅用於 OTP 驗證碼",
      utilityWarning: "內容必須是交易性通知，不能含促銷語言，否則會被改為 MARKETING",
      
      // 變數示例
      variableExamples: "變數示例：",
      variableExampleLabel: "變數 {{index}} 的示例值",
      variableExamplePlaceholder: "例如：張三、12345 等",
      
      // 預覽模板
      name: "名稱：",
      category: "類別：",
      language: "語言：",
      status: "狀態：",
      
      // 變數類型說明
      autoNumberDescription: "自動編號：",
      customNameDescription: "自定義名稱：",
      metaStandardFormat: "適用於 Meta 官方模板，符合 WhatsApp 標準格式",
      moreReadable: "更易讀，但需要在發送時正確映射變數名稱",
      
      // 總計顯示
      totalTemplates: "共 {count} 個模板",
      pageRange: "第 ",
      total: " 個模板",
      
      // 錯誤消息
      validationFailed: "驗證失敗",
      createFailed: "創建失敗",
      
      // 示例值
      exampleValue: "示例值{index}",

      // 官方範本資料庫
      fromLibrary: "從官方資料庫建立",
      libraryTitle: "Meta 官方範本資料庫",
      libraryHint: "從 Meta 官方資料庫選擇模板，建立後將成為您的自訂模板並提交審核。",
      librarySearchPlaceholder: "搜尋模板名稱…",
      libraryTopic: "主題",
      libraryUsecase: "用途",
      libraryIndustry: "行業",
      libraryLanguage: "語言",
      libraryApplyFilters: "篩選",
      libraryEmpty: "沒有符合條件的範本",
      libraryUse: "建立",
      libraryLoadFailed: "載入範本資料庫失敗",
      libraryCreateSuccess: "已從資料庫建立模板",
      noData: "暫無模板"
    },
    
    // WhatsApp 模板列表頁面
    templateList: {
      internalTemplates: "內部模板",
      metaOfficialTemplates: "Meta 官方模板",
      description: "管理 WhatsApp 訊息模板：內部模板用於快速迭代，Meta 官方模板用於正式營銷活動"
    },
    
    // 缺少的翻譯鍵值
    categorySelect: "選擇分類",
    statusSelect: "選擇狀態",
    confirmDelete: "確定刪除",
    templateConfirmDeleteSelected: "確定要刪除選中的",
    templateConfirmDeleteSelectedSuffix: "個模板嗎？此操作無法撤銷。",
    addTitle: "新增模板",
    nameRequired: "請輸入模板名稱",
    namePlaceholder: "請輸入模板名稱",
    descriptionPlaceholder: "請輸入模板描述（可選）",
    categoryRequired: "請選擇分類",
    categoryPlaceholder: "請選擇分類",
    welcome: "歡迎",
    order: "訂單",
    marketing: "行銷",
    support: "客服",
    general: "一般",
    typeRequired: "請選擇模板類型",
    typePlaceholder: "請選擇模板類型",
    media: "媒體",
    pleaseEnterMessageContent: "請輸入訊息內容",
    pleaseEnterMessageContentWithVariables: "請輸入訊息內容，可使用 {{變數名}} 格式插入變數",
    statusRequired: "請選擇狀態",
    statusPlaceholder: "請選擇狀態",
    language: "語言",
    languageRequired: "請選擇語言",
    languagePlaceholder: "請選擇語言",
    traditionalChinese: "繁體中文",
    simplifiedChinese: "簡體中文",
    english: "English",
    searchAddress: "搜索地址",
    enterAddressToSearch: "輸入地址或地名進行搜索",
    selectThisLocation: "選擇此位置",
    confirm: "確定",
    cancel: "取消",
    save: "保存",
    
    // 地圖相關翻譯
    searchMapContainerInUse: "搜索地圖容器已被使用，正在清理...",
    searchMapContainerCleanupWarning: "清理搜索地圖容器時出現警告:",
    searchMap: "搜索地圖",
    mainMap: "主地圖",
    mapContainerInUse: "地圖容器已被使用，正在清理...",
    mapContainerCleanupWarning: "清理地圖容器時出現警告:",
    mapInitializing: "地圖正在初始化中，跳過重複初始化",
    cannotGetCurrentLocation: "無法獲取當前位置，請手動選擇",
    browserNotSupportGeolocation: "您的瀏覽器不支持地理定位",
    unknownLocation: "未知位置",
    reverseGeocodeFailed: "反向地理編碼失敗:",
    addressSearchSuccess: "地址搜索成功",
    noAddressFound: "未找到地址",
    searchFailed: "搜索失敗，請稍後重試",
    addressSearchFailed: "地址搜索失敗:",
    getLocationFailed: "獲取位置失敗:",
    saveTemplateError: "保存模板錯誤:",
    
    // 按鈕配置相關翻譯
    buttonConfiguration: "按鈕配置",
    maxButtonsLimit: "最多只能添加 3 個按鈕",
    addButton: "添加按鈕",
    maxThreeButtons: "最多 3 個按鈕",
    buttonText: "按鈕文字 {index}",
    pleaseEnterButtonText: "請輸入按鈕文字",
    buttonType: "按鈕類型",
    pleaseSelectButtonType: "請選擇按鈕類型",
    quickReply: "快速回覆",
    replyId: "回覆ID",
    pleaseEnterReplyId: "請輸入回覆ID",
    replyIdPlaceholder: "回覆ID（用於識別用戶選擇）",
    
    // 列表配置相關翻譯
    listOptionsConfiguration: "列表選項配置",
    listTitle: "列表標題",
    pleaseEnterListTitle: "請輸入列表標題",
    maxOptionsLimit: "最多只能添加 10 個選項",
    addOption: "添加選項",
    maxTenOptions: "最多 10 個選項",
    optionId: "選項 {index} ID",
    pleaseEnterOptionId: "請輸入選項ID",
    optionTitle: "選項標題",
    pleaseEnterOptionTitle: "請輸入選項標題",
    optionDescription: "選項描述",
    optionDescriptionOptional: "選項描述（可選）",
    
    // 產品配置相關翻譯
    productConfiguration: "產品配置",
    productId: "產品ID",
    pleaseEnterProductId: "請輸入產品ID",
    productCatalogId: "產品目錄ID",
    pleaseEnterProductCatalogId: "請輸入產品目錄ID",
    pleaseEnterFacebookProductCatalogId: "請輸入Facebook產品目錄ID",
    productImageUrl: "產品圖片URL",
    pleaseEnterProductImageUrl: "請輸入產品圖片URL",
    
    // 複製相關翻譯
    copy: "複製"
  },

  workflowPackage: {
    title: 'CUI 應用套件',
    cuiDefinition: 'CUI 為 Conversational User Interface（對話式使用者介面）的縮寫，指以自然語言對話互動為核心的應用。',
    subtitle: '在此匯出或匯入流程及其依賴（表單、數據集、模板、AI 員工、Studio 知識庫文件等）。',
    tabExport: '匯出',
    tabImport: '匯入',
    stepSelectWorkflow: '選擇流程',
    stepReviewDeps: '檢視依賴',
    stepBuilding: '產生 ZIP',
    stepDownload: '下載',
    stepUpload: '上傳套件',
    stepPreview: '預覽',
    stepImporting: '匯入中',
    stepDone: '完成',
    selectWorkflow: '選擇要匯出的流程',
    selectWorkflowFirst: '請先選擇流程',
    prev: '上一步',
    dropdownColName: '流程名稱',
    dropdownColCompany: '公司',
    dropdownColStatus: '發布狀態',
    dropdownColUpdated: '更新',
    exportAiStaff: '一併匯出',
    next: '下一步：掃描依賴',
    previewLoaded: '已載入依賴清單',
    colKind: '類型',
    kindEform: '表單',
    kindDataset: '數據集',
    kindTemplate: '模板',
    kindMetaTemplate: 'Meta 模板',
    kindAiStaff: 'AI 員工',
    kindKnowledgeDoc: '知識庫文件',
    kindWorkflow: '流程',
    colName: '名稱',
    colInclude: '包含',
    included: '已包含',
    excluded: '已排除',
    startExportZip: '開始產生 ZIP',
    downloadZip: '下載 ZIP',
    selectZip: '選擇 .zip 套件',
    importPreviewOk: '已解析套件預覽',
    metaNotice: '此套件含 Meta 相關資源；匯入後請於 WhatsApp／表單設定完成 WABA 同步並必要時填寫 Meta 對照。',
    renameFrom: '原名',
    renameTo: '匯入為',
    confirmImport: '確認匯入',
    importDone: '匯入完成',
    metaWarningsTitle: 'Meta 模板匯入注意事項',
    exportMetaWarningsTitle: 'Meta 模板匯出注意事項',
    exportAgain: '再次匯出',
    importAgain: '再次匯入',
    goImport: '前往匯入',
    goExport: '前往匯出',
  },

  knowledgeBase: {
    title: 'Studio 知識庫',
    subtitle: '上傳 Office／PDF 等文件，自動轉為可供 AI 使用的文字與預覽圖，並支援版本與發布。',
    viewTile: '大圖示',
    viewList: '列表',
    filterCategory: '分類',
    allCategories: '全部分類',
    searchPlaceholder: '搜尋標題或內文關鍵字',
    search: '搜尋',
    uploadNew: '上傳新文件',
    uploadSelectCategory: '選擇分類（選填）',
    newCategory: '新增分類',
    uploadOk: '上傳成功，正在處理…',
    versionAdded: '已新增版本',
    publishOk: '已設為發布版本',
    deleteVersionOk: '已刪除版本',
    deleteDocumentOk: '已刪除文件（自列表移除）',
    deleteDocument: '刪除整份文件',
    confirmDeleteDocument: '確定刪除整份文件？將自知識庫列表隱藏；各版本紀錄仍保留於系統以供稽核。',
    publish: '發布',
    delete: '刪除',
    confirmDeleteVersion: '確定刪除此版本？若為發布版本將一併取消發布。',
    empty: '尚無文件',
    noPreview: '無預覽',
    published: '已發布',
    draft: '未發布',
    detailTitle: '文件詳情',
    addVersion: '上傳新版本',
    metaPublished: '目前發布版本',
    none: '無',
    categoryCreated: '已建立分類',
    categoryName: '分類名稱',
    parentCategory: '上層分類（選填）',
    sortOrder: '排序',
    colVersion: '版號',
    colFileName: '檔名',
    colStatus: '狀態',
    colIndexStatus: '向量索引',
    colChunks: 'Chunks',
    indexNone: '未索引',
    reindex: '重建索引',
    reindexQueued: '已加入向量索引佇列',
    ragWorkflowHint: '「向量檢索 (RAG)」在流程設計器節點的「使用知識庫」設定中啟用：先開啟總開關、選取本文件，即可看到 RAG 開關。本頁「重建索引」僅負責建立向量索引。',
    ragXaiHint: '已啟用 xAI Collections 託管 RAG。請先建立 Collection（分類左側），再「發布」版本即可同步至 xAI，Chatbot 將自動搜尋已同步內容。',
    xaiNotSyncedHint: '尚未同步至 xAI Collection，請確認分類已建立 Collection 後重新發布版本。',
    colCreated: '建立時間',
    colActions: '操作',
    colDocumentActions: '文件',
    colTitle: '標題',
    colPublished: '已發布',
    colUpdated: '更新',
    yes: '是',
    no: '否',
    prev: '上一頁',
    next: '下一頁',
    download: '下載',
    downloadLatest: '下載最新版本',
    downloadAllVersionsZip: '下載全部版本（ZIP）',
    downloadNoVersions: '尚無版本可下載',
    colXaiSync: 'xAI 同步',
    xaiSynced: '已同步',
    xaiNotSynced: '未同步',
    xaiCategoryCollections: 'xAI Collections（各分類）',
    xaiCollectionStatus: 'xAI Collection 狀態',
    xaiCollectionReady: '已建立',
    xaiCollectionNotCreated: '未建立',
    xaiCollectionCreate: '建立 Collection',
    xaiCollectionRemove: '移除 Collection',
    xaiCollectionConfirmRemove: '確定要移除 xAI Collection 嗎？此操作將刪除 xAI 上的所有已上傳文件，無法還原。',
    xaiCollectionCreated: 'xAI Collection 建立成功',
    xaiCollectionRemoved: 'xAI Collection 已移除',
    xaiCollectionNoMgmtKey: '需設定 Management API Key：Tenant Admin → API 供應商 → 託管 RAG(Collections) → 編輯 → 填入 Management API Key（與 Regular API Key 不同，請在 x.ai console 建立 Management 類型的 Key）',
    allCategories: '全部文件',
    noCategoryYet: '暫無分類',
    noCategorySet: '未設定分類',
    categoryLabel: '分類',
    moveCategoryOk: '分類已更新',
    deleteCategory: '刪除分類',
    categoryDeleted: '分類已刪除',
    confirmDeleteCategory: '確定刪除此分類？（分類下不可有文件或子分類）',
    catDeleteBlockedXai: '此分類仍連接 xAI Collection，請先點擊「移除 Collection」再刪除分類',
    catDeleteBlockedDocs: '分類下仍有文件，請先移動或刪除所有文件',
    catDeleteBlockedChildren: '請先刪除子分類',
  },

  reportTemplates: {
    title: '報表範本庫',
    subtitle: '管理 Word / Excel / PowerPoint 範本，設定 Placeholder 與流程變量綁定',
    refresh: '重新整理',
    uploadTemplate: '上傳範本',
    categories: '分類',
    all: '全部',
    uncategorized: '未分類',
    searchPlaceholder: '搜尋名稱 / 描述 / 分類…',
    searchResultCount: '共 {count} 筆結果',
    selectedCount: '已選取 {count} 個範本',
    batchDelete: '批量刪除',
    batchDownload: '批量下載',
    clearSelection: '取消選取',
    colName: '名稱',
    colFormat: '格式',
    colCategory: '分類',
    colPlaceholder: 'Placeholder',
    colUploadDate: '上傳日期',
    colActions: '操作',
    textCount: '{count} 文字',
    photoCount: '{count} 相片',
    viewPlaceholder: '查看 Placeholder',
    download: '下載範本',
    edit: '編輯',
    delete: '刪除',
    cancel: '取消',
    save: '儲存',
    close: '關閉',
    confirmDeleteOne: '確定刪除此範本？',
    confirmBatchDelete: '確定刪除已選取的 {count} 個範本？',
    emptyInCategory: '此分類尚無範本。',
    loadFailed: '載入範本庫失敗：',
    loadDetailFailed: '載入詳情失敗：',
    deleteSuccess: '已刪除範本',
    deleteFailed: '刪除失敗：',
    batchDeleteSuccess: '已刪除 {count} 個範本',
    batchDeleteFailed: '批量刪除失敗：',
    downloadFailed: '下載失敗：',
    batchDownloadSuccess: '已完成下載 {done} 個範本',
    batchDownloadFailed: '批量下載部分失敗：{error} 個錯誤',
    updateSuccess: '已更新',
    updateFailed: '更新失敗：',
    batchCategoryLabel: '分類（全部檔案套用）',
    categoryPlaceholder: '輸入或選擇分類（選填）',
    dragHint: '拖曳或點擊選擇 .docx / .xlsx / .pptx / .zip 檔案',
    dragSubHint: '支援一次選取多個檔案；ZIP 檔案將自動解壓，以原始檔名作為範本名稱',
    uploadComplete: '上傳完成：{done} 成功 / {error} 失敗',
    fileCount: '{count} 個檔案',
    pendingUpload: '{count} 個待上傳',
    uploading: '上傳中…',
    completed: '已完成',
    uploadingProgress: '上傳中… ({done}/{total})',
    uploadAll: '上傳全部 ({count} 個)',
    photoSlotCount: '{count} 相片位',
    placeholderFormatHint: 'Placeholder 格式：',
    placeholderFormatExamples: '{{PV:xxx}} / {{EFORM:表單.欄位}} / {{SYS:DATE}} / {{PHOTO:槽位|cols=5}}',
    detailTitle: '範本詳情',
    detailTitleWithName: '{name} — Placeholder',
    editTitle: '編輯範本資訊',
    nameRequired: '請輸入名稱',
    description: '說明',
    bindingsSaved: '變量綁定已儲存',
    saveFailed: '儲存失敗：',
    textPlaceholders: '文字 Placeholder',
    saveBindings: '儲存綁定',
    location: '位置：{location}',
    displayLabelPlaceholder: '顯示標籤（選填）',
    photoSlots: '相片插入位置',
    noPlaceholdersDetected: '此範本未偵測到任何 Placeholder。請確認範本中有使用 {{TYPE:key}} 格式。',
  },
  
  // WhatsApp Workflow Designer
  workflowDesigner: {
    title: '工作流程設計器',
    workflowInfo: '工作流程信息',
    workflowName: '工作流程名稱',
    workflowDescription: '工作流程描述',
    workflowNamePlaceholder: '請輸入工作流程名稱',
    workflowDescriptionPlaceholder: '請輸入工作流程描述',
    nodeTypes: '節點類型',
    loadingNodeTypes: '載入節點類型中...',
    nodeConfiguration: '節點配置',
    connection: '連線',
    node: '節點',
    flow: '流程',
    startNode: '開始節點',
    endNode: '結束節點',
    waitReplyNode: '等待回覆節點',
    waitForQRCodeNode: '等待 QR Code 掃描',
    waitForLocationNode: '請求地理位置',
    waitForEmailReplyNode: '等待 Email 回覆節點',
    waitForEmailReplyAutoCompleteTitle: '逾時自動完成（僅 Wait for Email Reply）',
    waitForEmailReplyAutoCompleteEnable: '啟用逾時自動完成',
    waitForEmailReplyAutoCompleteTimeout: '自動完成逾時時間',
    switchNode: '條件分支節點',
    sendMessageNode: '發送 Message 節點',
    sendWhatsAppNode: '發送 Message 節點',
    sendTemplateNode: '發送模板節點',
    shoppingCartNode: 'WhatsApp 購物車',
    sendInstitutionOrderingCartNode: '機構訂購購物車',
    institutionOrderingCartNode: '機構訂購購物車',
    chatOrderingCartNode: '聊天購物車',
    chatBotNode: '聊天機械人',
    chatBotInitialGreeting: '開場白',
    chatBotInitialGreetingPlaceholder: '例如：您好！有什麼可以幫到您？',
    chatBotGreetingEnabled: '發送開場白',
    chatBotGreetingEnabledHelp: '關閉後，進入等待狀態時不會發送開場白訊息。適合用戶一開始就會直接發送照片或訊息的流程。',
    chatBotEndKeywords: '以相似關鍵字結束對話',
    chatBotEndKeywordsPlaceholder: '按 Enter 加入參考短語。系統會用 AI 比對語意（例：再見、謝謝、不用了、stop）',
    chatBotEndMessageEnabled: '發送結束語',
    chatBotEndMessageEnabledHelp: '關閉後，對話結束時不會發送任何結束訊息（包括系統預設及超時訊息）。',
    chatBotEndMessage: '對話結束語',
    chatBotEndMessageHelp: '當用戶觸發結束關鍵字或對話閒置超時自動完成時，發送此訊息給用戶。留空則使用系統預設結束語。',
    chatBotEndMessagePlaceholder: '例如：感謝您的查詢，如有需要歡迎再聯絡我們。',
    chatBotRagAdditionalQuery: 'RAG 附加查詢',
    chatBotRagAdditionalQueryHelp: '每次查詢知識庫時，將此文字附加到用戶訊息後一起送給 RAG 引擎，可提升特定知識庫 chunk（如身份對照表）的命中率。留空則只用用戶訊息查詢。',
    chatBotRagAdditionalQueryPlaceholder: '例如：身份識別 用戶資料 租戶',
    chatBotAdditionalPrompt: 'Additional Prompt',
    chatBotAdditionalPromptHelp: '追加到 Chat Bot 預設 system prompt，不會取代 appsettings 的 system prompt。',
    chatBotAdditionalPromptPlaceholder: '輸入額外行為或回答風格指示，例如：請用簡短條列回答。',
    chatBotSystemPromptOverride: 'System Prompt 覆寫',
    chatBotSystemPromptOverridePlaceholder: '留空使用 appsettings 預設',
    chatOrderingCartTargetCompany: '目標公司',
    chatOrderingCartProductLanguage: '商品語言',
    chatOrderingCartProductNlFilterFields: '以自然語言查找商品欄位',
    chatOrderingCartProductNlFilterFieldsHelp: '選擇一或多個商品欄位。系統在每輪用戶訊息中，比對這些欄位的現有值，只把命中的商品送入 AI，可大幅節省 token。無命中時自動回傳全部商品。不選 = 不過濾。',
    chatOrderingCartProductNlFilterName: '商品名稱 (Name)',
    chatOrderingCartProductNlFilterProductType: '商品類型 (ProductType)',
    chatOrderingCartProductNlFilterBrand: '品牌 (Brand)',
    chatOrderingCartProductNlFilterGoogleCategory: 'Google 商品分類 (GoogleProductCategory)',
    chatOrderingCartProductNlFilterFbCategory: 'Facebook 商品分類 (FbProductCategory)',
    chatOrderingCartProductNlFilterCustomLabel0: '自訂標籤 (CustomLabel0)',
    chatOrderingCartInitialGreeting: '開場白',
    chatOrderingCartInitialGreetingPlaceholder: '例如：您好！請告訴我您要訂什麼～',
    chatOrderingCartReconfirmQuestion: '追問語句',
    chatOrderingCartReconfirmQuestionPlaceholder: '例如：還有什麼需要的嗎？',
    chatOrderingCartMissingInfoExtra: '缺漏資訊時追加提示',
    chatOrderingCartAdditionalPrompt: 'Additional Prompt',
    chatOrderingCartAdditionalPromptHelp: '追加到聊天購物車預設 system prompt，不會取代 appsettings 的 system prompt。',
    chatOrderingCartAdditionalPromptPlaceholder: '輸入額外下單規則或回答風格指示，例如：地址、電話、金額必須逐字複製。',
    chatOrderingCartEndKeywords: '以相似關鍵字結束對話',
    chatOrderingCartEndKeywordsPlaceholder: '按 Enter 加入參考短語（中英皆可）。系統會用 AI 比對語意，與下列相近即視為放棄下單／結束對話（例：取消、不訂了、cancel、stop ordering）',
    chatOrderingCartBtnConfirmLabel: '確認按鈕文字',
    chatOrderingCartBtnModifyLabel: '修改按鈕文字',
    chatOrderingCartBtnCancelLabel: '取消按鈕文字',
    chatOrderingCartSystemPromptOverride: 'System Prompt 覆寫',
    chatOrderingCartSystemPromptOverridePlaceholder: '留空使用 appsettings 預設',
    chatOrderingCartContactAndAnonymous: '聯絡人與匿名',
    chatOrderingCartAllowAnonymousOrder: '允許匿名下單',
    chatOrderingCartAllowAnonymousOrderHelp: '開啟時，即使 WhatsApp 號碼未連結到聯絡人，也可下單（CustomerId 留空並標記為匿名）。關閉時，必須在 PWA 聯絡人設定中將 WhatsApp 號碼授權至少 1 個客戶。',
    conditionNode: '條件節點',
    formNode: '表單節點',
    webhookNode: 'Webhook 節點',
    callApiNode: '觸發外部 API 節點',
    dataSetQueryNode: 'DataSet 查詢節點',

    tabDesign: '流程設計',
    exportFlowJson: '匯出流程 JSON',
    importFlowJson: '匯入流程 JSON',
    exportFlowJsonSuccess: '已匯出 JSON 檔案',
    exportFlowJsonFailed: '匯出失敗',
    importFlowJsonSuccess: '已匯入流程',
    importFlowJsonFailed: '匯入失敗',
    importFlowJsonInvalidFile: '請選擇 .json 檔案',
    importFlowJsonConfirmTitle: '覆寫目前流程？',
    importFlowJsonConfirmContent: '目前有未儲存的變更，匯入檔案將取代畫布上的流程。是否繼續？',
    importFlowJsonConfirmOk: '繼續匯入',
    importFlowJsonConfirmCancel: '取消',
    tabAIAssistant: 'AI 流程助理',
    aiChat: {
      placeholder: '例如：開始後發送 WhatsApp 再等回覆，然後結束',
      includeCurrentFlow: '包含當前流程',
      pleaseEnterPrompt: '請輸入流程描述',
      generationFailed: '生成失敗',
      schemaValidationFailed: '流程格式驗證失敗：',
      logicValidationFailed: '流程邏輯驗證失敗：',
      applied: '已套用流程',
      updated: '已根據您的要求更新流程',
      restored: '已還原到此版本',
      restoreFailed: '還原失敗',
      restoreToThisVersion: '還原到此版本',
      emptyHint: '輸入流程描述，AI 將協助生成或修改流程',
      saveHint: '儲存流程後，對話紀錄將寫入',
      chatSaveFailed: '未能保存對話記錄',
      timeout: 'AI 生成逾時，請重試或縮短流程描述',
      generatingHint: '這可能需要 15–60 秒，請耐心等候'
    },
    
    // DataSet 節點相關翻譯
    dataSet: {
      selectDataSet: '選擇 DataSet',
      selectDataSetPlaceholder: '選擇要操作的 DataSet',
      operationType: '操作類型',
      operationTypePlaceholder: '請選擇操作類型',
      select: '查詢',
      insert: '新增',
      update: '更新',
      delete: '刪除',
      queryConditions: '查詢條件',
      addQueryConditionGroup: '添加查詢條件組',
      editQueryConditionGroup: '編輯查詢條件組',
      queryConditionGroup: '查詢條件組',
      conditionRelation: '條件關係',
      conditionRelationPlaceholder: '請選擇條件關係',
      and: 'AND',
      or: 'OR',
      andDescription: '所有條件都必須滿足',
      orDescription: '任一條件滿足即可',
      cancel: '取消',
      add: '添加',
      update: '更新',
      selectDataSetField: '選擇 DataSet 欄位',
      selectDataSetFieldPlaceholder: '請選擇 DataSet 欄位',
      operator: '操作符',
      operatorPlaceholder: '請選擇操作符',
      conditionValue: '條件值',
      conditionValueSource: '條件值來源',
      fixedValue: '固定值',
      selectVariable: '選擇變量',
      userNaturalLanguage: '以自然語言查找',
      conditionValuePlaceholder: '請輸入條件值',
      conditionValueInputPlaceholder: '輸入條件值，可使用流程資料 ${variableName}',
      conditionLabel: '條件標籤',
      conditionLabelPlaceholder: '可選的條件描述標籤',
      nlModeDescription: '系統會從對話 [用戶] 訊息中，找出與此欄位的現有值相符的關鍵字，並自動套用為過濾條件。例如用戶說「今日完成了朗晴居工程」，系統會比對欄位所有值，找到「朗晴居」後只返回相關記錄。',
      nlFallback: '無匹配時行為',
      nlFallbackKeepAll: '跳過此條件（保留全部記錄）',
      nlFallbackReturnEmpty: '強制返回空集',
      nlMinFieldLength: '欄位值最短字元數',
      nlMinFieldLengthHint: '短於此長度的欄位值不參與比對，避免單字欄位（如 E、L）誤匹配。預設 2。',
      availableProcessVariables: '可用流程資料',
      clickVariableToInsert: '點擊變量名稱可插入到條件值中',
      editQueryCondition: '編輯查詢條件',
      noDataSetFields: '暫無 DataSet 欄位',
      conditionCount: '條件數量',
      qrCodeSuccessMessage: 'QR Code 掃描成功！流程將繼續執行。',
      qrCodeErrorMessage: '無法處理您上傳的圖片，請重新上傳。',
      template: '模板',
      close: '關閉',
      testQuery: '測試查詢',
      queryResultDescription: '基於輸入的模擬數據查詢結果（前10條）：',
      noQueryResultData: '暫無查詢結果數據',
      totalRecords: '共 {count} 條記錄',
      pvSimulationDataHelp: '輸入測試值後點擊「測試查詢」查看結果',
      addCondition: '添加條件',
      operationData: '操作數據',
      setOperationData: '設置操作數據',
      fieldMapping: '欄位映射',
      setFieldMapping: '設置欄位映射',
      selectDataSetField: '選擇 DataSet 欄位',
      selectProcessVariable: '選擇流程資料',
      selectValueSource: '選擇流程資料或 eForm 欄位',
      processVariables: '流程資料',
      eFormFields: 'eForm 欄位',
      noProcessVariables: '暫無流程資料',
      addFieldMapping: '添加欄位映射',
      noFieldMapping: '暫無欄位映射',
      noOperationData: '暫無操作數據設置',
      fieldMappingSaved: '欄位映射保存成功',
      fieldMappingSaveFailed: '保存欄位映射失敗',
      operationDataSaved: '操作數據設置保存成功',
      operationDataSaveFailed: '保存操作數據設置失敗',
      queryConditionGroupSaved: '查詢條件組保存成功',
      queryConditionGroupSaveFailed: '保存查詢條件組失敗',
      queryConditionSaved: '查詢條件保存成功',
      queryConditionSaveFailed: '保存查詢條件失敗',
      loadDataSetListFailed: '載入 DataSet 列表失敗',
      loadDataSetColumnsFailed: '載入 DataSet 欄位失敗',
      loadProcessVariablesFailed: '載入流程資料失敗',
      testOperation: '測試操作',
      testQuery: '測試查詢',
      testOperationFailed: '測試操作失敗',
      testConfigSuccess: '測試配置成功！請在彈窗中輸入模擬數據進行查詢測試。',
      pleaseSelectDataSet: '請先選擇 DataSet',
      pleaseSelectDataSetAndOperation: '請先選擇 DataSet 和操作類型',
      queryResultPreview: 'DataSet 查詢結果預覽',
      pvSimulationData: 'PV 模擬數據',
      pvSimulationDataDescription: '為查詢條件中的流程資料輸入測試值：',
      pvSimulationDataHelp: '輸入測試值後點擊「測試查詢」查看結果',
      queryResultDescription: '基於輸入的模擬數據查詢結果（前10條）：',
      noQueryConditions: '無查詢條件',
      fieldMappingDescription: '選擇 DataSet 欄位並從現有流程資料中選擇對應的變量，查詢結果會自動映射到流程資料中',
      operationDataDescription: '選擇 DataSet 欄位並從流程資料或 eForm 欄位中選擇對應的值，INSERT/UPDATE 操作會將選定的值寫入到 DataSet 欄位中',
      jsonPvMapping: 'JSON 流程資料映射',
      jsonKeyPlaceholder: '請輸入 JSON 鍵名（例如：amount、status、date）',
      jsonKeyDescription: '當流程資料為 JSON 類型時，請輸入要提取的 JSON 鍵名。系統會從 JSON 對象中提取該鍵對應的值並寫入到 DataSet 欄位中。',
      fixedColumn: '固定欄位',
      dynamicColumnName: '動態欄位名',
      selectDynamicColumnSource: '選擇流程資料或 eForm 欄位（值須為合法欄位名）',
      dynamicColumnJsonKey: '動態欄位名 JSON Key',
      dynamicColumnJsonKeyPlaceholder: '輸入 JSON 鍵名（解析結果須為 DataSet 欄位名）',
      dynamicColumnJsonKeyDescription: '當來源為 JSON 類型流程資料時，輸入要提取的鍵名，提取結果須為有效的 DataSet 欄位名稱。',
      fieldMappingSummary: '已設置 {count} 個欄位映射',
      operationDataSummary: '已設置 {count} 個欄位映射',
      clickToSetFieldMapping: '點擊上方按鈕設置 DataSet 欄位到流程資料的映射關係',
      generatedWhereClause: '生成的 WHERE 條件',
      operationPreview: '操作預覽',
      pleaseSelectDataSetAndOperationType: '請先選擇 DataSet 和操作類型',
      pleaseSelectOperationType: '請先選擇操作類型',
      pleaseSelectDataSet: '請先選擇 DataSet',
      operationData: '操作數據',
      fieldMapping: '欄位映射',
      noOperationData: '無操作數據',
      noFieldMapping: '無欄位映射',
      queryTopRows: '查詢筆數上限 (TOP)',
      queryTopRowsPlaceholder: '例如：1、10、100',
      queryTopRowsHelp: '留空表示不限制筆數',
      orderByFields: '排序欄位 (ORDER BY)',
      noOrderByFields: '尚未設定排序欄位',
      addOrderByField: '新增排序欄位',
      selectOrderByField: '選擇排序欄位',
      orderAsc: '升序 ASC',
      orderDesc: '降序 DESC'
    },
    
    eFormResultNode: '表單結果節點',
    taskName: '任務名稱',
    taskNameLabel: '任務名稱',
    taskNamePlaceholder: '請輸入任務名稱',
    phoneNumberPlaceholder: '請輸入手機號碼',
    recipient: '收件人',
    messageTemplate: '訊息模板',
    clear: '清除',
    sectionBasic: '基本',
    sectionTrigger: '觸發',
    sectionRecipient: '對象',
    sectionMessage: '訊息',
    sectionRecipientAndMessage: '對象及訊息',
    sectionTemplate: '模板與媒體',
    sectionAi: 'AI',
    sectionValidation: '驗證',
    sectionKnowledgeBase: '知識庫',
    sectionData: '資料整合',
    sectionForm: '表單與文件',
    sectionCommerce: '商務購物車',
    sectionApproval: '審批',
    sectionBranch: '分支',
    sectionOverdue: '逾期與升級',
    sectionDescription: '功能說明',
    sectionLocation: '地理位置',
    sectionEmailFilter: 'Email 篩選',
    loading: '載入中...',
    noCollections: '暫無集合',
    selectUser: '選擇用戶',
    selectRecipients: '選擇收件人',
    shoppingCartSelectCollection: '選擇商品集合',
    shoppingCartSelectCollectionPlaceholder: '請選擇要顯示的商品集合',
    shoppingCartBody: '訊息內容（必填）',
    shoppingCartBodyPlaceholder: '輸入商品列表上方的說明文字',
    shoppingCartHeader: '標題（選填）',
    shoppingCartHeaderPlaceholder: '選填',
    shoppingCartFooter: '頁腳（選填）',
    shoppingCartFooterPlaceholder: '選填',
    shoppingCart24hHint: '此訊息需在用戶 24 小時內有回覆的對話中發送；超過 24 小時需使用 MPM 模板（後續支援）。',
    institutionOrderingCartFlowMessageTitle: 'Flow 訊息內容（依語系）',
    institutionOrderingCartFlowMessageHeader: '標題 (Header)',
    institutionOrderingCartFlowMessageHeaderPlaceholder: '留空則使用流程名稱',
    institutionOrderingCartFlowMessageBody: '內文 (Body)',
    institutionOrderingCartFlowMessageBodyDefault: '請按下面按鈕開始輸入訂單',
    institutionOrderingCartFlowMessageBodyDefaultZhCN: '请按下面按钮开始输入订单',
    institutionOrderingCartFlowMessageBodyDefaultEn: 'Tap the button below to start ordering',
    institutionOrderingCartFlowMessageButton: '按鈕 (Footer)',
    institutionOrderingCartFlowMessageButtonDefault: '開始創建訂單',
    institutionOrderingCartFlowMessageButtonDefaultZhCN: '开始创建订单',
    institutionOrderingCartFlowMessageButtonDefaultEn: 'Start creating order',
    institutionOrderingCartFlowTemplate: 'Flow 模板名稱',
    institutionOrderingCartHint: '請先在 Meta Flows 建立並發布名為上述模板名稱的 Flow，Data Exchange 端點會依 flow_token 前綴 cart_ 辨識並回傳商品組合／商品列表／購物車。',
    institutionOrderingCart24hTemplateNote: 'Flows 一律透過「Flow 模板」發送，24 小時內外皆使用同一模板（與普通 Shopping Cart 的 product_list 不同，無 24h 內免模板選項）。',
    institutionOrderingCartSettingsSummary: '本節點設定：收件者、Flow 模板名稱。流程為選 collection → 商品列表（含圖）→ 產品明細（±qty、±10）→ 購物車 → 提交。',
    institutionOrderingCartFlowLanguage: 'Flow 語言',
    institutionOrderingCartLangZhTW: '繁體中文',
    institutionOrderingCartLangZhCN: '简体中文',
    institutionOrderingCartLangEn: 'English',
    institutionOrderingCartCompanyForTemplate: '公司（用於建立 Template）',
    institutionOrderingCartSelectCompany: '請選擇公司',
    institutionOrderingCartSelectCompanyFirst: '請先選擇公司再建立 Template',
    institutionOrderingCartCreateTemplateButton: '創建到 Meta Template 並連結',
    institutionOrderingCartCreateSuccess: 'Flow Template 已建立，可於 Meta 模板管理查看',
    institutionOrderingCartCreateFailed: '建立 Flow Template 失敗',
    institutionOrderingCartPreviewTitle: 'Flow Template 預覽',
    institutionOrderingCartOpenMetaPanel: '在 Meta 模板管理查看',
    institutionOrderingCartTemplateInfo: '模板資訊',
    institutionOrderingCartStatus: '狀態',
    institutionOrderingCartCategory: '類別',
    institutionOrderingCartLanguage: '語言',
    institutionOrderingCartMessagePreview: '訊息預覽',
    institutionOrderingCartFlowButton: '開啟訂購購物車',
    close: '關閉',
    shoppingCartMode: '模式',
    shoppingCartModeSelectCollection: '選定一個 collection 來顯示',
    shoppingCartModeSendCollectionOptions: '發送 collection 選項（先發列表，用戶選擇後再發 product_list）',
    messageWithVariablesPlaceholder: '請輸入訊息內容，可使用變量如 {變量名}；流程資料為 JSON 時可用 ${JsonName.JsonFieldName}',
    availableVariables: '可用變量',
    variableSyntaxHelp: '使用 {變量名} 語法來插入變量；JSON 流程資料可使用 ${JsonName.JsonFieldName}',
    description: '描述',
    descriptionPlaceholder: '請輸入描述（可選）',
    assignTo: '指定給',
    assignToPlaceholder: '請選擇指定人員',
    messageContent: '訊息內容',
    messageContentPlaceholder: '請輸入訊息內容',
    condition: '條件',
    conditionPlaceholder: '請輸入條件',
    formSelection: '表單選擇',
    formSelectionPlaceholder: '請選擇表單',
    webhookUrl: 'Webhook URL',
    webhookUrlPlaceholder: '請輸入 Webhook URL',
    save: '儲存',
    saveSuccess: '工作流程已儲存！',
    saveFailed: '儲存失敗',
    validationErrors: '驗證錯誤',
    validationWarnings: '驗證警告',
    mustHaveStartEnd: '工作流程必須包含開始和結束節點',
    mustHaveConnection: '請建立節點連線',
    hasCycle: '發現循環連接',
    isolatedNode: '發現孤立節點',
    startNodeNoOutput: '開始節點沒有輸出連接',
    endNodeNoInput: '結束節點沒有輸入連接',
    cannotConnectToSelf: '不能連接節點到自己',
    connectionAlreadyExists: '節點之間已經存在連接',
    workflowValidationFailed: '工作流程驗證失敗',
    workflowValidationWarning: '工作流程警告',
    continueSave: '是否繼續保存？',
    back: '返回',
    design: '設計',
    copy: '複製',
    delete: '刪除',
    confirmDelete: '確定要刪除此工作流程嗎？',
    copySuccess: '已複製工作流程',
    deleteSuccess: '已刪除工作流程',
    deleteFailed: '刪除失敗',
    copyFailed: '複製失敗',
    nameRequired: '請輸入工作流程名稱',
    descriptionRequired: '請輸入工作流程描述',
    
    // 按鈕和操作
    selectPerson: '選擇人員',
    selectForm: '選擇表單',
    selectTemplate: '選擇模板',
    
    // 表單標籤和提示
    taskNameLabel: '任務名稱',
    phoneNumberPlaceholder: '輸入電話號碼 (例如: 85296366318) 或點擊選擇用戶',
    selectSpecifiedPerson: '選擇指定人員',
    waitReplyMessagePlaceholder: '輸入等待用戶回覆時的提示訊息',
    selectEFormPlaceholder: '選擇要發送的 e-Form',
    
    // 節點配置
    replyType: '回覆類型',
    initiator: '流程啟動人',
    specifiedPerson: '指定人員',
    promptMessage: '提示訊息',
    promptMessageHelp: '在用戶輸入前，系統會發送以下訊息提醒用戶需要輸入',
    validationConfig: '驗證配置',
    validationSettings: '驗證設定',
    validatorActiveLabel: '驗證狀態',
    active: '啟用',
    inactive: '停用',
    enableValidation: '啟用驗證',
    yes: '是',
    no: '否',
    validatorType: '驗證器類型',
    defaultValidator: '預設驗證器',
    customValidator: '自定義驗證器',
    aiValidator: 'AI 驗證',
    timeValidatorLabel: '時間驗證器（無回應提醒）',
    timeoutCompleteValidatorLabel: 'Auto Complete 驗證器',
    promptText: '提示文字',
    promptTextPlaceholder: '描述有效回覆需要滿足的條件，例如「用戶必須提供 6 位數字驗證碼」。',
    retryMessage: '提醒訊息',
    retryMessagePlaceholder: '輸入當用戶回覆不符合要求時要發送的提示內容。',
    maxRetries: '最大提醒次數',
    minutes: '分鐘',
    days: '天',
    hours: '小時',
    validationAiProvider: 'AI 提供商',
    validationAiProviderPlaceholder: '選擇用於驗證用戶回覆的 AI 提供商',
    validationAiProviderRequired: '請選擇用於驗證的 AI 提供商',
    voiceProviderKey: '語音轉文字 Provider',
    voiceProviderKeyPlaceholder: '留空則使用公司預設語音 AI',
    aiStaffLabel: 'AI 員工',
    aiStaffPlaceholder: '選擇 AI 員工（可選）',
    aiStaffHelp: '選定後，AI 調用將以該員工的角色、技能和個性執行任務',
    aiStaffUseMemory: '使用 AI 員工全局記憶',
    aiStaffUseMemoryHelp: '開啟時，AI 員工的歷史工作記憶（MemoryMd）會注入 system prompt；關閉則只使用角色設定，不帶入過去記憶。',
    validationAiResultVariable: 'AI 結果流程資料',
    validationAiResultVariablePlaceholder: '選擇要儲存 AI 結果的流程資料',
    validationAiResultVariableHelp: 'AI 解析完成後會將結果寫入此流程資料，供後續節點引用。',
    validationAiSuggestionVariable: 'AI 建議流程資料',
    validationAiSuggestionVariablePlaceholder: '選擇要儲存 AI 建議文字的流程資料',
    validationAiSuggestionVariableHelp: '驗證成功且 AI 回傳 suggestion 時，會寫入此流程資料。僅可選擇 text 或 string 類型（非 json）。',
    validationAiFailReasonVariable: 'AI 失敗原因流程資料',
    validationAiFailReasonVariablePlaceholder: '選擇要儲存 AI 失敗原因的流程資料',
    validationAiFailReasonVariableHelp: '驗證失敗時，會將 AI 回應中解析出的 reason（若無則為錯誤訊息）寫入此流程資料。僅可選擇 text 或 string 類型（非 json）。',
    aiProviderInactive: '未啟用',
    aiProviderNotConfigured: '尚未配置 AI 提供商，請至 API 管理頁面新增。',
    aiProviderLoadFailed: '無法載入 AI 提供商列表',
    
    // Time Validator 相關翻譯
    timeValidator: {
      retryInterval: '提醒間隔',
      retryIntervalHelp: '用戶在此時間內沒有回應，系統將自動重新發送提醒訊息',
      retryLimit: '提醒次數上限',
      retryMessage: '提醒訊息設置',
      escalation: '升級通知設置',
      configureRetryMessage: '設置提醒訊息',
      configureEscalation: '設置升級通知',
      directMessage: '直接訊息',
      useTemplate: '使用模板',
      retryMessageDescription: '設置當用戶在指定時間內沒有回應時，重新發送的提醒訊息內容：',
      retryMessagePlaceholder: '請輸入提醒訊息內容，提醒用戶儘快回覆...',
      retryMessageTip: '提示：此訊息會在每次提醒時發送給用戶',
      retryMessageRecipients: '提醒訊息收件人',
      retryMessageRecipientsDescription: '選擇需要接收提醒訊息的人員（可選擇用戶、聯絡人、流程資料或流程啟動人）：',
      templateDescription: '選擇一個已建立的模板作為提醒訊息：',
      noTemplateSelected: '尚未選擇模板',
      escalationMessageDescription: '設置當達到提醒上限後，發送給升級對象的通知訊息：',
      escalationMessagePlaceholder: '請輸入升級通知訊息內容，告知管理者需要處理...',
      escalationMessageTip: '提示：此訊息只會在達到提醒上限後發送一次',
      escalationRecipients: '升級通知收件人',
      escalationRecipientsDescription: '選擇在達到提醒上限後，需要接收升級通知的人員：',
      escalationMessage: '升級通知訊息',
      retryMessageSaved: '提醒訊息配置已保存',
      escalationSaved: '升級通知配置已保存',
      retryMessageCleared: '提醒訊息配置已清除',
      escalationCleared: '升級通知配置已清除',
      overdueEscalationCleared: '逾期升級通知配置已清除',
      retryMessageConfig: '提醒訊息設置',
      escalationConfig: '升級通知設置',
      overdueEscalation: '逾期升級通知',
      configureOverdueEscalation: '設置逾期升級通知',
      overdueEscalationRecipients: '逾期升級通知收件人',
      overdueEscalationRecipientsDescription: '選擇在流程逾期後，需要接收升級通知的人員：',
      overdueEscalationMessage: '逾期升級通知訊息',
      overdueEscalationMessageDescription: '設置當流程逾期後，發送給升級對象的通知訊息：',
      overdueEscalationMessagePlaceholder: '請輸入逾期升級通知訊息內容...',
      overdueEscalationMessageTip: '提示：此訊息會在流程超過逾期時間後發送',
    },

    // Auto Complete 驗證器相關翻譯
    timeoutComplete: {
      timeoutInterval: '超時間隔',
      description: '設定超時後自動完成節點的時間間隔。超過此時間用戶無操作，系統將自動完成節點並前往下一個節點。',
      hint: '提示：將天、時、分全部設為 0 或留空，則不啟用自動完成功能。',
    },
    autoComplete: {
      aiBatchCount: {
        enable: '圖片／影片 AI 批次分析次數達標後自動完成',
        count: 'AI 批次分析完成次數',
        description: '僅計算圖片或影片觸發的 AI 批次分析（純文字訊息不計入）。設定完成幾批後自動結束 Chatbot；停用則不限制批次次數。',
        hint: '提示：適合「用戶發完一批相片即結束」的場景。若用戶在第 1 批 AI 分析期間搶先發出第 2 批，第 2 批將排入佇列；若已達設定次數，佇列中剩餘圖片將被丟棄而不會送至 AI。',
      },
    },
    chatBot: {
      jsonExtraction: {
        sectionTitle: 'JSON 擷取（每輪 AI 回覆後同步執行）',
        additionalPrompt: '額外 Prompt（JSON 生成指示）',
        additionalPromptHelp: '用於指示 AI 從對話歷史中擷取數據並生成 JSON。有填寫才執行，結果寫入下方指定流程資料。',
        additionalPromptPlaceholder: '例如：請將對話中提到的訂單資料生成以下格式的 JSON：\n{\n  "customerName": "...",\n  "product": "...",\n  "quantity": 1,\n  "deliveryAddress": "..."\n}',
        jsonResultVariable: 'JSON 結果流程資料',
        jsonResultVariableHelp: '選擇一個 JSON 類型的流程資料來存儲 AI 每輪擷取的 JSON 數據',
        jsonResultVariablePlaceholder: '選擇 JSON 類型的流程資料',
      },
      batchRequireText: {
        enable: '圖片批次必須附帶文字說明',
        waitSeconds: '等待文字秒數',
        seconds: '秒',
        prompt: '未收到文字時的提示語',
        promptPlaceholder: '請附上文字說明，如樓盤/地址/工程描述，多謝！',
      },
    },
    
    // 模板變量配置相關翻譯
    templateVariables: '模板變量配置',
    addTemplateVariable: '添加模板變量',
    templateVariable: '模板變量',
    parameterName: '參數名稱',
    processVariable: '流程資料',
    selectProcessVariable: '選擇流程資料',
    noTemplateVariables: '暫無模板變量配置',
    
    // Meta 模板變量配置
    metaTemplateVariableConfig: 'Meta 模板變量配置',
    metaTemplateVariableDescription: 'Meta 官方模板使用數字參數(1, 2, 3...) 或命名參數。請根據模板定義配置對應的變量來源。',
    metaTemplateParameterPlaceholder: '1, 2, 3...',
    metaTemplateParameterHint: 'Meta 模板參數：使用數字(1,2,3...) 或變量名 (customer_name, order_id)',
    
    // 內部模板變量配置
    internalTemplateVariableConfig: '內部模板變量配置',
    internalTemplateVariableDescription: '內部模板使用命名參數。請根據模板定義配置對應的變量來源。',
    internalTemplateParameterPlaceholder: 'customer_name, order_id...',
    internalTemplateParameterHint: '內部模板參數：使用變量名 (customer_name, order_id)',
    
    // Drawer 全屏相關
    enterFullscreen: '全屏顯示',
    exitFullscreen: '退出全屏',
    
    // Overdue Settings（流程逾期設置 - Start 節點）
    overdueConfig: '流程逾期設置',
    overdueSettings: '逾期監控設定',
    overdue: {
      enabled: '啟用逾期監控',
      duration: '逾期時限',
      escalation: '逾期通知設置',
      configureEscalation: '設置逾期通知',
      durationHelp: '流程從啟動後超過此時限仍未完成，將發送逾期通知',
      escalationRecipients: '逾期通知收件人',
      escalationRecipientsDescription: '選擇在流程逾期時需要接收通知的管理人員：',
      escalationMessage: '逾期通知訊息',
      escalationMessageDescription: '設置當流程逾期時，發送給管理者的通知訊息：',
      escalationMessagePlaceholder: '請輸入逾期通知訊息內容，告知管理者流程已逾期需要處理...',
      escalationMessageTip: '提示：此訊息會在流程逾期時發送一次',
      escalationSaved: '逾期通知配置已保存',
      howItWorks: '運作方式',
      description1: '系統定時檢查所有運行中的流程，計算從啟動至今的時間',
      description2: '當超過設定的時限（天數 + 小時），且流程仍在運行（未 Complete 或 Failed），則發送逾期通知',
      description3: '逾期通知只發送一次，避免重複打擾',
    },
    
    // 功能說明
    waitReplyDescription1: '1. 流程執行到此節點時會暫停等待用戶回覆',
    waitReplyDescription2: '2. 只有指定的用戶回覆才會繼續執行流程',
    waitReplyDescription3: '3. 如果啟用驗證，會檢查用戶輸入是否符合要求',
    waitReplyDescription4: '4. 驗證失敗時會要求用戶重新輸入',
    waitReplyKnowledgeBaseEnabled: 'Dataset 作為知識庫',
    waitReplyKnowledgeBaseEnabledHelp: '啟用 AI 驗證時，執行前會先依條件查詢指定 Dataset，將結果 JSON 一併傳給 AI，便於對照主檔判斷使用者輸入。AI Result 流程資料寫入邏輯不變。',
    waitReplyKnowledgeBaseHint: '查詢結果會以 JSON 傳給 AI（條件編輯與 DataSet Query 節點相同）。資料量大時請用查詢條件縮小範圍。',
    waitReplyKnowledgeBaseDataSet: '知識庫 Dataset',
    waitReplyKnowledgeBaseQueryConditions: '查詢條件',
    knowledgeSourcesHint: '可同時或擇一使用：「Dataset 作為知識庫」會依查詢條件將列資料以 JSON 傳給 AI；「使用知識庫」可複選 Studio 知識庫文件，傳入已發布版本之抽用文字。Dataset 僅能選一個；文件可選多份。',
    knowledgeSourceDataset: 'Dataset 作為知識庫',
    knowledgeSourceDatasetHelp: '開啟後可指定一個 Dataset 與查詢條件，結果以 JSON 併入 AI 提示（與 DataSet Query 節點條件編輯相同）。',
    knowledgeSourceStudio: '使用知識庫',
    knowledgeSourceStudioHelp: '複選與 Studio「知識庫」頁相同的文件；執行時僅納入已有發布版本之內容。未發布者仍可選取以利設計，但執行時會略過。',
    knowledgeSourceStudioPlaceholder: '選擇知識庫文件（可多選）',
    knowledgeSourceStudioDraft: '未發布',
    knowledgeBaseSettingsDrawerLabel: '使用知識庫',
    knowledgeBaseSettingsDrawerHelp: '點「開啟設定」於彈窗內一併設定「知識庫 Dataset」（單一）與 Studio 知識庫文件（可多選）；確定後寫入節點。',
    knowledgeBaseSettingsModalTitle: '使用知識庫設定',
    knowledgeBaseSettingsConfigure: '開啟設定',
    knowledgeBaseSettingsOk: '確定',
    knowledgeBaseSettingsCancel: '取消',
    knowledgeBaseSettingsSectionDataset: '知識庫 Dataset',
    knowledgeBaseSettingsSectionStudio: '知識庫文件（可多選）',
    knowledgeStudioRagEnabled: '向量檢索 (RAG)',
    knowledgeStudioRagHint: '啟用後僅將與用戶訊息最相關的 FAQ 片段送給 AI（需文件已完成向量索引）。預設關閉以維持全文模式。',
    knowledgeStudioTopK: 'Top-K 片段數',
    knowledgeStudioMaxContextChars: '最大上下文字元',
    knowledgeStudioEmbeddingProvider: 'Embedding 供應商',
    knowledgeStudioEmbeddingProviderPlaceholder: '留空則使用公司預設 Embedding provider',
    knowledgeStudioRagProvider: 'RAG 引擎',
    knowledgeStudioRagProviderLocal: '自建管線（本地 Embedding）',
    knowledgeStudioRagProviderXai: 'xAI Collections（託管）',
    knowledgeStudioRagXaiHint: 'xAI Collections 由 xAI 雲端託管。系統將自動搜尋知識庫中所有「已建立 Collection」的分類，無需手動填入 ID。請確保：① 在知識庫頁面為各分類建立 Collection；② 將文件歸入分類後發布，即可自動同步至 xAI。',
    knowledgeStudioRagXaiAutoSelected: '已偵測到預設 AI 供應商為 xAI，自動使用 xAI Collections（託管）模式。',
    knowledgeStudioCollectionIds: 'xAI Collection ID',
    knowledgeStudioCollectionIdsHelp: '可輸入多個 Collection ID（如 collection_xxxxxxxx），用逗號、空格或換行分隔。',
    knowledgeStudioCollectionIdsPlaceholder: '輸入 Collection ID 後按 Enter（可多個）',
    knowledgeBaseSettingsSummaryEmpty: '尚未設定',
    knowledgeBaseSettingsSummaryDataset: 'Dataset：{name}',
    knowledgeBaseSettingsSummaryAndStudio: '；文件 {count} 份',
    knowledgeBaseSettingsSummaryStudioOnly: '文件 {count} 份',
    knowledgeBaseSettingsSummaryMasterOn: '已開啟（尚未選擇文件或 Dataset）',
    knowledgeBaseSettingsMasterSwitch: '使用知識庫',
    knowledgeBaseSettingsMasterHelp: '關閉時不向 AI 傳遞知識庫內容；開啟後可設定下方知識庫文件與 Dataset。',
    knowledgeBaseSettingsQueryDivider: '查詢條件',
    knowledgeBaseSettingsSectionCalendar: '日曆事件',
    knowledgeBaseCalendarEnabledSwitch: '啟用日曆事件作為知識庫',
    knowledgeBaseCalendarEnabledHelp: '開啟後，執行時會依篩選模式查詢日曆事件，將事件清單以 JSON 傳給 AI，供聊天機械人回答工作安排等問題。',
    knowledgeBaseCalendarFilterModeLabel: '人員篩選模式',
    knowledgeBaseCalendarFilterModeSelf: '查詢本人（自動以觸發流程的 WhatsApp 用戶篩選）',
    knowledgeBaseCalendarFilterModeGroupTag: '指定群組／標籤（可建不同流程給不同權限的人）',
    knowledgeBaseCalendarGroupIds: 'Broadcast Group',
    knowledgeBaseCalendarGroupIdsPlaceholder: '選擇廣播群組（可多選）',
    knowledgeBaseCalendarHashtags: 'Hashtag 標籤',
    knowledgeBaseCalendarHashtagsPlaceholder: '輸入標籤後按 Enter，可多個',
    knowledgeBaseCalendarRelativeDays: '查詢未來幾天',
    knowledgeBaseCalendarRelativeDaysPlaceholder: '留空 = 不限日期',
    knowledgeBaseSettingsSummaryCalendarSelf: '日曆：查本人',
    knowledgeBaseSettingsSummaryCalendarGroup: '日曆：{n} 群組{tags}',
    eFormDescription1: '1. 選擇要發送的 e-Form 表單',
    eFormDescription2: '2. 選擇接收表單的用戶（電話號碼）',
    eFormDescription3: '3. 系統會將表單連結發送給指定用戶',
    eFormDescription4: '4. 用戶可以點擊連結填寫表單',
    eFormDescription5: '5. 表單提交後會觸發後續流程',
    eFormDescription6: '6. 可設置審批結果回收變量，記錄審批狀態（approve/reject/pending）',
    eFormDescription7: '7. 審批結果可用於後續 Switch 節點進行流程分流',
    
    // 審批結果回收
    approvalResultVariable: '審批結果回收的流程資料',
    selectApprovalResultVariable: '選擇用於記錄審批結果的流程資料',
    approvalResultInfo: '審批結果說明',
    approvalResultDescription1: '1. 當表單完成審批時，系統會自動將審批結果寫入選定的流程資料',
    approvalResultDescription2: '2. 審批結果值：approve（通過）、reject（拒絕）、pending（待審批）',
    approvalResultDescription3: '3. 可在後續的 Switch 節點中使用此變量進行流程分流',
    
    // 啟動方式配置
    activationConfig: '啟動方式配置',
    activationType: '啟動方式',
    manualActivation: '手動啟動',
    metaWebhookCall: '從 WhatsApp 啟動',
    scheduledTableWatch: '定時監看數據表',
    emailMonitor: 'Email 監控',
    emailProvider: '郵件服務提供商',
    emailProviderPlaceholder: '請選擇郵件服務提供商',
    emailNoProviderConfigured: '未配置郵件服務提供商，請在 API 管理中添加',
    emailMonitorMailbox: '監聽的 Email Box (email address)',
    emailMonitorMailboxPlaceholder: '要監聽的信箱地址，例如 user@company.com；留空則依提供商設定',
    emailFilterSender: '篩選發件人',
    emailFilterSenderPlaceholder: '留空則不篩選；可輸入部分比對',
    emailFilterSubject: '篩選關鍵詞（任一命中）',
    emailFilterSubjectPlaceholder: '留空則不篩選；任一關鍵詞出現在主旨或內文即可',
    emailFilterKeywordsRequired: '必要關鍵詞（全部必須）',
    emailFilterKeywordsRequiredPlaceholder: '留空則不強制；每個關鍵詞都須出現在主旨或內文',
    emailFilterKeywordsMatchHint: '兩欄之間為 AND：先通過「任一命中」，再檢查「全部必須」；關鍵詞會在主旨與內文搜尋',
    emailFilterSenderNot: '發件人不包含',
    emailFilterSenderNotPlaceholder: '留空則不篩選；任一出現則排除',
    emailFilterSubjectNot: '主旨不包含',
    emailFilterSubjectNotPlaceholder: '留空則不篩選；任一出現則排除',
    emailFilterBodyKeywordsNot: '內文不包含',
    emailFilterBodyKeywordsNotPlaceholder: '留空則不篩選；任一出現則排除',
    emailFilterHasAttachment: '僅有附件的郵件',
    emailFilterAttachmentExtensions: '附件副檔名篩選',
    emailFilterAttachmentExtensionsPlaceholder: '留空則不篩選；多個為 OR（任一副檔名符合即可）',
    emailFilterAttachmentFileName: '附件檔名包含',
    emailFilterAttachmentFileNamePlaceholder: '留空則不篩選；多個為 OR（檔名包含任一關鍵詞即可）',
    emailFilterAttachmentFileNameNot: '附件檔名不包含',
    emailFilterAttachmentFileNameNotPlaceholder: '留空則不篩選；檔名包含任一則排除',
    emailMonitorInfo: 'Email 監控說明',
    emailMonitorDescription1: '1. 系統會定期檢查所選信箱，符合篩選條件的郵件將觸發此流程',
    emailMonitorDescription2: '2. 觸發後郵件內容與附件會寫入流程，可搭配「整合 Email 監看 (AI 填表)」節點使用',
    watchTable: '監看數據表',
    queryCondition: '查詢條件',
    checkInterval: '檢查間隔 (秒)',
    
    // Webhook 相關
    webhookToken: 'Webhook Token',
    webhookTokenPlaceholder: '請輸入 Webhook Token',
    whatsAppMenuName: 'WhatsApp 選單名稱',
    whatsAppMenuNamePlaceholder: '選填，顯示在 WhatsApp 選單的選項名稱（留空則使用流程名稱）',
    webhookInfo: 'Webhook 資訊',
    webhookDescription1: '1. 請在公司設定頁面配置 Meta Webhook URL',
    webhookDescription2: '2. 當收到 WhatsApp 訊息時，系統會回覆選單讓用戶選擇功能',
    webhookDescription3: 'Webhook Token 已在公司層級配置，流程將自動使用公司的 Webhook 設定',

    // Webhook 流程使用權限
    webhookAccess: {
      modalTitle: '選擇允許啟動本流程的聯絡人',
      modalIntro: '只有電話號碼屬於以下任一條件的聯絡人，才會在 WhatsApp 選單中看到並可以啟動此流程。',
      modeLabel: '流程使用權限',
      modePublic: '公眾可用',
      modeRestricted: '限定指定聯絡人',
      allowedRecipientsLabel: '允許啟動的聯絡人 / 群組 / 標籤',
      allowedRecipientsHelp: '可勾選個別聯絡人、廣播群組或聯絡人標籤；只要符合任一條件即視為有權使用。',
      restrictedInfo: '此流程已限定使用對象，不在名單內的 WhatsApp 用戶將看不到此選項。',
      fieldPlaceholder: '尚未選擇任何聯絡人 / 群組 / 標籤',
      fieldButton: '選擇',
      selectedSummary: '已選擇的允許名單',
      summaryGroups: '{count} 個群組',
      summaryHashtags: '{count} 個標籤',
      summaryContacts: '{count} 個聯絡人',
    },

    // 定時監看相關
    scheduledTable: '監看數據表',
    scheduledTablePlaceholder: '例如: dbo.SoOrderManage',
    scheduledQuery: '查詢條件',
    scheduledQueryPlaceholder: '例如: WHERE status = \'PENDING\' AND created_at > @lastCheckTime',
    scheduledInterval: '檢查間隔',
    seconds: '秒',
    scheduledInfo: 'Dataset 排程（觸發條件＋寫回）',
    scheduledDataSet: '要監看的 Dataset',
    scheduledTriggerConditions: '觸發條件（哪些列會啟動流程）',
    scheduledFieldMapping: '將列欄位對應到流程資料',
    scheduledPostSuccessWriteBack: '流程建立成功後 — 寫回該列',
    scheduledPostSuccessSetWriteBack: '設定寫回欄位',
    scheduledPostSuccessWriteBackSummary: '將在流程執行建立後更新該列共 {count} 個欄位。',
    scheduledPostSuccessOperationSaved: '已儲存寫回欄位。',
    scheduledLegacySqlDeprecated: '此流程仍留有舊版自由填寫的資料表／SQL 欄位。請改選 Dataset 並用下方條件組設定觸發條件；伺服器將忽略舊欄位。',
    scheduledDescription1: '1. 選擇一個 Dataset（如同您從 Excel 上傳的表格）。系統會依您設定的間隔掃描其中的資料列。',
    scheduledDescription2: '2. 觸發條件：與 DataSet 節點相同的查詢條件組。例如：狀態 等於 待處理 且 部門 等於 業務 —— 只有符合的列才會為該列建立一筆新的流程執行。',
    scheduledDescription3: '3. 欄位對應：把命中列上的欄位寫入流程資料（例如訂單編號、客戶名稱），後續節點才能使用。',
    scheduledDescription4: '4. 寫回：執行個體成功建立後，系統會更新同一筆列（例如把狀態改為處理中），下一輪掃描就不會再重複觸發。請至少設定一個寫回欄位，以免重複開跑。',
    scheduledDescription5: '範例：Dataset「訂單」有欄位狀態、金額。觸發條件為狀態＝新建；寫回把狀態改為處理中。某一列第一次符合時會開跑，寫回後不再符合「新建」，就不會重複觸發。',
    
    // 配置說明
    metaWebhookConfigTitle: 'Meta Webhook 配置說明',
    metaWebhookConfig1: '1. 請在公司設定頁面配置 Meta Webhook URL',
    metaWebhookConfig2: '2. 當收到 WhatsApp 訊息時，系統會回覆選單讓用戶選擇功能',
    metaWebhookConfig3: '3. 根據用戶選擇啟動對應的流程',
    metaWebhookConfig4: '4. 此流程將在用戶選擇後執行',
    scheduledWatchTitle: '定時監看說明',
    scheduledWatchDescription: '此功能正在開發中，將在後續版本中實現',
    
    // 模態框
    selectWhatsAppTemplate: '選擇 WhatsApp 模板',
    selectEForm: '選擇 e-Form 表單',
    noTemplatesAvailable: '暫無可用的模板，請先創建模板',
    noUsersAvailable: '暫無可用的用戶，請先添加用戶',
    noEFormsAvailable: '暫無可用的 e-Form 表單，請先創建表單',
    internalTemplate: '內部模板',
    
    // Meta 模板相關
    metaTemplate: {
      title: 'Meta 官方模板',
      approved: '已審核',
      pending: '審核中',
      rejected: '已拒絕',
    },
    templateLibraryTab: '範本資料庫',
    templateLibrarySearchPlaceholder: '搜尋範本關鍵字',
    templateLibraryTopic: '主題',
    templateLibraryUsecase: '用途',
    templateLibraryIndustry: '行業',
    templateLibraryLanguage: '語言代碼',
    templateLibraryApplyFilters: '套用篩選',
    templateLibraryHint: '選擇後會向 Meta 提交建立至您的 WABA（含公司識別後綴）；通過審核後即可如一般 Meta 模板發送。',
    templateLibraryCatalog: '資料庫',
    templateLibraryLoadFailed: '無法載入範本資料庫',
    templateLibraryCreateFailed: '自範本資料庫建立失敗（若範本含按鈕，可能需在 Meta 後台補齊 URL／電話等）',
    templateLibraryEmpty: '沒有符合條件的範本',

    libTopic_ACCOUNT_UPDATE: '帳戶更新',
    libTopic_CUSTOMER_FEEDBACK: '客戶回饋',
    libTopic_ORDER_MANAGEMENT: '訂單管理',
    libTopic_PAYMENTS: '付款',

    libUsecase_ACCOUNT_CREATION_CONFIRMATION: '帳戶建立確認',
    libUsecase_AUTO_PAY_REMINDER: '自動付款提醒',
    libUsecase_DELIVERY_CONFIRMATION: '送達確認',
    libUsecase_DELIVERY_FAILED: '送達失敗',
    libUsecase_DELIVERY_UPDATE: '配送更新',
    libUsecase_FEEDBACK_SURVEY: '回饋問卷',
    libUsecase_FRAUD_ALERT: '詐騙警示',
    libUsecase_LOW_BALANCE_WARNING: '餘額不足警示',
    libUsecase_ORDER_CONFIRMATION: '訂單確認',
    libUsecase_ORDER_DELAY: '訂單延遲',
    libUsecase_PAYMENT_DUE_REMINDER: '付款到期提醒',
    libUsecase_SHIPMENT_CONFIRMATION: '出貨確認',
    libUsecase_TRANSACTION_ALERT: '交易警示',

    libIndustry_E_COMMERCE: '電子商務',
    libIndustry_FINANCIAL_SERVICES: '金融服務',

    libLang_af: '南非荷蘭語',
    libLang_sq: '阿爾巴尼亞語',
    libLang_ar: '阿拉伯語',
    libLang_az: '亞塞拜然語',
    libLang_bn: '孟加拉語',
    libLang_bg: '保加利亞語',
    libLang_ca: '加泰隆尼亞語',
    libLang_zh_CN: '簡體中文',
    libLang_zh_HK: '繁體中文（香港）',
    libLang_zh_TW: '繁體中文（台灣）',
    libLang_hr: '克羅埃西亞語',
    libLang_cs: '捷克語',
    libLang_da: '丹麥語',
    libLang_nl: '荷蘭語',
    libLang_en: '英語',
    libLang_en_GB: '英語（英國）',
    libLang_en_US: '英語（美國）',
    libLang_et: '愛沙尼亞語',
    libLang_fil: '菲律賓語',
    libLang_fi: '芬蘭語',
    libLang_fr: '法語',
    libLang_ka: '喬治亞語',
    libLang_de: '德語',
    libLang_el: '希臘語',
    libLang_gu: '古吉拉特語',
    libLang_ha: '豪薩語',
    libLang_he: '希伯來語',
    libLang_hi: '印地語',
    libLang_hu: '匈牙利語',
    libLang_id: '印尼語',
    libLang_ga: '愛爾蘭語',
    libLang_it: '義大利語',
    libLang_ja: '日語',
    libLang_kn: '卡納達語',
    libLang_kk: '哈薩克語',
    libLang_rw_RW: '盧安達語',
    libLang_ko: '韓語',
    libLang_ky_KG: '吉爾吉斯語',
    libLang_lo: '寮語',
    libLang_lv: '拉脫維亞語',
    libLang_lt: '立陶宛語',
    libLang_mk: '馬其頓語',
    libLang_ms: '馬來語',
    libLang_ml: '馬拉雅拉姆語',
    libLang_mr: '馬拉地語',
    libLang_nb: '挪威語',
    libLang_fa: '波斯語',
    libLang_pl: '波蘭語',
    libLang_pt_BR: '葡萄牙語（巴西）',
    libLang_pt_PT: '葡萄牙語（葡萄牙）',
    libLang_pa: '旁遮普語',
    libLang_ro: '羅馬尼亞語',
    libLang_ru: '俄語',
    libLang_sr: '塞爾維亞語',
    libLang_sk: '斯洛伐克語',
    libLang_sl: '斯洛維尼亞語',
    libLang_es: '西班牙語',
    libLang_es_AR: '西班牙語（阿根廷）',
    libLang_es_ES: '西班牙語（西班牙）',
    libLang_es_MX: '西班牙語（墨西哥）',
    libLang_sw: '史瓦希里語',
    libLang_sv: '瑞典語',
    libLang_ta: '坦米爾語',
    libLang_te: '泰盧固語',
    libLang_th: '泰語',
    libLang_tr: '土耳其語',
    libLang_uk: '烏克蘭語',
    libLang_ur: '烏爾都語',
    libLang_uz: '烏茲別克語',
    libLang_vi: '越南語',
    libLang_zu: '祖魯語',

    // 訊息模式
    directMessage: '直接輸入訊息',
    useTemplate: '使用模板',
    sendEmail: '發送郵件',
    
    // 郵件配置
    email: {
      provider: '郵件服務提供商',
      providerRequired: '請選擇郵件服務提供商',
      selectProvider: '選擇郵件服務提供商',
      noProviderConfigured: '未配置郵件服務提供商。請在 API 管理中添加。',
      subject: '郵件主題',
      subjectRequired: '請輸入郵件主題',
      subjectPlaceholder: '輸入郵件主題',
      body: '郵件內容',
      bodyRequired: '請輸入郵件內容',
      bodyPlaceholder: '輸入郵件內容（支持流程資料，如 ${variableName}；若為 JSON 類型可用 ${JsonName.JsonFieldName}）',
      bodyHelp: '您可以在郵件內容中使用流程資料。點擊上方的變量標籤即可插入。支持富文本格式（粗體、斜體、顏色等）。若流程資料為 JSON，可使用 ${JsonName.JsonFieldName} 格式讀取欄位。',
      insertReceivedMediaTokenButton: '已接收媒體',
      insertReceivedMediaTokenTitle: '插入已接收媒體連結 token',
      richTextToolbarBold: '粗體',
      richTextToolbarItalic: '斜體',
      richTextToolbarUnderline: '底線',
      richTextToolbarStrike: '刪除線',
      richTextToolbarHeader: '標題層級',
      richTextToolbarTextColor: '文字顏色',
      richTextToolbarBackgroundColor: '背景顏色',
      richTextToolbarOrderedList: '有序清單',
      richTextToolbarBulletList: '無序清單',
      richTextToolbarAlign: '對齊方式',
      richTextToolbarLink: '插入連結',
      richTextToolbarClean: '清除格式（移除粗體、顏色、連結等樣式）'
    },
    
    // 其他界面元素
    inDevelopment: '開發中',
    loadingWorkflow: '載入流程中…',
    clickToSelectConnection: '點擊選擇連接線',
    clickToChangeToTarget: '點擊切換為目標點',
    clickToChangeToSource: '點擊切換為源點',
    template: '模板',
    templateInfo: '模板信息',
    templatePreview: '模板預覽',
    templateContent: '模板內容',
    templatePreviewNoData: '無模板資料可預覽',
    templateId: '模板ID：',
    templateName: '模板名稱：',
    // 模板 Image/Document URL 配置
    templateImageUrl: '圖片 URL',
    templateDocumentUrl: '文件 URL',
    templateImageUrlPlaceholder: '例如：https://example.com/images/${InvoiceNo}.jpg',
    templateDocumentUrlPlaceholder: '例如：https://example.com/pdf/${InvoiceNo}.pdf',
    templateHeaderUrlHelp: '支持使用流程資料，例如：${InvoiceNo}。若為 JSON 類型可使用 ${JsonName.JsonFieldName}。運行時會自動替換為實際值。',
    templateImageSource: '圖片來源',
    templateImageSourceUrl: '使用 URL',
    templateImageSourceInstance: '使用流程實例圖片',
    templateImageSourceHelp: '選擇使用 URL 或當前流程實例文件夾中的圖片（自動排除 qr_scan_success_* 文件，如有多張圖片則使用最早的一張）。',
    templateDocumentFilename: '文件名稱',
    templateDocumentFilenamePlaceholder: '例如：${InvoiceNo}.pdf',
    templateDocumentFilenameHelp: '支持使用流程資料，例如：${InvoiceNo}。若為 JSON 類型可使用 ${JsonName.JsonFieldName}。運行時會自動替換為實際值。',
    formInfo: '表單信息',
    formId: '表單ID：',
    formName: '表單名稱：',
    formDescription: '描述：',
    
    // 默認值和提示
    enterValidContent: '請輸入有效內容',
    inputIncorrectRetry: '輸入不正確，請重新輸入',
    dateFormatExample: '例如：請輸入請假日期，格式：YYYY-MM-DD',
    formatExample: '例如：格式不正確，請重新輸入，例如：2024-01-15',
    tableExample: '例如: dbo.SoOrderManage',
    queryExample: '例如: WHERE status = \'PENDING\' AND created_at > @lastCheckTime',
    
    // 默認節點數據
    defaultStartNode: '開始',
    defaultEndNode: '結束',
    defaultSendWhatsAppNode: '發送訊息',
    defaultSendTemplateNode: '發送 WhatsApp 模板',
    defaultWaitReplyNode: '等待用戶回覆',
    defaultWaitForQRCodeNode: '等待 QR Code 掃描',
    defaultWaitForLocationNode: '請求地理位置',
    defaultLocationRequestBody: '請點選下方按鈕分享您的位置。',
    defaultWaitForEmailReplyNode: '等待 Email 回覆',
    defaultQRCodeMessage: '請上傳包含 QR Code 的圖片',
    defaultSwitchNode: '條件分支',
    defaultDataSetQueryNode: 'DataSet 查詢/更新',
    defaultCallApiNode: '觸發外部 API',
    defaultSendEFormNode: '發送 e-Form',
    defaultGenerateHtmlReportNode: '產生 HTML 報表',
    defaultGenerateDocumentNode: '產生文件',
    defaultEFormResultNode: 'e-Form 核准/拒絕',
    
    // 驗證訊息
    defaultReplyMessage: '請輸入您的回覆',
    defaultValidationPrompt: '請輸入有效內容',
    defaultRetryMessage: '輸入不正確，請重新輸入',
    
    // 註釋說明
    specifiedUsersComment: '指定人員的電話號碼，用逗號分隔',
    scheduledIntervalComment: '5分鐘',
    
    // 狀態和其他標籤
    statusEnabled: '啟用',
    statusDisabled: '停用',
    designer: '設計者',
    functionDescription: '功能說明',
    
    // 錯誤訊息
    saveFailed: '保存失敗',
    updateFailed: '更新失敗',
    createFailed: '創建失敗',
    getTemplatesFailed: '獲取模板列表失敗',
    unknownError: '未知錯誤',
    
    // 驗證錯誤訊息
    missingStartNode: '缺少開始節點 (Start)',
    missingEndNode: '缺少結束節點 (End)',
    noConnections: '沒有連接線',
    circularConnection: '發現循環連接：節點 "{nodeName}" 參與循環',
    isolatedNodes: '發現孤立節點：{nodeNames}',
    startNodeNoOutput: '開始節點 "{nodeName}" 沒有輸出連接',
    endNodeNoInput: '結束節點 "{nodeName}" 沒有輸入連接',
    
    // 節點類型說明
    nodeDescriptions: {
      start: '流程的開始點，只能有一個',
      end: '流程的結束點，可以有多個',
      waitReply: '等待用戶回覆的節點',
      sendMessage: '發送訊息給用戶的節點',
      condition: '根據條件決定流程方向的節點',
      form: '顯示表單給用戶填寫的節點',
      webhook: '調用外部 API 的節點'
    },
    // 節點配置說明
    nodeConfigDescriptions: {
      waitReply: '1. 流程執行到此節點時會暫停等待用戶回覆\n2. 只有指定的用戶回覆才會繼續執行流程',
      sendMessage: '1. 發送訊息給用戶\n2. 可以包含文字、圖片、文件等\n3. 支援變數替換',
      condition: '1. 根據條件決定下一步流程\n2. 支援多個分支\n3. 可以根據用戶輸入、時間等條件判斷',
      form: '1. 顯示表單給用戶填寫\n2. 支援多種表單類型\n3. 表單提交後會觸發後續流程',
      webhook: '1. 調用外部 API\n2. 可以發送數據到其他系統\n3. 根據 API 回應決定流程方向'
    },
    
    // sendEForm 節點相關翻譯
    sendEForm: {
      promptMessagePlaceholder: '輸入提示訊息，提醒用戶填寫表單前需要了解的信息',
      sendNotificationToRecipients: '發送通知給收件人',
      sendNotificationToRecipientsHelp: '關閉時僅填表不發送通知（收件人與通知訊息無需設置）。手動填表模式必須為開啟。',
      sendNotificationOn: 'On',
      sendNotificationOff: 'Off',
      notificationMessage: '通知訊息內容',
      notificationMessagePlaceholder: '請輸入通知訊息內容，可使用 {formName} 和 {formUrl} 變量',
      notificationMessageHelp: '支援的變量：{formName} - 表單名稱，{formUrl} - 表單連結',
      defaultNotificationMessage: '您的{formName}已準備就緒，請點擊以下鏈接填寫：\n\n{formUrl}',
      customMessage: '自定義訊息',
      useDefaultMessage: '使用預設訊息',
      messageTemplate: '訊息模板',
      messageTemplatePlaceholder: '請輸入訊息模板',
      variablePlaceholder: '變量佔位符',
      formNameVariable: '表單名稱變量',
      formUrlVariable: '表單連結變量',
      
      // 表單填充模式
      fillMode: '表單填充模式',
      integrateWaitReply: '整合等待用戶回覆節點 (AI 填表)',
      integrateDataSetQuery: '整合 DataSet Query 節點 (數據填表)',
      integrateEmailStart: '整合 Email 監看 (AI 填表)',
      integrateEmailStartDesc: '承接開始節點由 Email 監控觸發時收到的郵件內容與附件，使用 AI 智能填充表單；無需 waitReply 節點。',
      integrateManualStart: '整合已發布應用手動觸發 (AI 填表)',
      integrateManualStartDesc: '承接「已發布應用」手動觸發時輸入的訊息與附件（與 Email 監看相同資料結構），使用 AI 填表；請搭配手動觸發流程使用。',
      integrateEForm: '整合上游 eForm 節點 (用已填好的表單資料)',
      integrateEFormDesc: '承接畫布上指定的 sendEForm 節點所產生的表單實例；同一節點若使用多筆模式（multiFormMode=multi）會把所有實例的欄位一併彙總後送給 AI。',
      selectUpstreamEFormNode: '上游 sendEForm 節點',
      selectUpstreamEFormNodePlaceholder: '選擇要整合的 sendEForm 節點…',
      selectUpstreamEFormNodeHelp: '指向同一流程中已執行完成的 sendEForm 節點；其表單實例（FilledHtmlCode）解析出的欄位會作為 AI 的輸入資料。多筆模式時會逐張彙總所有實例。',
      noUpstreamEFormNode: '畫布上沒有 sendEForm 節點；請先新增 sendEForm 節點。',
      integrateChatBot: '整合 Chatbot 節點 (AI 填表)',
      integrateChatOrderingCart: '整合 Chatbot 購物車節點 (AI 填表)',
      selectUpstreamWaitReplyNode: '指定上游 waitReply 節點',
      selectUpstreamWaitReplyNodePlaceholder: '選擇 waitReply 節點（留空=最後一筆）…',
      selectUpstreamWaitReplyNodeHelp: '選擇特定 waitReply 節點的回覆（含圖片／文件）作為 AI 輸入資料。留空則自動取本次執行中最後一筆有效回覆。',
      noUpstreamWaitReplyNode: '畫布上沒有 waitReply 節點',
      selectUpstreamChatBotNode: '指定上游 Chatbot 節點',
      selectUpstreamChatBotNodePlaceholder: '選擇 Chatbot 節點（留空=最新 session）…',
      selectUpstreamChatBotNodeHelp: '選擇特定 Chatbot 節點的對話記錄作為 AI 輸入資料。留空則自動取本次執行中最近更新的 Chatbot session。',
      noUpstreamChatBotNode: '畫布上沒有 Chatbot 節點',
      selectUpstreamChatOrderingCartNode: '指定上游 Chatbot 購物車節點',
      selectUpstreamChatOrderingCartNodePlaceholder: '選擇 Chatbot 購物車節點（留空=最新 session）…',
      selectUpstreamChatOrderingCartNodeHelp: '選擇特定 Chatbot 購物車節點的下單對話記錄作為 AI 輸入資料。留空則自動取本次執行中最近更新的購物車 session。',
      noUpstreamChatOrderingCartNode: '畫布上沒有 Chatbot 購物車節點',
      integrateEmailStartSendToAi: '傳給 AI 的內容',
      integrateEmailStartSendToAiHelp: '選擇傳給 AI 填表的數據來源：僅附件、僅 email 內文、或兩者都傳。',
      integrateEmailStartSendToAiAttachment: '僅附件',
      integrateEmailStartSendToAiBody: '僅 email 內文',
      integrateEmailStartSendToAiBoth: '兩者都傳',
      integrateManualStartSendToAiHelp: '選擇傳給 AI 的數據來源：僅附件、僅手動觸發時輸入的訊息（用戶啟動信息）、或兩者都傳。',
      integrateManualStartSendToAiBody: '僅 用戶啟動信息',
      manualFill: '手動填表 (獨立運行)',
      exclusiveModeLabel: '獨立模式（互斥）',
      aiSourceLabel: 'AI 資料來源（可多選）',
      emailAndManualBothWarning: 'Email 監看與手動觸發同屬啟動觸發器，同一流程只有一種，建議只選其中一個。',
      multiSourceDesc: '多個 AI 來源將合併後一併送給 AI，各來源資料以區塊標示。',

      // eForm 結果模式
      resultMode: 'eForm 結果模式',
      singleResult: '單個 eForm 結果',
      multiResult: '容許多於一個 eForm 結果（兩層分析）',
      singleResultDesc: '單個結果：AI 直接填充一份表單。',
      multiResultDesc: '多個結果：AI 先分析出多份表單，再逐一填充。',
      multiResultNotice: '此模式會增加 AI 呼叫次數，請留意成本與時間。',
      
      // 模式說明
      modeDescription: '模式說明',
      integrateChatBotDesc: '使用上游 Chatbot 節點的對話記錄（含圖片／附件）作為 AI 填表的輸入資料',
      integrateChatOrderingCartDesc: '使用上游 Chatbot 購物車節點的下單對話記錄（含圖片／附件）作為 AI 填表的輸入資料',
      integrateWaitReplyDesc: '承接前一個 waitReply 節點的自然語言回覆，使用 AI 智能填充表單',
      integrateDataSetQueryDesc: '使用指定 DataSet Query 節點的查詢結果數據，直接映射到表單欄位',
      manualFillDesc: '發送空白表單給用戶自行填寫，無需依賴其他節點。系統會自動將表單字段值（字段名稱需與流程資料名稱匹配）複製到流程資料中',
      
      // DataSet Query 選擇
      selectDataSetQueryNode: '選擇 DataSet Query 節點',
      selectDataSetQueryNodePlaceholder: '選擇要整合的 DataSet Query 節點',
      
      // Additional Prompt 和 JSON Result Variable 配置
      fillFormAdditionalPrompt: '額外 Prompt（填表指示）',
      fillFormAdditionalPromptHelp: '用於指示 AI 如何理解數據來源並填充表單，特別是在多筆模式中，此指示會用於規劃多個表單',
      fillFormAdditionalPromptPlaceholder: '例如：數據來源的明細表，會是有不同公司名、不同地址，原因他是在明細內看送貨要到那處，所以請你正確理解，每一個明細其實就是一張單獨的送貨單 delivery note',
      additionalPrompt: '額外 Prompt（JSON 生成指示）',
      additionalPromptHelp: '用於指示 AI 如何用同一組數據源（用戶輸入的文字/圖片/文件）來生成 JSON，方便之後的 dataset 節點用 insert / update 時可以選用 json 來插記錄',
      additionalPromptPlaceholder: '例如：請將提取的數據生成以下格式的 JSON：\n{\n  "date": "2017-04-25",\n  "time": "18:27",\n  "amount": 1500.00,\n  "currency": "HKD",\n  "fromAccount": "661-050***-292",\n  "toAccount": "619-034457-888",\n  "toAccountName": "HUNG C** W**",\n  "reference": "5BCO"\n}',
      jsonResultVariable: 'JSON 結果流程資料',
      jsonResultVariableHelp: '選擇一個 JSON 類型的流程資料來存儲 AI 生成的 JSON 數據',
      jsonResultVariablePlaceholder: '選擇 JSON 類型的流程資料',
      jsonResultAiSuggestionVariable: 'AI 建議流程資料',
      jsonResultAiSuggestionVariablePlaceholder: '選擇 text 或 string 類型流程資料',
      jsonResultAiSuggestionVariableHelp: '當 AI 在 JSON 物件中回傳 suggestion 欄位（與驗證節點語意相同）時，於 JSON 擷取寫入後一併寫入此變數。僅 text/string。',
      jsonResultAiFailReasonVariable: 'AI 失敗原因流程資料',
      jsonResultAiFailReasonVariablePlaceholder: '選擇 text 或 string 類型流程資料',
      jsonResultAiFailReasonVariableHelp: '當 AI 在 JSON 物件中回傳 reason 欄位時寫入此變數。僅 text/string（非 json）。',
      knowledgeBaseEnabled: 'Dataset 作為知識庫',
      knowledgeBaseEnabledHelp: '啟用後，執行時會先依條件查詢指定 Dataset，將結果 JSON 一併傳給 AI，便於將 Email／WhatsApp 內容對照主檔（如產品代碼、名稱）再填表。',
      knowledgeBaseHint: '執行時會將查詢結果以 JSON 傳給 AI（條件編輯與 DataSet Query 節點相同）。資料量大時請用查詢條件縮小範圍。',
      knowledgeBaseDataSet: '知識庫 Dataset',
      knowledgeBaseQueryConditions: '查詢條件',
      
      // MetaFlows 專用配置
      flowHeader: '標題',
      flowHeaderPlaceholder: '請輸入 Flow 消息的標題（例如：請填寫表單）',
      flowBody: '內容',
      flowBodyPlaceholder: '請輸入 Flow 消息的主體內容（例如：請點擊下方按鈕開始填寫表單）',
      flowCta: '按鈕文字',
      flowCtaPlaceholder: '請輸入按鈕文字（例如：填寫表單）',
      flowTemplateModeTitle: 'Meta Flow Template 變量配置',
      flowTemplateModeHint: 'Template 的標題、內文、按鈕文字已於建立時固定，無法在此 override。下方逐項對應 {{1}} {{2}} ... placeholder 到流程資料；如需修改文字內容請至 MetaFlows 表單頁重建 Flow Template。',
      flowTemplateNotBuiltHint: '此表單尚未建立 Flow Template（或建立失敗）。請至 MetaFlows 表單頁觸發建立後再回此節點配置變量；以下變量映射會在 Template 建好後生效。',
      flowTemplateLegacyHint: '此表單目前的 Flow Template 為舊格式（無 {{N}} placeholder），下方變量映射不會生效。請至 MetaFlows 表單頁重建 Flow Template，並在 BODY 中加入 {{1}} {{2}} ... 才能注入流程資料。',
      metaFlowsManualFillOnly: 'Meta Flows 表單僅支持手動填表模式',
      noDataSetQueryNodes: '暫無可用的 DataSet Query 節點',
      dataSetQueryNodeHelp: '只有操作類型為 SELECT 的 DataSet Query 節點才會顯示在此列表中',
      aiProvider: 'AI 提供商',
      aiProviderPlaceholder: '選擇用於解析用戶自然語言輸入的 AI 提供商',
      aiProviderRequired: '請為 AI 自動填寫模式選擇 AI 提供商',
      
      // 依賴檢查
      dependencyCheck: '依賴檢查',
      waitReplyDependency: '需要前一個節點為 waitReply',
      dataSetQueryDependency: '需要指定的 DataSet Query 節點已完成執行',
      noDependency: '無需依賴其他節點',
      
      // 警告信息
      warningNoWaitReply: '警告：前一個節點不是 waitReply，無法使用 AI 填充功能',
      warningNoDataSetQuery: '警告：找不到指定的 DataSet Query 節點或查詢結果',
      warningInvalidMode: '警告：選擇的填充模式與流程結構不匹配',
      
      // 審批設置
      approvalSettingDescription: 'eForm 可以設置為是否需要審批。如果選擇「是」，流程將等待用戶回覆；如果選擇「否」，表單提交後將立即自動設為已審批。',
      requireApproval: '需要審批',
      approveButtonLabel: 'Approve 顯示名稱',
      approveButtonLabelPlaceholder: '例如：通過、WON（留空使用預設名稱）',
      rejectButtonLabel: 'Reject 顯示名稱',
      rejectButtonLabelPlaceholder: '例如：不通過、LOST（留空使用預設名稱）'
    },
    artifact: {
      generationMode: '生成資料來源',
      documentFormat: '輸出格式',
      storageKind: '儲存位置',
      storageLocal: 'WhatoFlow 本機',
      comingSoon: '即將推出',
      sendNotification: '發送通知給收件人',
      reportNameVariable: '報表名稱（對應任務名稱）',
      reportUrlVariable: '報表連結（登入後可開啟的完整 URL）',
      docNameVariable: '文件名稱',
      docUrlVariable: '文件頁面連結（登入後可下載，完整 URL）',
      defaultHtmlReportNotification: '您的報表「{reportName}」已產生，請登入後開啟：\n\n{reportUrl}',
      defaultDocumentNotification: '您的文件「{docName}」已產生，請登入後下載：\n\n{docUrl}',
      knowledgeBaseEnabled: 'Dataset 作為知識庫',
      knowledgeBaseEnabledHelp: '啟用後，產生 HTML 報表或 Office 文件前會先依條件查詢指定 Dataset，將列資料以 JSON 附加於 AI 系統提示，便於對照主檔（如產品、客戶代碼）生成內容。',
      knowledgeBaseHint: '查詢結果會以 JSON 傳給 AI（條件編輯與 DataSet Query 節點相同）。資料量大時請用查詢條件縮小範圍。',
      attachmentBatchMode: '附件送 AI 範圍',
      attachmentBatchModeHelp: '多個附件時：「全部」會依序轉檔並合併送 AI；「僅第一個」只處理清單中第一個路徑（省 token）。與 eForm「多筆結果／多張表單」不同。',
      attachmentBatchModeAll: '全部附件',
      attachmentBatchModeFirst: '僅第一個附件',
      attachmentAiInputFormat: '輸入格式',
      attachmentAiInputFormatHelp: '限定送 AI 的附件副檔名：先依此篩選，再套用「附件送 AI 範圍」。篩後為空則節點失敗。',
      attachmentAiInputFormatAny: '不篩選',
      documentFormatPdfHelp: '以輸入的 PDF（或 Office 檔）為範本：經 LibreOffice 轉為 FODG 交 AI 填寫後再匯出 PDF；多個輸入會一對一產出多份，並各自發送通知。',
      embeddedImages: '嵌入圖片',
      embeddedImageDesc: '常用於公司蓋章、授權人簽名等需印在文件上的圖片。上傳後在「額外填表指示」中寫明使用哪張圖及放置位置，AI 會自動將圖片嵌入對應欄位。',
      embeddedImageUpload: '上傳圖片',
      embeddedImageHint: '支援 jpg/png/gif/bmp/webp/svg；在「額外填表指示」中用圖片名稱指定插入位置',
      embeddedImageName: '圖片名稱（在 prompt 中引用）',
      embeddedImageEmpty: '尚未上傳任何圖片',
      embeddedImageNoWorkflowId: '請先儲存流程定義後再上傳圖片',
      embeddedImageInvalidType: '只支援 jpg/png/gif/bmp/webp/svg 格式',
      embeddedImageUploaded: '圖片上傳成功',
      embeddedImageUploadFailed: '圖片上傳失敗'
    },
    // 流程啟動人選項
    initiatorOptions: {
      initiator: '流程啟動人',
      anyUser: '任何用戶',
      specificUser: '指定用戶'
    },
    
    // 缺少的翻譯鍵
    conditionLabel: '條件標籤',
    conditionLabelPlaceholder: '請輸入條件標籤（可選）',
    cancel: '取消',
    add: '添加',
    selectDefaultPath: '選擇默認路徑',
    defaultPath: '默認路徑',
    defaultPathDescription: '當所有條件群組都不滿足時，將執行此默認路徑',
    conditionValuePlaceholder: '請輸入條件值',
    
    // 新增的高級功能翻譯鍵
    copyNodes: '複製節點',
    pasteNodes: '貼上節點',
    paste: '貼上',
    align: '對齊',
    alignNodes: '對齊節點',
    alignLeft: '左對齊',
    alignCenter: '居中對齊',
    alignRight: '右對齊',
    alignTop: '頂部對齊',
    alignMiddle: '垂直居中',
    alignBottom: '底部對齊',

    multiSelectHintTitle: '小提示',
    multiSelectHint: '按住 {key} 鍵 + 點擊節點即可多選，再用上方對齊按鈕即可批次對齊',
    gotIt: '知道了',

    unsavedChangesTitle: '有未保存的變更',
    unsavedChangesContent: '流程內容已變更尚未保存，是否要保存？',
    saveAndLeave: '保存並離開',
    leaveWithoutSaving: '不保存並離開',
    cancel: '取消',
    
    // 節點類型標籤
    sendEFormNode: '發送 e-Form',
    generateHtmlReportNode: '產生 HTML 報表',
    generateDocumentNode: '產生文件',
    calendarNode: '日曆',
    defaultCalendarNode: '日曆排程',
    calendar: {
      generationMode: '資料來源整合模式',
      additionalPrompt: '附加 Prompt（用於指示 AI 如何排期）',
      additionalPromptPlaceholder: '例如：每月第 2 週週三上午 9:00 安排例行檢查工程',
      fillCalendarAdditionalPrompt: '填充日曆附加 Prompt',
      fillCalendarAdditionalPromptPlaceholder: '例如：請依據合約期間，逐月展開為具體事件',
      calendarCommandVariable: '保存指令 JSON 至流程資料',
      defaultWorkflowDefinitionLinkage: '事件預設關聯到目前流程定義',
      dryRun: '只驗證不寫入（Dry Run）',
      failOnValidationError: '指令驗證失敗時整體失敗',
      manualStartInputMode: '手動觸發資料來源',
      manualStartInputModeBody: '使用觸發 InputJson',
      manualStartInputModeAttachment: '使用觸發附件',
      manualStartInputModeBoth: '兩者皆使用',
      // 兩段式 AI：分析視窗與現況快照
      snapshotSection: '分析視窗與現況快照',
      snapshotHelp: '兩段式 AI：第一輪解析分析視窗 from/to/timezone，後端依視窗 + 同流程定義範圍撈出既有事件快照，第二輪 AI 才依快照避免衝突地產生 commands。',
      disableTwoStage: '停用兩段式 AI（直接用預設視窗）',
      windowDefaults: '預設分析視窗（AI 沒給時 fallback）',
      windowMaxes: '分析視窗最大允許範圍',
      analysisLookBackDaysDefault: '預設向前回看天數（from = 現在 - N 天）',
      analysisLookAheadDaysDefault: '預設向後展望天數（to = 現在 + N 天）',
      analysisLookBackDaysMax: '最大向前回看天數',
      analysisLookAheadDaysMax: '最大向後展望天數',
      snapshotLimits: '快照大小限制',
      snapshotMaxEvents: '快照事件上限',
      snapshotMaxEventsHelp: '超過上限時只送 perDayCount 統計（不送 events 陣列），避免 token 爆量。',
      snapshotIncludeEvents: '包含事件詳情（events 陣列）',
      snapshotIncludeEventsHelp: '關閉時只送每日數量統計（perDayCount），最省 token。',
      resourceContactRefs: '資源人員識別符',
      resourceContactRefsHelp: '每行（或逗號分隔）一個識別符，系統嘗試比對系統 Contact。\n• 電話號碼（如 85296366318）\n• Email（如 user@example.com）\n• {{initiator}} — 自動使用流程啟動人\n\n比對成功 → 加入事件「資源」欄位；找不到 → 在事件「說明」末尾補充提示，不影響事件建立。',
      resourceContactRefsPlaceholder: '每行一個，例如：\n85296366318\nuser@example.com\n{{initiator}}',
      defaultEventTypeRef: '預設日曆類型名稱',
      defaultEventTypeRefsHelp: '填寫系統已建立的日曆類型名稱（完整比對）。\n• AI 指令未指定 eventTypeId 時，後端自動以此名稱查找並注入。\n• AI 已在 additional prompt 中明確指定類型時，優先採用 AI 的選擇。\n• 找不到對應類型 → 不報錯，eventTypeId 留空或由 AI 決定。\n• 所有可用類型名稱會自動注入 AI context，方便在 additional prompt 中按名稱指定。',
      defaultEventTypeRefPlaceholder: '例如：假期申請',
    },
    odooNode: 'Odoo',
    defaultOdooNode: 'Odoo ERP',
    odoo: {
      tabData: '操作',
      tabMode: '生成模式',
      tabMapping: '欄位對應',
      tabResult: '結果與行為',
      intro: 'Odoo 19 ERP 整合：請先在 API Provider Management → ERP 系統 加入 odoo provider 並啟用後再使用。',
      apiProviderKey: 'Odoo Provider',
      apiProviderKeyTip: '對應 API Provider Management → ERP 系統 → odoo；多 Odoo 環境可改成其他 provider key。',
      operationType: '操作類型',
      generationMode: '生成模式',
      modeFormBased: 'Form 模式（手動欄位對應）',
      defaultCompanyId: '預設公司 ID',
      defaultCompanyIdTip: '多公司情境下強制 Odoo context.allowed_company_ids；單公司可留空。',
      autoConfirm: '建立後自動 button_confirm',
      autoPost: '建立後自動 action_post',
      autoValidate: '建立後自動 button_validate',
      autoValidateTip: '需要庫存可用，否則建議保持關閉，由人手在 Odoo 確認。',
      mappingHelp: 'Form 模式：把 Process Variable / 靜態值 / Expression 對應到 OdooOperation 欄位（例 partner.name、lines[0].product.code、lines[0].qty）。',
      mappingHelpForm: 'Form 模式：上游 sendEForm 欄位 / Process Variable / 靜態值對應到 Odoo 欄位（partner.id、partner.name、lines[0].product.code、lines[0].qty…）；mappedFields 為空則 fallback AI。',
      mappingHelpDataSet: 'DataSet 模式：scope=master 取第一筆 row，scope=line 每筆 row 產生一筆 lines[]；mappedFields 為空則 fallback AI。',
      mappingEmptyHint: '尚未設定任何 mapping，將以 AI 解析整批內容（不確定欄位請優先用對應而非 prompt）。',
      mappingOdooField: 'Odoo 欄位路徑',
      mappingSourceType: '來源',
      mappingSourceValue: '值',
      mappingAdd: '新增欄位對應',
      scope: 'Scope',
      scopeMaster: 'master',
      scopeLine: 'line',
      sourceEFormField: 'eForm 欄位',
      sourceDatasetColumn: 'DataSet 欄',
      sourceVariable: '流程資料',
      sourceStatic: '靜態值',
      sourceExpressionLegacy: 'Expression（已棄用）',
      sourceEFormFieldPlaceholder: '選 eForm 欄位…',
      sourceDatasetColumnPlaceholder: '選 DataSet 欄…',
      sourceVariablePlaceholder: '選流程資料…',
      sourceStaticPlaceholder: '輸入靜態值',
      expressionDeprecatedTag: '已棄用',
      selectUpstreamEForm: '上游 sendEForm 節點',
      selectUpstreamEFormTip: '指向已填好的 eForm instance；其欄位用作 mapping value 來源。',
      selectUpstreamEFormPlaceholder: '選擇上游 sendEForm…',
      noUpstreamEForm: '畫布上沒有 sendEForm 節點；請先新增並指定 formId。',
      schemaPanelMissing: '此 operation 尚無 cheat-sheet',
      schemaPath: '路徑 / 標籤',
      schemaTip: '說明',
      schemaMaster: 'Master 欄位',
      schemaLines: 'Line 欄位（每筆 row 重複）',
      schemaFk: 'FK 參照',
      schemaExample: '範例 JSON',
      schemaTips: '注意事項',
      requiredTag: '必填',
      fkTag: 'FK',
      promptFieldPickerButton: '插入 Odoo 欄位',
      promptFieldPickerInsert: '插入到游標位置',
      promptFieldPickerInsertBtn: '加入',
      promptFieldPickerSearch: '搜尋路徑 / 標籤…',
      promptFieldPickerMaster: 'Master',
      promptFieldPickerLines: 'Lines',
      promptFieldPickerFk: 'FK 參照',
      promptFieldPickerSchema: '完整 Schema',
      promptFieldPickerEmpty: '無欄位',
      promptFieldPickerNoProvider: '需設定 Odoo Provider Key 才能載入完整 schema',
      promptFieldPickerSchemaEmpty: 'fields_get 為空',
      commandVariable: '保存指令 JSON 至流程資料',
      commandVariableTip: '可選；存放最終丟給 Odoo 的 commands JSON 字串。',
      resultVariable: '保存 Odoo 執行結果至流程資料',
      resultVariableTip: '存放 OdooCommandExecutionReport（含每筆 doc id / state）。',
      fillOdooAdditionalPrompt: '填充 Odoo 附加 Prompt',
      fillOdooAdditionalPromptPlaceholder: '例：請從 PDF 解析供應商名稱、SKU 與 5 筆 line items',
      op: {
        createPO: '建立採購訂單（PO）',
        createQuotation: '建立報價單（draft SO）',
        createSO: '建立並確認銷售單（SO）',
        confirmSO: '確認銷售單',
        createInvoice: '建立發票（INV）',
        postInvoice: '過帳發票',
        createDeliveryNote: '建立出貨單（DN）',
        createGoodsReceive: '建立收貨單（GR）',
        createReturn: '建立退貨',
        createCreditNote: '建立信用備忘錄',
        registerPayment: '登記付款',
        lookupPartner: '查詢客戶／供應商',
        lookupProduct: '查詢產品',
        lookupStock: '查詢庫存'
      }
    },
    
    // 流程資料格節點
    processDataCellNode: '流程資料格操作',
    defaultProcessDataCellNode: '整理流程資料',
    processDataCell: {
      title: '賦值規則',
      addRule: '新增規則',
      mode: '操作',
      modeCopyPv: '複製資料',
      modeFixedValue: '填入固定值',
      modeJsonToPv: '從 JSON 取值',
      modePvToJson: '寫入 JSON',
      modeAi: 'AI 智能填寫',
      sourceVariable: '來源流程資料',
      sourceVariablePlaceholder: '選擇來源流程資料',
      sourceJsonKey: '來源 JSON 欄位名',
      sourceJsonKeyPlaceholder: '例：Estate_Name',
      targetVariable: '目標流程資料',
      targetVariablePlaceholder: '選擇目標流程資料',
      targetJsonKey: '目標 JSON 欄位名',
      targetJsonKeyPlaceholder: '例：Estate_Name',
      fixedValue: '固定值',
      fixedValuePlaceholder: '輸入固定值，可用 ${variableName}',
      jsonFieldMappings: 'JSON 欄位對應',
      jsonFieldMappingsAdd: '新增 JSON 欄位',
      jsonKey: 'JSON 欄位名',
      jsonKeyPlaceholder: '例：Estate_Name',
      valueSource: '值來源',
      valueSourcePv: '流程資料',
      valueSourceFixed: '固定值',
      noRules: '尚無賦值規則，點擊「新增規則」開始',
      ruleLabel: '第 {index} 條規則',
      aiSources: 'AI 資料來源',
      aiAdditionalPrompt: 'JSON 生成 Prompt',
      aiAdditionalPromptPlaceholder: '告訴 AI 要從對話中提取哪些資料，並以 JSON 格式回傳',
      aiOutputVariable: '寫入目標流程資料',
      aiOutputVariablePlaceholder: '選擇流程資料（text 或 json 型）',
      modeEFormToPv: '從 eForm 取值',
      eFormNode: 'eForm 節點',
      eFormNodePlaceholder: '選擇上游 sendEForm 節點',
      eFormFieldName: 'eForm 欄位',
      eFormFieldNamePlaceholder: '例：Estate_Name（與表單 input name 一致）',
      eFormFieldsNotLoaded: '欄位清單未載入，請確認 eForm 節點已設定表單 ID，或手動輸入欄位名稱',
      multiInstanceMode: '多張表單時的處理方式',
      multiInstanceFirst: '取第一張',
      multiInstanceLast: '取最後一張',
      multiInstanceJoin: '全部合併（文字）',
      multiInstanceAllJson: '全部寫成 JSON 陣列',
      joinSeparator: '連接符號',
      validationNoMode: '請選擇操作類型',
      validationNoSource: '請選擇來源',
      validationNoTarget: '請選擇目標',
    },

    // Switch 節點相關翻譯鍵
    switchConditions: '條件設置',
    editConditionGroup: '編輯條件群組',
    groupRelation: '群組關係',
    groupRelationRequired: '請選擇群組關係',
    outputPath: '輸出路徑',
    outputPathRequired: '請選擇輸出路徑',
    selectOutputPath: '選擇輸出路徑',
    conditions: '條件',
    noConditions: '暫無條件',
    addCondition: '添加條件',
    update: '更新',
    editCondition: '編輯條件',
    selectProcessVariable: '選擇流程資料',
    selectProcessVariableRequired: '請選擇流程資料',
    noProcessVariables: '暫無流程資料',
    noProcessVariablesHint: '請先在流程資料管理中創建流程資料',
    operator: '運算符',
    operatorRequired: '請選擇運算符',
    equals: '等於',
    notEquals: '不等於',
    greaterThan: '大於',
    lessThan: '小於',
    contains: '包含',
    isEmpty: '為空',
    isNotEmpty: '不為空',
    conditionValue: '條件值',
    conditionValueRequired: '請輸入條件值',
    jsonPvMapping: 'JSON 流程資料映射',
    jsonKeyPlaceholder: '請輸入 JSON 鍵名（例如：amount、status、date）',
    jsonKeyDescription: '當流程資料為 JSON 類型時，請輸入要提取的 JSON 鍵名。系統會從 JSON 物件中提取該鍵對應的值再與條件值比對。支援以 "." 分隔的巢狀鍵，例如 "order.amount"。',
    
    // Switch 節點新 UI 翻譯鍵
    conditionGroups: '條件群組',
    conditionGroup: '條件群組',
    addConditionGroup: '添加條件群組',
    clickToSelectDefaultPath: '點擊選擇默認路徑',
    
    // QR Code 節點翻譯鍵
    qrCodeVariable: 'QR Code 變量',
    qrCodeMessagePlaceholder: '請輸入提示訊息，例如：請上傳包含 QR Code 的圖片',
    qrCodeAiValidatorPromptHelp: 'AI 將驗證 QR Code 圖像解析出來的「QR Code 變量」中的值是否符合要求。請描述驗證規則，例如「QR Code 內容必須是 6 位數字驗證碼」。',
    qrCodeAiValidatorPromptPlaceholder: '描述 QR Code 變量值需要滿足的驗證條件，例如「QR Code 內容必須是 6 位數字驗證碼」。',
    qrCodeDescription1: '此節點會等待用戶上傳包含 QR Code 的圖片',
    qrCodeDescription2: '系統會自動掃描圖片中的 QR Code 並提取內容',
    qrCodeDescription3: '掃描結果會保存到指定的流程資料中，供後續節點使用',
    waitForLocationHint: '先選擇 Meta 模板（用於開啟客服視窗），再設定「請分享位置」的說明文字。',
    waitForLocationPromptMessageHelp: '在用戶分享位置前，系統會依下方設定發送提示（直接訊息或模板）；接著再發送「請分享位置」互動訊息。',
    locationRequestBody: '位置請求說明文字',
    locationRequestBodyPlaceholder: '顯示在「請分享位置」互動訊息（最多 1024 字）',
    locationRequestBodyRequired: '請填寫位置請求說明文字',
    locationResultVariable: '位置 JSON 流程資料',
    waitForLocationDesc1: '提示訊息可選「直接輸入」或「使用模板」（與等待回覆相同），之後系統會再發送「請分享位置」互動訊息；用戶分享位置後，座標與地址會寫入所選流程資料（JSON）。',
    waitForLocationDesc2: '需在客服視窗內發送；通常須先以模板開啟對話。',
    qrCodeSuccessMessage: 'QR Code 成功訊息',
    qrCodeErrorMessage: 'QR Code 錯誤訊息',
    waitReplySuccessMessage: '等待回覆成功訊息',
    waitReplyErrorMessage: '等待回覆錯誤訊息',
    waitReplySuccessMessagePlaceholder: '輸入驗證成功時發送的訊息',
    waitReplyErrorMessagePlaceholder: '輸入驗證失敗時發送的訊息',
    
    // 通用翻譯
    yes: '是',
    no: '否'
  },

  // 文檔中心
  documentLibrary: {
    treeTitle: '文檔目錄',
    collapseTree: '收合目錄',
    expandTree: '展開文檔目錄',
    resizeTree: '拖曳調整目錄寬度',
    clearLocationFilter: '清除位置篩選',
    noData: '暫無資料',
    searchPlaceholder: '搜尋文件名稱、PV 值、表單欄位、使用者…',
    filterType: '類型',
    filterUser: '使用者',
    filterModifiedDate: '修改日期',
    typeEForm: '表單 eForm',
    typeDoc: '文件 Doc',
    typeReport: '報表 Report',
    totalDocuments: '共 {count} 份文件',
    totalRows: '共 {count} 筆',
    noDocuments: '暫無文件',
    loadMore: '載入更多',
    colThumbnail: '縮圖',
    colNameKeyValues: '名稱 / 關鍵值',
    noPreviewImage: '無預覽圖',
    colWorkflow: '流程',
    colUser: '使用者',
    colStatus: '狀態',
    colUpdated: '更新',
    colActions: '操作',
    definitionFallback: '定義 #{id}',
    executionLabel: '執行 #{id}',
    open: '開啟',
    download: '下載',
    emptyValue: '—',
    datePresetToday: '今天',
    datePreset7d: '過去 7 天',
    datePreset30d: '過去 30 天',
    datePresetThisYear: '今年',
    datePresetLastYear: '去年',
    treeEFormCount: 'eForm×{count}',
    treeDocCount: 'Doc×{count}',
    treeReportCount: 'Report×{count}',
    errorTreeLoad: '載入目錄樹失敗',
    errorSearch: '搜尋失敗',
    statusApproved: '已核准',
    statusCompleted: '已完成',
    statusRejected: '已拒絕',
    statusPending: '待處理',
    statusSubmitted: '已提交',
    valueSeparator: '：',
    exportPdfSuccess: 'PDF 匯出成功',
    exportPdfFailed: 'PDF 匯出失敗',
    metaFlowsPdfNotSupported: 'MetaFlows 表單不支援 PDF 匯出',
    saveSuccess: '表單已儲存',
    saveFailed: '儲存失敗',
    selectedCount: '已選 {count} 份',
    batchDownloadZip: '下載 ZIP',
    clearSelection: '取消選取',
  },
  
  // 流程實例監控
  workflowMonitor: {
    title: '運行中的應用',
    description: '監控和管理您的 WhatsApp 工作流程實例',
    runningAppsTitle: '運行中的應用',
    runningAppsDescription: '監控正在運行的工作流程應用狀態',
    overview: '概覽',
    activeInstances: '活躍實例',
    completedInstances: '已完成實例',
    failedInstances: '失敗實例',
    totalInstances: '總實例數',
    runningInstances: '運行中實例',
    waitingInstances: '等待中實例',
    errorInstances: '錯誤實例',
    
    // 實例列表
    instanceList: '實例列表',
    horizontalBoardTab: '流程活動橫向看板',
    instanceListTab: '實例列表',
    selectWorkflowName: '選擇流程名稱',
    horizontalBoardDescription: '實時顯示每個流程實例已開始的節點，節點開始後會自動加入。',
    loadingHorizontalBoard: '載入橫向看板中...',
    loadHorizontalBoardFailed: '載入橫向看板失敗',
    noHorizontalBoardSteps: '目前沒有已開始的流程節點',
    viewChatBotConversation: '查看對話',
    viewChatOrderingCartConversation: '查看購物車對話',
    chatBotConversationTitle: '聊天機械人對話',
    chatOrderingCartConversationTitle: '聊天購物車對話',
    chatBotSessions: '對話列表',
    chatBotMessages: '則訊息',
    chatBotStateCollecting: '進行中',
    chatBotStateDone: '已結束',
    chatBotAiStaff: 'AI 員工',
    chatBotUser: '用戶',
    chatBotNoMessages: '尚無對話訊息',
    chatBotInputPlaceholder: '輸入訊息（Enter 送出，Shift+Enter 換行）',
    chatBotMessageSent: '訊息已發送',
    chatBotMessageSendFailed: '訊息發送失敗',
    chatBotMessageFailed: '發送失敗',
    chatBotMissingWaId: '此對話缺少 WhatsApp 號碼，無法發送',
    chatBotAdminIntervention: 'Admin 介入',
    chatBotAdminInterventionHint: '此處發送的訊息為 admin 介入，不會寫入 ChatBot 對話歷史',
    chatOrderingCartAdminInterventionHint: '此處發送的訊息為 admin 介入，不會寫入聊天購物車對話歷史',
    noChatBotSessions: '此節點暫無對話紀錄',
    noChatOrderingCartSessions: '此節點暫無購物車對話紀錄',
    loadChatBotSessionsFailed: '載入聊天機械人對話失敗',
    loadChatOrderingCartSessionsFailed: '載入聊天購物車對話失敗',
    send: '發送',
    artifactLinks: '產物連結',
    htmlReport: 'HTML Report',
    htmlReportInstances: 'HTML Report 實例',
    generatedDocument: '生成文件',
    generatedDocumentInstances: '生成文件實例',
    loadingReportInstances: '載入 HTML Report 實例中...',
    loadingDocInstances: '載入生成文件實例中...',
    loadReportInstancesFailed: '載入 HTML Report 實例失敗',
    loadDocInstancesFailed: '載入生成文件實例失敗',
    openHtmlReport: '打開 HTML Report',
    openGeneratedDocument: '打開生成文件',
    noReportInstances: '暫無 HTML Report 實例',
    noDocInstances: '暫無生成文件實例',
    artifactPreview: '產物預覽',
    executionTime: '執行時間',
    waitingFor: '等待',
    workflowName: '流程名稱',
    instanceId: '實例 ID',
    status: '狀態',
    currentStep: '當前步驟',
    startedAt: '開始時間',
    endedAt: '結束時間',
    duration: '執行時間',
    createdBy: '創建者',
    errorMessage: '錯誤信息',
    
    // 統計卡片
    totalInstancesCount: '總實例數',
    runningCount: '運行中',
    completedCount: '已完成',
    successRate: '成功率',
    
    // 狀態
    statusRunning: '運行中',
    statusCompleted: '已完成',
    statusFailed: '失敗',
    statusWaiting: '等待中',
    statusPaused: '已暫停',
    statusCancelled: '已取消',
    statusPending: '等待中',
    statusSent: '已發送',
    statusDelivered: '已送達',
    statusRead: '已讀',
    statusPartiallyFailed: '部分失敗',
    
    // 操作
    viewDetails: '查看詳情',
    pause: '暫停',
    resume: '恢復',
    cancel: '取消',
    retry: '重試',
    viewLogs: '查看日誌',
    
    // 篩選
    filterAll: '全部',
    filterRunning: '運行中',
    filterCompleted: '已完成',
    filterFailed: '失敗',
    filterWaiting: '等待中',
    searchPlaceholder: '搜尋流程名稱、實例 ID...',
    selectStatus: '選擇狀態',
    startDateRange: '開始日期範圍',
    endDateRange: '結束日期範圍',
    refresh: '刷新',
    clearFilters: '清空',
    autoRefreshSettings: '自動刷新設置',
    
    // 實例詳情
    instanceDetails: '實例詳情',
    basicInfo: '基本信息',
    triggerSource: '啟動來源',
    executionHistory: '執行歷史',
    triggerSourceEmail: 'Email',
    triggerSourceWhatsApp: 'WhatsApp 訊息',
    triggerSourceUnknown: '未知來源',
    triggerSourceFrom: '發件人',
    triggerSourceTo: '收件人',
    triggerSourceSubject: '主旨',
    triggerSourceBody: '內文',
    triggerSourceReceivedAt: '接收時間',
    triggerSourceMessageId: '訊息 ID',
    triggerSourceAttachments: '附件',
    triggerSourceContact: '聯絡人',
    triggerSourceMessageText: '訊息內容',
    triggerSourceTimestamp: '時間',
    triggerSourceNoInput: '無啟動資料',
    triggerSourceRawJson: '原始 JSON',
    triggerSourceStructured: '啟動資料（表格）',
    triggerSourcePublishedManual: '已發布應用（手動）',
    triggerSourceUserMessage: '使用者輸入',
    manualTrigger: '手動觸發',
    stepDetails: '步驟詳情',
    formInstances: '表單實例',
    receivedImages: '接收圖片',
    inputData: '輸入數據',
    outputData: '輸出數據',
    processVariables: '流程資料',
    workflowStarted: '流程啟動',
    workflowCompleted: '流程完成',
    executionStep: '執行步驟',
    stepStatus: '狀態',
    stepStartTime: '開始時間',
    stepEndTime: '完成時間',
    information: '信息',
    error: '錯誤',
    
    // 步驟詳情
    stepIndex: '步驟索引',
    stepType: '步驟類型',
    stepStatus: '步驟狀態',
    stepStartedAt: '開始時間',
    stepEndedAt: '結束時間',
    stepDuration: '執行時間',
    stepInput: '輸入數據',
    stepOutput: '輸出數據',
    stepError: '錯誤信息',
    
    // 表單實例
    formName: '表單名稱',
    formStatus: '表單狀態',
    formSubmittedAt: '提交時間',
    formApprovedAt: '核准時間',
    formRejectedAt: '拒絕時間',
    formApprovedBy: '核准人',
    formRejectedBy: '拒絕人',
    formApprovalNote: '核准備註',
    formRejectNote: '拒絕備註',
    
    // 統計信息
    statistics: '統計信息',
    todayInstances: '今日實例',
    weekInstances: '本週實例',
    monthInstances: '本月實例',
    averageExecutionTime: '平均執行時間',
    successRate: '成功率',
    errorRate: '錯誤率',
    
    // 操作確認
    confirmPause: '確定要暫停此流程實例嗎？',
    confirmResume: '確定要恢復此流程實例嗎？',
    confirmCancel: '確定要取消此流程實例嗎？',
    confirmRetry: '確定要重試此流程實例嗎？',
    
    // 操作結果
    pauseSuccess: '流程實例已暫停',
    resumeSuccess: '流程實例已恢復',
    cancelSuccess: '流程實例已取消',
    retrySuccess: '流程實例重試已啟動',
    operationFailed: '操作失敗',
    whatsappChat: 'WhatsApp 對話',
    pause: '暫停',
    resume: '恢復',
    retry: '重試',
    cancel: '取消',
    delete: '刪除',
    deleteSuccess: '流程實例已刪除',
    deleteFailed: '刪除流程實例失敗',
    deleteConfirmTitle: '刪除流程實例',
    deleteConfirmMessage: '確定要刪除實例 {instanceId}（{workflowName}）嗎？此操作將移除相關紀錄且無法復原。',
    cancelConfirmTitle: '取消流程實例',
    cancelConfirmMessage: '確定要取消此流程實例嗎？流程將立即停止且無法恢復。',
    
    // 實時更新
    realTimeUpdate: '實時更新',
    autoRefresh: '自動刷新',
    refreshInterval: '刷新間隔',
    lastUpdated: '最後更新',
    
    // 導出功能
    exportData: '導出數據',
    exportToExcel: '導出到 Excel',
    exportToCsv: '導出到 CSV',
    exportToPdf: '導出到 PDF',
    
    // 批量操作
    batchOperations: '批量操作',
    batchPause: '批量暫停',
    batchResume: '批量恢復',
    batchCancel: '批量取消',
    batchRetry: '批量重試',
    batchDelete: '批量刪除',
    clearSelection: '清除選擇',
    selectInstances: '選擇實例',
    selectedCount: '已選擇 {count} 個實例',
    batchNoApplicableInstances: '所選實例中無可執行「{action}」的項目',
    batchOperationSuccess: '已成功對 {count} 個實例執行「{action}」',
    batchOperationPartialFail: '部分操作失敗：成功 {success} 個，失敗 {fail} 個',
    batchCancelConfirmTitle: '批量取消流程實例',
    batchCancelConfirmMessage: '確定要取消所選的 {count} 個運行中實例嗎？流程將立即停止且無法恢復。',
    batchDeleteConfirmTitle: '批量刪除流程實例',
    batchDeleteConfirmMessage: '確定要刪除所選的 {count} 個實例嗎？此操作將移除相關紀錄且無法復原。',
    emailDeleteConfirmTitle: '刪除以 Email 觸發的執行',
    emailDeleteConfirmContent: '此執行由 Email 觸發。刪除後是否允許該郵件再次觸發流程？',
    emailDeleteAllowRetrigger: '是，刪除後允許再次觸發',
    emailDeleteKeepProcessed: '否，保留記錄（該郵件不會再次觸發）',
    batchDeleteEmailConfirmTitle: '批量刪除（含 Email 觸發）',
    batchDeleteEmailConfirmContent: '所選 {total} 筆中有 {emailCount} 筆為 Email 觸發。刪除後是否允許這些郵件再次觸發流程？',
    deleteFilesChoiceTitle: '是否同時刪除相關檔案？',
    deleteFilesChoiceContentSingle: '實例 {instanceId}（{workflowName}）可能包含已接收的圖片、影片、文件等檔案。刪除實例記錄後，這些檔案預設會保留在伺服器上（不會自動刪除）。請選擇要如何處理：',
    deleteFilesChoiceContentBatch: '所選 {count} 個實例可能包含已接收的圖片、影片、文件等檔案。刪除實例記錄後，這些檔案預設會保留在伺服器上（不會自動刪除）。請選擇要如何處理：',
    deleteFilesChoiceKeepFiles: '只刪除記錄，保留檔案',
    deleteFilesChoiceDeleteFiles: '同時刪除記錄與檔案',
    deleteFilesChoiceDownloadThenDelete: '先下載備份，再刪除記錄與檔案',
    deleteFilesBackupSuccess: '備份已下載',
    deleteFilesBackupEmpty: '此範圍沒有可備份的檔案，將直接繼續刪除',
    deleteFilesBackupFailed: '打包備份檔案失敗',
    
    // 日誌查看
    executionLogs: '執行日誌',
    logLevel: '日誌級別',
    logTime: '時間',
    logMessage: '消息',
    logDetails: '詳情',
    
    // 性能監控
    performanceMetrics: '性能指標',
    responseTime: '響應時間',
    throughput: '吞吐量',
    resourceUsage: '資源使用',
    memoryUsage: '內存使用',
    cpuUsage: 'CPU 使用',
    
    // 錯誤處理
    errorHandling: '錯誤處理',
    errorCount: '錯誤數量',
    errorTrend: '錯誤趨勢',
    errorDetails: '錯誤詳情',
    errorResolution: '錯誤解決方案',
    
    // 通知設置
    notifications: '通知設置',
    emailNotifications: '郵件通知',
    smsNotifications: '簡訊通知',
    webhookNotifications: 'Webhook 通知',
    notificationEvents: '通知事件',
    notifyOnError: '錯誤時通知',
    notifyOnCompletion: '完成時通知',
    notifyOnDelay: '延遲時通知',
    
    // 媒體文件相關
    receivedMedia: '已接收的媒體',
    uploadMedia: '上傳',
    uploading: '上傳中…',
    mediaUploadSuccess: '檔案上傳成功',
    mediaUploadFailed: '上傳失敗',
    loadingMediaFiles: '載入媒體文件中...',
    noMediaFiles: '暫無媒體文件',
    mediaFilesApiNotExists: '媒體文件 API 不存在',
    mediaFilesApiNotImplemented: '媒體文件 API 尚未實現',
    loadMediaFilesFailed: '載入媒體文件失敗',
    loadedMediaFilesData: '已載入媒體文件數據',
    rootFolder: '根目錄',
    files: '個文件',
    totalFiles: '總文件數',
    image: '圖片',
    video: '視頻',
    audio: '音頻',
    document: '文檔',
    file: '文件',
    view: '查看',
    download: '下載',
    
    // Lightbox 工具欄
    rotateLeft: '逆時針旋轉',
    rotateRight: '順時針旋轉',
    flipHorizontal: '水平翻轉',
    flipVertical: '垂直翻轉',
    zoomIn: '放大',
    zoomOut: '縮小',
    reset: '重置',
    
    // 用戶回覆（消息驗證）
    userReplies: '用戶回覆',
    validationPassed: '有效',
    validationFailed: '無效',
    others: '其他',
    caption: '文字：',
    reply: '則回覆',
    replies: '則回覆',
    
    // 消息發送詳情
    viewMessageSendStatus: '查看發送狀態',
    viewFormInstance: '查看表單實例',
    viewEmbedded: 'View Form Instance',
    loadingFormInstance: '載入表單實例中...',
    close: '關閉',
    openInNewTab: '在新標籤頁中打開',
    viewDataSet: '查看數據集',
    messageSendDetails: '消息發送詳情',
    messageSendStatusDetails: '消息發送詳細狀態',
    sendOverview: '發送概覽',
    recipientDetails: '收件人詳情',
    statusAnalysis: '狀態分析',
    totalRecipients: '總收件人數',
    sentCount: '已發送',
    deliveredCount: '已送達',
    readCount: '已讀',
    failedCount: '失敗',
    pendingCount: '等待中',
    sendBasicInfo: '發送基本信息',
    sendRecordId: '發送記錄ID',
    messageSendId: '消息發送ID',
    workflowExecutionId: '工作流程執行ID',
    nodeId: '節點ID',
    nodeType: '節點類型',
    messageType: '消息類型',
    totalRecipientsCount: '總收件人數',
    successSendCount: '成功發送數',
    successCount: '成功數',
    failedSendCount: '失敗發送數',
    startTime: '開始時間',
    endTime: '結束時間',
    completedAt: '完成時間',
    messageContent: '消息內容',
    errorInfo: '錯誤信息',
    recipient: '收件人',
    recipientName: '收件人',
    recipientType: '類型',
    recipientStatus: '狀態',
    type: '類型',
    whatsAppMessageId: 'WhatsApp消息ID',
    whatsappMessageId: 'WhatsApp消息ID',
    sentAt: '發送時間',
    sendTime: '發送時間',
    deliveredAt: '送達時間',
    deliveredTime: '送達時間',
    readAt: '已讀時間',
    readTime: '已讀時間',
    retryCount: '重試次數',
    errorMessage: '錯誤信息',
    sendStatusDistribution: '發送狀態分佈',
    timeAnalysis: '時間分析',
    sendStartTime: '發送開始時間',
    sendEndTime: '發送完成時間',
    sendCompleteTime: '發送完成時間',
    totalSendTime: '總發送時間',
    sendSuccessRate: '成功率',
    deliveryRate: '送達率',
    user: '用戶',
    contact: '聯絡人',
    group: '群組',
    hashtag: '標籤',
    initiator: '流程啟動人',
    phoneNumber: '電話號碼',
    recipientTypeUser: '用戶',
    recipientTypeContact: '聯絡人',
    recipientTypeGroup: '群組',
    recipientTypeHashtag: '標籤',
    recipientTypeInitiator: '流程啟動人',
    recipientTypePhoneNumber: '電話號碼',
    pending: '等待中',
    sent: '已發送',
    delivered: '已送達',
    read: '已讀',
    failed: '失敗',
    retrying: '重試中',
    
    // 發送原因
    sendReason: '發送原因',
    sendReasonNormal: '正常發送',
    sendReasonRetry: '提醒發送',
    sendReasonEscalation: '升級通知',
    sendReasonOverdue: '逾期通知',
    relatedStepExecutionId: '關聯步驟執行ID',
    
    // 相關消息發送記錄
    allRelatedMessageSends: '所有相關消息發送記錄',
    current: '當前',
    
    // 狀態標籤
    statusRunning: '運行中',
    statusCompleted: '已完成',
    statusFailed: '失敗',
    statusWaiting: '等待中',
    statusPaused: '已暫停',
    statusCancelled: '已取消',
    
    // 時間單位
    minutes: '分鐘',
    hours: '小時',
    
    // 操作結果
    operationSuccess: '操作成功',
    operationFailed: '操作失敗',
    loadInstancesFailed: '載入實例失敗',
    loadStatisticsFailed: '載入統計數據失敗',
    loadDetailsFailed: '載入詳情失敗',
    loadMessageSendDetailsFailed: '載入消息發送詳情失敗',
    loadMessageSendStatusFailed: '載入消息發送詳細狀態失敗',
    
    // 表單狀態
    pendingApproval: '待審批',
    approved: '已批准',
    rejected: '已拒絕',
    
    // eForm 狀態
    eformStatusPending: '待審批',
    eformStatusApproved: '已批准',
    eformStatusRejected: '已拒絕',
    eformStatusSubmitted: '已提交',
    
    // 調試和日誌相關
    requestUrl: '請求 URL',
    requestParams: '請求參數',
    currentPaginationParams: '當前分頁參數',
    dataFromMonitorApi: '來自監控 API 的數據',
    instanceDataStructure: '實例數據結構',
    paginationInfo: '分頁信息',
    firstInstanceCompleteData: '第一個實例的完整數據',
    inputJsonField: 'InputJson 字段',
    inputJsonType: 'InputJson 類型',
    parsedInputJson: '解析後的 InputJson',
    parseInputJsonFailed: '解析 InputJson 失敗',
    noInputJsonField: '沒有 InputJson 字段',
    availableFields: '可用字段',
    sendMessage: '發送消息',
    tableChange: '表格變更',
    sorterDetails: '排序詳情',
    paginationChange: '分頁變更',
    sortField: '排序字段',
    sortOrder: '排序順序',
    paginationOnlyDefaultSort: '僅分頁變更，使用默認排序',
    apiResponseStatus: 'API 響應狀態',
    apiResponseStatusText: 'API 響應狀態文本',
    apiEndpointNotExists: 'API 端點不存在',
    eformApiNotImplemented: 'eForm API 尚未實現',
    loadedEformData: '已載入 eForm 數據',
    loadEformInstancesFailed: '載入 eForm 實例失敗',
    eformApiNotExists: 'eForm API 不存在',
    backendServerError: '後端服務器錯誤',
    processVariablesApiNotExists: '流程資料 API 不存在',
    processVariablesApiNotImplemented: '流程資料 API 尚未實現',
    loadedProcessVariablesData: '已載入流程資料數據',
    loadProcessVariablesFailed: '載入流程資料失敗',
    mediaFilesApiNotExists: '媒體文件 API 不存在',
    mediaFilesApiNotImplemented: '媒體文件 API 尚未實現',
    loadedMediaFilesData: '已載入媒體文件數據',
    loadMediaFilesFailed: '載入媒體文件失敗',
    
    // 布爾值
    yes: '是',
    no: '否',
    
    // 變量相關
    variableName: '變量名稱',
    dataType: '數據類型',
    description: '描述',
    currentValue: '當前值',
    defaultValue: '默認值',
    setTime: '設置時間',
    setBy: '設置者',
    sourceType: '來源類型',
    sourceReference: '來源引用',
    required: '必需',
    hasValue: '有值',
    noValue: '無值',
    
    // 表單實例
    formInstance: '表單實例',
    exportPdfSuccess: 'PDF 匯出成功',
    exportPdfFailed: 'PDF 匯出失敗',
    metaFlowsPdfNotSupported: 'MetaFlows 表單不支援 PDF 匯出',
    formBasicInfo: '表單基本信息',
    formContent: '表單內容',
    formReplyContent: '表單回覆內容',
    formName: '表單名稱',
    instanceName: '實例名稱',
    fillType: '填充類型',
    createdAt: '創建時間',
    userInput: '用戶輸入',
    approvalBy: '審批人',
    approvalTime: '審批時間',
    approvalNote: '審批備註',
    unnamedForm: '未命名表單',
    unnamed: '未命名',
    loadingEformInstances: '載入表單實例中...',
    loadingEmbeddedFormInstance: '載入內嵌表單實例中...',
    loadedEmbeddedFormInstance: '已載入內嵌表單實例',
    loadEmbeddedFormInstanceFailed: '載入內嵌表單實例失敗',
    loadFormInstanceFailed: '載入表單實例失敗',
    cannotLoadFormInstance: '無法載入表單實例',
    setAt: '設置時間',
    
    // 其他
    noStepExecutionRecords: '暫無步驟執行記錄',
    loadingProcessVariables: '載入流程資料中...',
    loadingFormInstances: '載入表單實例中...',
    noProcessVariables: '暫無流程資料',
    noEformInstances: '暫無表單實例',
    noFormInstances: '暫無表單實例',
    inProgress: '進行中',
    loadingRecipientDetails: '載入收件人詳情中...',
    noRecipientRecords: '暫無收件人記錄',
    loadingMessageValidations: '載入消息驗證記錄中...',
    loadingEforms: '載入表單實例中...',
    selectedInstances: '已選擇 {count} 個實例',
    paginationTotal: '第 {start}-{end} 項，共 {total} 項',
    pageRange: '第 {start}-{end} 項，共 {total} 項',
    itemsPerPage: '條/頁',
    jumpTo: '跳至',
    page: '頁',
    confirm: '確定',
    whatsappChat: 'WhatsApp 對話',
    openWhatsAppChat: '打開 WhatsApp 對話',
    openSettingsModal: '打開設置彈窗',
    cannotFindMessageSendId: '無法找到消息發送記錄ID，請檢查後端數據',
    
    // MessageSendStatusModal 相關翻譯
    messageSendStatus: '消息發送狀態',
    loadingMessageSendRecords: '載入消息發送記錄中...',
    loadMessageSendRecordsFailed: '載入消息發送記錄失敗',
    normalSend: '正常發送',
    retrySend: '提醒發送',
    escalationNotification: '升級通知',
    normalSendRecords: '正常消息發送記錄',
    retrySendRecords: '提醒消息發送記錄',
    escalationSendRecords: '升級消息發送記錄',
    totalSendCount: '總發送數',
    successCount: '成功數',
    failureCount: '失敗數',
    currentRecord: '當前',
    messageSendId: '消息發送ID',
    nodeId: '節點ID',
    sendReason: '發送原因',
    status: '狀態',
    totalRecipients: '總收件人',
    successCount: '成功數',
    failedCount: '失敗數',
    creator: '創建者',
    startTime: '開始時間',
    viewDetails: '查看詳情',
    noMessageSendRecords: '暫無消息發送記錄',
    recipientDetails: '收件人詳情',
    recipient: '收件人',
    whatsAppMessageId: 'WhatsApp消息ID',
    sendTime: '發送時間',
    deliveredTime: '送達時間',
    readTime: '已讀時間',
    retryCount: '重試次數',
    errorMessage: '錯誤信息',
    createTime: '創建時間',
    normal: '正常',
    retry: '重試',
    escalation: '升級',
    overdue: '逾期',
    pending: '等待中',
    inProgress: '進行中',
    completed: '已完成',
    failed: '失敗',
    partiallyFailed: '部分失敗',
    sent: '已發送',
    delivered: '已送達',
    read: '已讀',
    retrying: '重試中',
    operation: '操作',
    person: '人',
    time: '時間',
    userResponse: '用戶回應',
    outputUserRepliedContinuing: '用戶已回覆，流程繼續',
    outputUserProvidedResponse: '用戶已提供回應',
    locationMapTitle: '用戶分享的位置',
    locationMapClickToEnlarge: '點擊放大',
    locationName: '地點名稱',
    locationAddress: '地址',
    error: '錯誤',
    step: '步驟',
    
    // 步驟調試相關
    stepData: '步驟 {stepNumber} 數據',
    stepAvailableFields: '步驟 {stepNumber} 可用字段',
    stepOutputJson: '步驟 {stepNumber} OutputJson',
    stepOutputJsonCapital: '步驟 {stepNumber} OutputJson (大寫)',
    stepOutput: '步驟 {stepNumber} 輸出',
    stepErrorMessage: '步驟 {stepNumber} 錯誤信息',
    stepParsedData: '步驟 {stepNumber} 解析數據',
    stepDetectedSuccess: '步驟 {stepNumber} 檢測到成功',
    stepDetectedError: '步驟 {stepNumber} 檢測到錯誤',
    stepDetectedSuccessMessage: '步驟 {stepNumber} 檢測到成功消息',
    stepDetectedNormalMessage: '步驟 {stepNumber} 檢測到普通消息',
    stepDetectedSwitchOutput: '步驟 {stepNumber} 檢測到 Switch 輸出',
    switchEvaluationResult: '條件分支結果',
    evaluatedAt: '判斷時間',
    conditionGroupsCount: '條件群組數',
    defaultPathUsed: '使用預設路徑',
    conditionMatched: '條件符合',
    selectedPathTarget: '選中路徑',
    stepNoClearFields: '步驟 {stepNumber} 沒有明確字段',
    stepParseJsonFailed: '步驟 {stepNumber} 解析 JSON 失敗',
    stepNoJsonContentField: '步驟 {stepNumber} 沒有 JSON 內容字段',
    stepFinalResult: '步驟 {stepNumber} 最終結果',
    stepIsSendWhatsAppNode: '步驟 {stepNumber} 是 sendWhatsApp 節點',
    stepErrorMessageSameAsOutputJson: '步驟 {stepNumber} errorMessage 與 outputJson 相同',
    stepErrorMessageContainsSuccess: '步驟 {stepNumber} errorMessage 包含成功信息',
    stepErrorMessageParseFailed: '步驟 {stepNumber} errorMessage 解析失敗',
    
    seconds: '秒',
    messageWithVariablesPlaceholder: '輸入消息內容，可使用 ${變量名} 引用流程資料；若為 JSON 類型可用 ${JsonName.JsonFieldName}',
    availableVariables: '可用變量',
    variableSyntaxHelp: '點擊變量標籤可插入到消息中，使用 ${變量名} 語法；JSON 流程資料可使用 ${JsonName.JsonFieldName}',
    switchConditions: '條件設置',
    switchDescription1: '此節點根據流程資料的值來決定執行路徑',
    switchDescription2: '可以設置多個條件，系統會按順序檢查每個條件',
    switchDescription3: '如果所有條件都不滿足，將執行默認路徑',
    newCondition: '新條件',
    defaultPath: '默認路徑',
    defaultPathPlaceholder: '當所有條件都不滿足時的路徑',
    selectDefaultPath: '選擇默認路徑',
    remove: '移除'
  },

  // 流程資料管理
  processVariables: {
    title: '流程資料管理',
    variableList: '流程資料列表',
    addVariable: '添加變量',
    editVariable: '編輯變量',
    deleteVariable: '刪除變量',
    createVariable: '創建變量',
    updateVariable: '更新變量',
    cancel: '取消',
    save: '保存',
    
    // 變量屬性
    variableName: '變量名稱',
    displayName: '顯示名稱',
    dataType: '數據類型',
    description: '描述',
    isRequired: '是否必填',
    defaultValue: '默認值',
    validationRules: '驗證規則',
    jsonSchema: 'JSON Schema',
    
    // 數據類型選項
    dataTypeString: '字符串 (string)',
    dataTypeInt: '整數 (int)',
    dataTypeDecimal: '小數 (decimal)',
    dataTypeDatetime: '日期時間 (datetime)',
    dataTypeBoolean: '布爾值 (boolean)',
    dataTypeText: '長文本 (text)',
    dataTypeJson: 'JSON 對象 (json)',
    
    // 表單提示
    variableNamePlaceholder: '例如：customer_name',
    displayNamePlaceholder: '例如：客戶名稱',
    descriptionPlaceholder: '描述這個變量的用途',
    defaultValuePlaceholder: '變量的默認值',
    validationRulesPlaceholder: 'JSON 格式的驗證規則',
    jsonSchemaPlaceholder: 'JSON Schema 定義（僅 JSON 類型需要）',
    
    // 驗證訊息
    variableNameRequired: '請輸入變量名稱',
    variableNamePattern: '變量名稱只能包含字母、數字和下劃線，且不能以數字開頭',
    dataTypeRequired: '請選擇數據類型',
    
    // 狀態標籤
    required: '必填',
    optional: '可選',
    
    // 操作結果
    createSuccess: '流程資料創建成功',
    updateSuccess: '流程資料更新成功',
    deleteSuccess: '流程資料刪除成功',
    createFailed: '流程資料創建失敗',
    updateFailed: '流程資料更新失敗',
    deleteFailed: '流程資料刪除失敗',
    saveFailed: '保存流程資料失敗',
    fetchFailed: '獲取流程資料失敗',
    
    // 確認對話框
    confirmDelete: '確定要刪除這個流程資料嗎？',
    confirmDeleteOk: '確定',
    confirmDeleteCancel: '取消',
    
    // 空狀態
    noVariables: '暫無流程資料，點擊「添加變量」開始創建',
    noDisplayName: '無顯示名稱',
    selectVariableToEdit: '請選擇一個流程資料進行編輯，或點擊「添加變量」創建新的流程資料',
    
    // 管理按鈕
    manageProcessVariables: '管理流程資料',

    // PV 顯示設定（PendingTasks 展開列用）
    displaySection: '列表顯示設定',
    showInList: '在表單列表中顯示',
    showInFormList: '在表單列表中顯示',
    showInFormListHelp: '勾選後，此 PV 會出現在 PendingTasks 等表單列表的「流程資料」區塊。',
    showInListHelp: '勾選後，此 PV 會出現在 PendingTasks 等表單列表的「流程資料」區塊。',
    shownInList: '已顯示於表單列表',
    shownInFormList: '已顯示於表單列表',
    showInInstanceList: '在實例列表中顯示',
    showInInstanceListHelp: '勾選後，此 PV 的值會顯示在流程活動看板的實例標題列，並可作為篩選條件。',
    shownInInstanceList: '已顯示於實例列表',
    displayLabel: '顯示標籤',
    displayLabelHelp: '若為空，會 fallback 用 DisplayName / VariableName。',
    displayLabelPlaceholder: '例如：客戶總價錢',
    displayOrder: '顯示順序',
    displayOrderHelp: '數值越小越靠前；通常用左側列表的 ↑/↓ 即可，不必手動輸入。',
    jsonKeyDisplay: 'JSON Key 顯示設定',
    jsonKeyDisplayHelp: '為此 JSON 變量定義要顯示的 key。每一列會在列表中顯示為一欄。',
    noJsonKeys: '尚未新增 JSON Key',
    addJsonKey: '新增 JSON Key',
    jsonKeyPlaceholder: '例如：customerName',
    jsonKeyDisplayLabelPlaceholder: '例如：客戶名稱',
    listColumnLabel: '列表顯示名稱:',
    moveUp: '上移',
    moveDown: '下移'
  },

  // 工作流列表頁面
  workflowList: {
    add: '新增',
    batchDelete: '批量刪除',
    batchEnable: '批量啟用',
    batchDisable: '批量停用',
    clearFilter: '清除篩選',
    manualStart: '手動啟動',
    select: '選擇',
    clear: '清除',
    confirmBatchDelete: '確認批量刪除',
    confirmBatchEnable: '確認批量啟用',
    confirmBatchDisable: '確認批量停用',
    confirmDelete: '確認刪除',
    cancel: '取消',
    confirmDeleteSelected: '確定要刪除選中的',
    confirmEnableSelected: '確定要啟用選中的',
    confirmDisableSelected: '確定要停用選中的',
    workflows: '個流程',
    cannotBeUndone: '此操作無法撤銷！',
    successfullyDeleted: '已成功刪除',
    successfullyEnabled: '已成功啟用',
    successfullyDisabled: '已成功停用',
    batchDeleteFailed: '批量刪除失敗',
    batchOperationFailed: '批量操作失敗',
    pleaseSelectWorkflows: '請選擇要刪除的流程',
    pleaseSelectWorkflowsToOperate: '請選擇要操作的流程',
    workflowStarted: '已成功啟動',
    manualStartMessage: '手動啟動的流程',
    deleteWithRelatedRecords: '刪除流程及其相關記錄',
    confirmDeleteWithRelatedRecords: '確定要刪除流程「{name}」嗎？',
    relatedRecordsWillBeDeleted: '刪除此流程將同時刪除以下相關記錄：',
    executionInstances: '流程實例',
    stepExecutions: '步驟執行記錄',
    messageSends: '消息發送記錄',
    messageRecipients: '消息收件人記錄',
    queryResults: '數據集查詢結果',
    queryRecords: '數據集查詢記錄',
    eformInstances: '表單實例',
    messageValidations: '消息驗證記錄',
    chatMessages: '聊天消息',
    processVariableValues: '流程資料值',
    processVariableDefinitions: '流程資料定義',
    noRelatedRecords: '此流程沒有相關記錄，可以直接刪除。',
    loadingRelatedRecords: '正在查詢相關記錄...',
    warningDeleteTitle: '⚠️ 嚴重警告：刪除操作不可回復！',
    warningDeleteDescription: '刪除此流程定義將永久刪除所有相關數據，包括：流程定義本身、所有流程運行實例、表單實例、表單審批記錄、消息發送記錄、步驟執行記錄、數據集查詢記錄、流程資料、消息驗證記錄等。所有數據將被永久刪除且無法恢復！',
    criticalWarning: '⚠️ 此操作無法撤銷！請確認您真的要刪除這些數據。',
    confirmStatusChange: '確認更改狀態',
    confirmStatusChangeContent: '確定要將流程「{name}」的狀態更改為「{action}」嗎？',
    successfullyChangedStatus: '狀態已成功更改為',
    statusChangeFailed: '狀態更改失敗'
  },

  // 日曆頁面（應用 → 日曆）
  calendar: {
    title: '日曆',
    viewDay: '日',
    viewWeek: '週',
    viewMonth: '月',
    viewYear: '年',
    today: '今天',
    jumpToDate: '跳至日期',
    jumpToMonth: '跳至月份',
    jumpToYear: '跳至年份',
    refresh: '重新整理',
    newEvent: '新增事件',
    editEvent: '編輯事件',
    filterAll: '全部流程',
    fromWorkflow: '所屬流程',
    fieldTitle: '標題',
    fieldAllDay: '整天',
    fieldTime: '開始 / 結束',
    fieldWorkflow: '流程定義',
    fieldWorkflowPlaceholder: '可選，將事件歸入指定流程定義',
    fieldResources: '資源',
    fieldResourcesPlaceholder: '選擇 contact 作為事件資源 / 工程人員',
    selectResources: '選擇資源',
    resourcePickerTitle: '選擇資源',
    resourcePickerSearchPlaceholder: '搜尋名稱 / 電話 / Email / 部門 / 群組 / 標籤',
    resourceName: '名稱',
    resourcePosition: '職位 / 部門',
    resourceCompany: '公司',
    resourcePhone: '電話',
    resourceEmail: 'Email',
    resourceGroup: '群組',
    resourceTags: '標籤',
    filterGroup: '群組',
    filterTag: '標籤',
    clearFilters: '清除篩選',
    apply: '套用',
    fieldLocation: '地點',
    fieldColor: '顏色',
    fieldStatus: '狀態',
    fieldEventType: '日曆類型',
    fieldEventTypePlaceholder: '選擇或輸入日曆類型',
    eventTypeDeleted: '已刪除日曆類型',
    eventTypeDeleteFail: '刪除日曆類型失敗',
    eventTypeDeleteInUse: '此日曆類型仍有事件使用中，無法刪除',
    eventTypeDeleteInUseCount: '此日曆類型仍有 {count} 個事件使用中，無法刪除',
    sidebarEventTypes: '日曆類型',
    untypedEvents: '未分類',
    noEventTypesYet: '尚無日曆類型，新增事件時可輸入建立',
    fieldTypeColor: '類型色彩',
    editTypeColor: '設定類型色彩',
    typeColorSidebarHint: '可在左側選單調整類型色彩',
    eventTypeColorUpdateFail: '更新日曆類型色彩失敗',
    collapseSidebar: '收合側邊欄',
    expandSidebar: '展開側邊欄',
    fieldDescription: '說明',
    statusConfirmed: '已確認',
    statusTentative: '待定',
    statusCancelled: '已取消',
    save: '儲存',
    cancel: '取消',
    delete: '刪除',
    saved: '已儲存',
    saveFail: '儲存失敗',
    deleted: '已刪除',
    deleteFail: '刪除失敗',
    confirmDelete: '確認刪除此事件？',
    requireTitle: '請輸入標題',
    requireTime: '請選擇開始與結束時間',
    loadFail: '載入事件失敗',
  },

  // 已發布應用頁面
  publishedApps: {
    title: '已發布應用',
    description: '顯示所有啟用狀態且支援手動啟動的工作流程應用',
    totalApps: '總應用數',
    manualTriggerWorkflows: '手動觸發工作流程',
    autoTriggerWorkflows: '自動觸發工作流程',
    noManualWorkflows: '暫無手動觸發的工作流程',
    noAutoWorkflows: '暫無自動觸發的工作流程',
    loading: '載入已發布應用中...',
    executionCount: '執行次數',
    creator: '創建者',
    clickToStart: '點擊啟動',
    manualMessagePlaceholder: '輸入訊息…',
    manualSend: '發送',
    manualSendHint: '輸入訊息後點綠色發送；附檔請點迴紋針，或將檔案拖入虛線框內',
    manualComposerDropHint: '將檔案拖到此虛線框內，或點左側迴紋針加入多個檔案',
    manualAttachTooltip: '從電腦選擇檔案（可多選）',
    manualDropOnIconHint: '拖放多個檔案至此，或點擊選擇檔案；亦可拖至下方虛線輸入區',
    manualSendNeedContent: '請輸入至少一則訊息或上傳一個檔案',
    starting: '啟動中...',
    autoOnly: '僅自動觸發',
    unknown: '未知',
    manual: '手動',
    auto: '自動',
    startWorkflowSuccess: '工作流程 "{name}" 已成功啟動',
    startWorkflowQueued: '工作流程 "{name}" 已送出並於背景執行；狀態與錯誤請至流程監控查看',
    startWorkflowFailed: '啟動工作流程失敗',
    loadAppsFailed: '載入已發布應用失敗',
    noDescription: '無描述',
    mockCustomerService: '客戶服務流程',
    mockCustomerServiceDesc: '處理客戶諮詢和投訴的標準化流程',
    mockOrderProcess: '訂單處理流程',
    mockOrderProcessDesc: '從訂單接收到發貨的完整流程',
    mockPaymentConfirm: '付款確認流程',
    mockPaymentConfirmDesc: '處理付款確認和發票生成的流程',
    mockAutoNotification: '自動通知流程',
    mockAutoNotificationDesc: '系統自動發送通知的流程'
  },

  // Data Set 管理頁面
  dataSetManagement: {
    title: '數據集管理',
    add: '新增',
    createDataSet: '創建 Data Set',
    editDataSet: '編輯 Data Set',
    createDataSetTitle: '創建 Data Set',
    editDataSetTitle: '編輯 Data Set',
    save: '保存',
    cancel: '取消',
    
    // 表格列標題
    name: '名稱',
    dataSourceType: '數據源類型',
    status: '狀態',
    recordCount: '記錄數',
    lastUpdate: '最後更新',
    actions: '操作',
    
    // 狀態標籤
    active: '啟用',
    inactive: '停用',
    error: '錯誤',
    
    // 同步狀態標籤
    idle: '閒置',
    running: '同步中',
    completed: '已完成',
    failed: '失敗',
    paused: '已暫停',
    
    // 同步進度
    syncStatus: '同步狀態',
    syncProgress: '同步進度',
    syncInProgress: '數據集正在同步中，請稍後再試',
    syncStarted: '同步已開始',
    syncCompleted: '同步完成 - 新增: {inserted}, 更新: {updated}, 刪除: {deleted}',
    syncFailed: '同步失敗',
    inserted: '新增',
    updated: '更新',
    deleted: '刪除',
    skipped: '跳過',
    processed: '已處理',
    total: '總計',
    syncPaused: '同步已暫停',
    readyToSync: '準備同步',
    syncing: '同步中...',
    processingSpeed: '速度',
    remaining: '剩餘',
    
    // 數據源類型
    sql: 'SQL',
    excel: 'EXCEL',
    googleDocs: 'GOOGLE_DOCS',
    
    // 數據源類型選項（完整文字）
    sqlQuery: 'SQL 查詢',
    excelFile: 'EXCEL 文件',
    googleDocsOption: 'GOOGLE_DOCS',
    
    // 操作按鈕
    viewRecords: '查看記錄',
    syncData: '同步數據',
    edit: '編輯',
    delete: '刪除',
    deleteRecord: '刪除記錄',
    editRecord: '編輯記錄',
    editRecordTitle: '編輯記錄',
    recordUpdated: '記錄已更新',
    recordUpdateFailed: '更新記錄失敗',
    
    // 確認對話框
    confirmDelete: '確定要刪除這個 DataSet 嗎？',
    confirmDeleteDescription: '刪除「{datasetName}」將同時刪除所有已同步的 {recordCount} 條記錄，此操作無法復原！',
    confirmDeleteOk: '確定',
    confirmDeleteCancel: '取消',
    confirmDeleteRecord: '確定要刪除這條記錄嗎？',
    confirmDeleteRecordDescription: '刪除此記錄將無法復原，請確認是否繼續？',
    recordDeleted: '記錄已成功刪除',
    recordDeleteFailed: '刪除記錄失敗',
    
    // 分頁
    totalRecords: '共 {total} 條記錄',
    pageRange: '第 ',
    total: ' 條記錄',
    pageSizeOptions: ['10', '20', '50', '100'],
    
    // 標籤頁
    basicInfo: '基本資訊',
    dataSourceConfig: '數據源配置',
    columnDefinition: '欄位定義',
    
    // 基本資訊表單
    nameLabel: '名稱',
    namePlaceholder: '輸入 Data Set 名稱',
    nameRequired: '請輸入名稱',
    description: '描述',
    descriptionPlaceholder: '輸入描述',
    isScheduled: '定時更新',
    updateInterval: '更新間隔（分鐘）',
    updateIntervalPlaceholder: '例如：60（1小時）',
    updateIntervalRequired: '請設定更新間隔',
    syncDirection: '同步方向',
    syncDirectionTooltip: '選擇數據同步的方向：入站（從外部讀取）、出站（寫入外部）、雙向（先寫入再讀取）',
    syncDirectionPlaceholder: '請選擇同步方向',
    syncDirectionInbound: '入站（從外部數據源讀取到內部）',
    syncDirectionOutbound: '出站（從內部寫入到外部數據源）',
    syncDirectionBidirectional: '雙向（先寫入外部，再從外部讀取）',
    
    // 數據源配置
    dataSourceTypeLabel: '數據源類型',
    dataSourceTypePlaceholder: '選擇數據源類型',
    dataSourceTypeRequired: '請選擇數據源類型',
    dataSourceTypeInfo: '數據源類型設定',
    dataSourceTypeDescription: '請在「數據源配置」標籤中選擇數據源類型並進行相應配置。',
    
    // SQL 配置
    connectionType: '連接方式',
    usePresetConnection: '使用預設連接',
    customConnection: '自定義連接',
    presetDatabaseConnection: '預設數據庫連接',
    presetConnectionPlaceholder: '選擇數據庫連接',
    erpDatabase: 'ERP 數據庫',
    purpleRiceDatabase: 'Purple Rice 數據庫',
    serverName: '伺服器名稱/IP',
    serverNamePlaceholder: '例如：192.168.1.100',
    serverNameRequired: '請輸入伺服器名稱或IP',
    port: '端口號',
    portPlaceholder: '例如：1433',
    databaseName: '數據庫名稱',
    databaseNamePlaceholder: '例如：MyDatabase',
    databaseNameRequired: '請輸入數據庫名稱',
    authenticationType: '認證方式',
    sqlServerAuth: 'SQL Server 認證',
    windowsAuth: 'Windows 認證',
    username: '用戶名',
    usernamePlaceholder: '例如：sa',
    usernameRequired: '請輸入用戶名',
    password: '密碼',
    passwordPlaceholder: '輸入密碼',
    passwordRequired: '請輸入密碼',
    additionalOptions: '額外連接選項',
    additionalOptionsPlaceholder: '例如：TrustServerCertificate=true;MultipleActiveResultSets=true',
    connectionTest: '連接測試',
    connectionTestDescription: '配置完成後，可以點擊下方按鈕測試連接是否成功。',
    testConnection: '測試連接',
    sqlQuery: 'SQL 查詢語句',
    sqlQueryPlaceholder: 'SELECT * FROM table_name WHERE condition',
    sqlQueryRequired: '請輸入 SQL 查詢語句',
    sqlParameters: 'SQL 參數（JSON 格式）',
    sqlParametersPlaceholder: '{"param1": "value1", "param2": "value2"}',
    targetTableName: '目標表名',
    targetTableNamePlaceholder: '例如：customers',
    targetTableNameRequired: '出站或雙向同步時，目標表名為必填項',
    targetTableNameTooltip: '指定出站同步時要寫入的 SQL 表名（僅在出站或雙向同步時需要）',
    
    // Excel 配置
    excelFilePath: 'Excel 文件路徑',
    excelFilePathPlaceholder: '例如：C:/local/data.xlsx、/uploads/excel/data.xlsx，或 \\\\\\\\server\\\\share\\\\folder\\\\file.xlsx（網路磁碟請用 UNC）',
    excelSheetName: '工作表名稱',
    excelSheetNamePlaceholder: '選擇工作表',
    uploadExcelFile: '上傳 Excel 文件',
    excelUploadDescription: 'Excel 上傳說明',
    excelUploadInfo: '上傳成功後，文件路徑會自動填充。保存 DataSet 後，點擊「同步數據」按鈕來將 Excel 數據導入到數據庫中。系統會自動根據 Excel 標題行生成欄位定義。',
    selectSheetThenLoadColumns: '已載入工作表列表，請選擇工作表後再點擊「載入欄位定義」。',
    
    // Google Docs 配置
    googleDocsUrl: 'Google Docs URL',
    googleDocsUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/...',
    googleDocsUrlRequired: '請輸入 Google Docs URL',
    googleDocsSheetName: '工作表名稱',
    googleDocsSheetNamePlaceholder: '例如：Sheet1',
    googleDocsIntegration: 'Google Docs 整合說明',
    googleDocsIntegrationDescription: '請確保 Google Docs 文件已設定為可公開讀取，或已配置適當的認證信息。',
    loadColumnDefinition: '載入欄位定義',
    tenantAdminOnly: '僅 Tenant_Admin 可用',
    sqlReadOnlyNotice: 'SQL 查詢由 Tenant_Admin 管理，您只能查看，無法修改。',
    
    // 自動更新
    autoUpdate: '自動更新',
    autoUpdateInterval: '更新間隔（分鐘）',
    autoUpdateIntervalPlaceholder: '例如：60（1小時）',
    autoUpdateIntervalRequired: '請設定更新間隔',
    
    // 欄位定義
    columnDefinitionDescription: '欄位定義說明',
    columnDefinitionInfo: '對於 Excel 數據源，系統會自動根據 Excel 標題行生成欄位定義。您可以在同步數據後手動調整欄位屬性。',
    columnName: '欄位名稱',
    columnNamePlaceholder: '例如：customer_id',
    columnNameRequired: '請輸入欄位名稱',
    displayName: '顯示名稱',
    displayNamePlaceholder: '例如：客戶編號',
    dataType: '數據類型',
    dataTypePlaceholder: '選擇數據類型',
    dataTypeRequired: '請選擇數據類型',
    string: '字串',
    text: '長文字',
    int: '整數',
    decimal: '小數',
    datetime: '日期時間',
    boolean: '布林值',
    isPrimaryKey: '主鍵',
    isPrimaryKeyNormal: '普通',
    isSearchable: '可搜尋',
    isSearchableNot: '不可搜尋',
    isSortable: '可排序',
    isSortableNot: '不可排序',
    isIndexed: '建索引',
    isIndexedNot: '不建索引',
    defaultValue: '預設值',
    defaultValuePlaceholder: '預設值',
    displayFormat: '顯示格式',
    displayFormatPlaceholder: '選擇或輸入格式',
    displayFormatTooltip: '數值欄位的顯示格式，例如 $#,###.## 表示貨幣格式',
    displayFormatCustomHint: '可直接輸入自訂格式',
    sortOrder: '排序順序',
    addColumn: '添加欄位',
    removeColumn: '刪除',
    
    // 記錄查看
    dataRecords: '數據記錄',
    advancedSearch: '進階搜尋',
    refresh: '重新整理',
    recordId: 'ID',
    primaryKeyValue: '主鍵值',
    recordStatus: '狀態',
    createdAt: '建立時間',
    nA: 'N/A',
    
    // 進階搜尋
    advancedSearchTitle: '進階搜尋',
    searchConditions: '搜尋條件',
    columnNameLabel: '欄位名稱',
    columnNamePlaceholder: '選擇欄位',
    columnNameRequired: '請選擇欄位',
    operator: '操作符',
    operatorPlaceholder: '選擇操作符',
    operatorRequired: '請選擇操作符',
    equals: '等於',
    contains: '包含',
    greaterThan: '大於',
    lessThan: '小於',
    dateRange: '日期範圍',
    value: '值',
    valuePlaceholder: '輸入搜尋值',
    valueRequired: '請輸入值',
    addSearchCondition: '添加搜尋條件',
    removeSearchCondition: '刪除',
    sortBy: '排序欄位',
    sortByPlaceholder: '選擇排序欄位',
    sortOrder: '排序方向',
    ascending: '升序',
    descending: '降序',
    executeSearch: '執行搜尋',
    
    // 操作結果訊息
    deleteSuccess: '刪除成功',
    deleteFailed: '刪除失敗',
    syncSuccess: '同步成功！共處理 {count} 條記錄',
    syncFailed: '同步失敗',
    createSuccess: '創建成功',
    updateSuccess: '更新成功',
    operationFailed: '操作失敗',
    fetchFailed: '獲取 DataSet 列表失敗',
    fetchRecordsFailed: '獲取記錄失敗',
    processFailed: '處理失敗',
    searchFailed: '搜尋失敗',
    foundRecords: '找到 {count} 條記錄',
    
    // 錯誤訊息
    pleaseSelectDataSourceType: '請選擇數據源類型',
    pleaseEnterName: '請輸入名稱',
    pleaseEnterServerName: '請輸入伺服器名稱或IP',
    pleaseEnterDatabaseName: '請輸入數據庫名稱',
    pleaseEnterUsername: '請輸入用戶名',
    pleaseEnterPassword: '請輸入密碼',
    pleaseEnterSqlQuery: '請先輸入 SQL 查詢語句',
    pleaseSelectPresetConnection: '請選擇預設連接',
    pleaseEnterGoogleDocsUrl: '請輸入 Google Docs URL',
    pleaseEnterColumnName: '請輸入欄位名稱',
    pleaseSelectDataType: '請選擇數據類型',
    pleaseSelectColumn: '請選擇欄位',
    pleaseSelectOperator: '請選擇操作符',
    pleaseEnterValue: '請輸入值',
    
    // 文件上傳
    onlyExcelFiles: '只能上傳 Excel 文件！',
    fileSizeLimit: '文件大小不能超過 10MB！',
    uploadSuccess: '上傳成功',
    uploadFailed: '上傳失敗',
    processingFile: '正在處理文件，請稍候...',
    getSheetNamesFailed: '獲取工作表名稱失敗',
    getColumnPreviewFailed: '獲取欄位預覽失敗',
    autoGeneratedColumns: '已自動生成 {count} 個欄位定義',
    cannotAutoGenerateColumns: '無法自動生成欄位定義',
    pleaseManuallyConfigure: '請手動配置',
    
    // 連接測試
    testingConnection: '正在測試連接...',
    connectionTestSuccess: '連接測試成功！正在獲取欄位定義...',
    connectionTestFailed: '連接測試失敗',
    presetConnectionConfigured: '預設連接配置完成',
    whatoFlowDatabase: 'WhatoFlow 數據庫',
    
    // 分頁
    pageRange: '第 {start}-{end} 條，共 {total} 條記錄',
    recordPageSizeOptions: ['20', '50', '100', '200'],
    recordsPerPage: '每頁顯示:',
    previousPage: '上一頁',
    nextPage: '下一頁',
    datasetNotFound: '未找到 ID 為 {id} 的數據集'
  },

  apiProviders: {
    pageTitle: 'API 供應商管理',
    pageDescription: '集中管理 AI 與雲端文件等外部 API，設定各供應商的連線資訊、模型與密鑰，方便團隊共用與擴充。',
    actions: {
      refresh: '重新整理'
    },
    messages: {
      loadFailed: '載入 API 供應商失敗，請稍後再試。',
      saveSuccess: '設定已更新。',
      saveFailed: '儲存失敗，請檢查輸入或稍後再試。',
      loadDetailFailed: '載入供應商詳細設定失敗，請稍後重試。',
      validationFailed: '表單驗證失敗，請檢查輸入內容。'
    },
    empty: '尚未有可管理的 API 供應商。',
    category: {
      ai: 'AI 服務',
      clouddoc: '雲端文件',
      emailserver: '郵件伺服器',
      erp: 'ERP 系統',
      voice: '語音 AI',
      embedding: 'Embedding / RAG',
      rag: '託管 RAG（Collections）'
    },
    noDescription: '尚未提供描述。',
    description: {
      'xai': 'Elon AI Grok 官方 API',
      'xai-stt': 'xAI 語音轉文字（Speech-to-Text）API',
      'xai-embed': 'xAI Embeddings（⚠️ xAI 目前無 embedding 模型，無法使用；請改用 OpenAI/Gemini Embeddings，或改用「託管 RAG → xAI Collections」）',
      'xai-collections': 'xAI Collections（託管 RAG）：文件上載至 xAI 雲端，由 xAI 自動 chunk/embedding/索引，透過 /v1/documents/search 做語意搜尋。需 xAI API Key。',
      'openai-embeddings': 'OpenAI Embeddings（知識庫 RAG，模型：text-embedding-3-small）',
      'gemini-embeddings': 'Google Gemini Embeddings（知識庫 RAG，模型：text-embedding-004）',
      'deepseek-embeddings': 'DeepSeek Embeddings（⚠️ 官方 API 不支援 Embedding，請改用 xai-embed / openai-embeddings）',
      'copilot-embeddings': 'GitHub Models Embeddings（需 GitHub PAT + models:read 權限）',
      'openai': 'OpenAI Chat Completions',
      'openai-whisper': 'OpenAI Whisper 語音轉文字（Speech-to-Text）API',
      'deepseek': 'DeepSeek 官方 Chat API',
      'copilot': 'Copilot Chat API（需企業授權）',
      'gemini': 'Google AI Gemini API',
      'google-docs': 'Google Docs 讀寫 API（Dataset 匯入、文件同步）',
      'microsoft-graph': '使用 Microsoft Graph API 透過 Office 365 發送電子郵件，需要 OAuth 2.0 認證與 Mail.Send 權限。',
      'odoo': 'Odoo 19 ERP 整合（PO / 報價單 / 銷售單 / 發票 / 出貨 / 收貨 / 退貨 / 信用備忘錄 / 收款），支援 XML-RPC 與 JSON-2 雙協定。'
    },
    status: {
      active: '啟用',
      inactive: '停用',
      activeTip: '此供應商目前可供流程與工具使用。',
      inactiveTip: '此供應商目前未啟用。'
    },
    apiKey: {
      set: '已設定密鑰',
      missing: '尚未設定密鑰',
      setTip: '密鑰已保存，可直接使用。',
      missingTip: '尚未設定密鑰，將無法完成授權。'
    },
    configure: '設定詳情',
    modal: {
      title: '設定 {name}',
      loadingTitle: '載入設定中...',
      save: '儲存設定',
      cancel: '取消',
      providerKeyLabel: 'Provider Key',
      defaultUrl: '官方預設 API URL',
      defaultModel: '官方建議模型'
    },
    form: {
      active: '啟用狀態',
      apiUrl: 'API URL',
      apiUrlRequired: '請輸入 API URL。',
      apiUrlEmailServerTip: 'Microsoft Graph API URL 中的 {userPrincipalName} 會在發送郵件時自動替換為發件人的 email 地址。',
      model: '模型',
      modelRequired: '請選擇或輸入模型。',
      modelPlaceholder: '請輸入模型名稱',
      temperature: 'Temperature',
      temperatureTip: '控制輸出隨機度，值越高越具創造性。',
      topP: 'Top P',
      topPTip: '控制取樣範圍，值越低越保守。',
      enableStreaming: '啟用串流輸出',
      apiKey: 'API Key',
      apiKeyPlaceholder: '輸入新的 API Key',
      clearApiKey: '清除已儲存的 API Key',
      maskedKey: '目前已保存的密鑰：{key}',
      managementApiKey: 'Management API Key',
      managementApiKeyHint: '用於建立 / 管理 xAI Collections（需 Management Key 權限）。僅 Tenant Admin 可設定。',
      managementApiKeyPlaceholder: '輸入 xAI Management API Key',
      clearManagementApiKey: '清除已儲存的 Management API Key',
      extraHeaders: '額外 HTTP Headers (JSON)',
      extraHeadersTip: '若需要自訂 Header，請輸入 JSON 格式，例如 {"X-Custom-Header":"value"}。',
      authType: '授權類型',
      authTypeTip: '選擇此供應商的授權方式，預設依照官方建議。',
      authTypePlaceholder: '選擇授權類型',
      authTypeOptions: {
        apiKey: 'API Key',
        bearerToken: 'Bearer Token',
        serviceAccount: 'Service Account JSON',
        oauth: 'OAuth 2.0'
      },
      authConfigJson: '授權配置 (JSON)',
      authConfigTip: '用於存放 Tenant、Client ID、Service Account 等授權所需資訊。',
      authConfigJsonEmailServer: 'OAuth 2.0 授權配置 (JSON)',
      authConfigTipEmailServer: 'Microsoft Graph API 需要 OAuth 2.0 認證，請輸入 JSON 格式：{"tenantId":"your-tenant-id","clientId":"your-client-id","clientSecret":"your-client-secret"}',
      oauthConfig: 'OAuth 2.0 認證設定',
      tenantId: 'Tenant ID',
      tenantIdRequired: '請輸入 Tenant ID',
      tenantIdTip: 'Azure AD 租戶 ID，可在 Azure Portal 中找到。使用 client_credentials 流程需要應用程序權限（Application Permissions），不是委派權限（Delegated Permissions）。',
      clientId: 'Application (client) ID',
      clientIdRequired: '請輸入 Application (client) ID',
      clientIdTip: '應用程式 (客戶端) ID，可在 Azure Portal 的應用程式註冊中找到',
      clientSecret: 'Client Secret',
      clientSecretRequired: '請輸入 Client Secret',
      clientSecretTip: '應用程式密鑰值，可在 Azure Portal 的應用程式註冊中建立。請確保已為應用程序添加 Mail.Send 應用程序權限並由管理員同意。',
      emailSettings: '郵件發送設定',
      fromEmail: '收及發件人電子郵件',
      fromEmailRequired: '請輸入收及發件人電子郵件地址',
      fromEmailInvalid: '請輸入有效的電子郵件地址',
      fromEmailTip: '同時用於：發送郵件時的發件人地址；流程 Start 節點 Email 監控時所監聽的信箱（收件人）。',
      replyTo: '回覆地址',
      replyToInvalid: '請輸入有效的電子郵件地址',
      replyToTip: '收件人回覆時使用的地址（可選）',
      saveToSentItems: '儲存到已傳送項目',
      saveToSentItemsTip: '是否將發送的郵件儲存到發件人的已傳送項目資料夾',
      enabled: '啟用',
      disabled: '停用',
      testEmail: '發送測試郵件',
      testEmailModalTitle: '發送測試郵件',
      sendTestEmail: '發送',
      testEmailTo: '收件人',
      testEmailToRequired: '請輸入收件人地址',
      testEmailToInvalid: '請輸入有效的電子郵件地址',
      testEmailToTip: '測試郵件將發送到此地址',
      testEmailSubjectLabel: '郵件主題',
      testEmailSubject: 'WhattoFlow 郵件發送測試',
      testEmailSubjectRequired: '請輸入郵件主題',
      testEmailBodyLabel: '郵件內容',
      testEmailBody: '這是一封測試郵件，用於驗證 Microsoft Graph API 郵件發送配置是否正確。',
      testEmailBodyRequired: '請輸入郵件內容',
      testEmailSuccess: '測試郵件發送成功！請檢查收件箱。',
      testEmailFailed: '測試郵件發送失敗，請檢查配置。',
      testEmailValidationError: '請先填寫必要的配置欄位（Tenant ID、Client ID、Client Secret、發件人地址）。',
      settingsJson: '進階設定 (JSON)',
      settingsJsonTip: '自訂供應商專屬參數，例如 temperature、top_p、top_k。',
      settingsJsonEmailServer: '郵件設定 (JSON)',
      settingsJsonTipEmailServer: '郵件發送相關設定，例如：{"fromEmail":"sender@example.com","replyTo":"reply@example.com","saveToSentItems":true}',
      resetSettings: '套用官方預設',
      resetSettingsHint: '將以供應商預設值覆寫目前設定。',
      jsonInvalid: '請輸入有效的 JSON 格式。',
      odooSettings: 'Odoo 連線設定',
      odooProtocol: '通訊協定',
      odooProtocolTip: 'XML-RPC：所有 Odoo 部署皆支援。JSON-2：僅 Odoo Custom plan 支援；其他方案請選 XML-RPC（系統會自動 fallback）。',
      odooDatabase: 'Database',
      odooDatabaseRequired: '請輸入 Odoo Database 名稱。',
      odooDatabaseTip: '與 Odoo 登入頁所顯示的 db 名稱相同。',
      odooDefaultLogin: '服務帳號 Login',
      odooDefaultLoginRequired: '請輸入服務帳號 Login。',
      odooDefaultLoginTip: '建議使用整合用專屬帳號，並在 Odoo Settings → Users → API Keys 產生 API Key。',
      odooDefaultCompanyId: '預設公司 ID（多公司情境）',
      odooDefaultCompanyIdTip: '會強制 Odoo context.allowed_company_ids；單公司可留空。',
      odooPort: 'Port',
      odooPortTip: '預設 443 (HTTPS)；自架／內網 Odoo 常見為 8069。',
      odooTimeoutSeconds: '逾時秒數',
      odooApiKeyHint: 'API Key：在 Odoo Settings → Users → API Keys 產生（Odoo 14+）。JSON-2 內 Key 每 3 個月需輪換一次，請設行事曆提醒。',
      testOdoo: '測試 Odoo 連線',
      testOdooSuccess: 'Odoo 連線測試成功',
      testOdooFailed: 'Odoo 連線測試失敗',
      testOdooValidationError: '請先填寫 API URL、Database 與服務帳號 Login。',
      voiceSettings: '語音轉文字設定',
      embeddingSettings: 'Embedding 設定',
      testEmbedding: '測試 Embedding',
      testEmbeddingOk: 'Embedding 成功（模型：{model}，維度：{dimensions}）',
      testEmbeddingFailed: 'Embedding 測試失敗',
      queryAvailableModels: '查詢此 Provider 可用模型',
      embeddingModelsTitle: '可用 Embedding 模型',
      embeddingModelsHint: '複製以下模型名稱並貼到上方「模型」欄位。',
      embeddingModelsEmpty: '查詢不到任何 Embedding 模型，請確認 API 金鑰是否有效。',
      embeddingExperimentalHint: 'GitHub Models (copilot-embeddings) 需 GitHub PAT（models:read 權限）。自建 RAG 建議使用 openai-embeddings 或 gemini-embeddings；xAI 請改用「託管 RAG → xAI Collections」。',
      voiceLanguage: '預設語言代碼',
      voiceLanguageTip: '語言代碼用於啟用 ITN（數字/貨幣格式化）。x.ai 目前支援的格式化語言：en、ja、ko、fr、de 等（不含 zh 中文）。接收粵語 / 中文請留空，模型會自動偵測語言並轉錄，不影響準確度。',
      voiceFormat: '啟用 ITN 格式化（format）',
      voiceFormatTip: '開啟後，語音中的數字、貨幣等會被轉換為書寫格式（如「一百元」→「$100」）。需設定語言代碼。',
      voiceApiKeyHint: 'API Key：x.ai STT 使用與 Chat 相同的 Bearer API Key。',
      testStt: '測試語音轉文字',
      testSttSuccess: '語音轉文字測試成功',
      testSttFailed: '語音轉文字測試失敗',
      advanced: '進階'
    }
  },

  // WhatsApp 電話號碼驗證管理
  phoneVerification: {
    title: 'WhatsApp 電話號碼驗證管理',
    pageDescription: '管理 WhatsApp 電話號碼驗證',
    refresh: '刷新',
    uploadCertificate: '上傳憑證',
    currentCompany: '當前公司：{name}',
    allCompaniesBanner: '以下列表為所有公司之 WhatsApp 電話驗證記錄。',
    tenantAdminHint: '以下為全系統各公司之驗證記錄。上傳憑證時請於視窗中選擇目標公司（目前預設操作脈絡：{name}）。',
    filterByCompany: '篩選公司',
    filterCompanyPlaceholder: '全部公司',
    loadVerificationsForbidden: '無權載入驗證列表，請確認已登入且具 Tenant_Admin。',
    phoneNumber: '電話號碼',
    status: '狀態',
    certificateExpiry: '憑證過期時間',
    codeExpiry: '驗證碼過期時間',
    phoneNumberId: 'Phone Number ID',
    createdAt: '創建時間',
    actions: '操作',
    view: '查看',
    copyUrl: '複製 URL',
    delete: '刪除',
    deleteConfirmTitle: '確定刪除此筆驗證記錄？',
    deleteConfirmDesc: '刪除後無法復原，若客戶仍持有舊連結將無法再使用。',
    deleteOk: '刪除',
    deleteSuccess: '已刪除驗證記錄',
    deleteFailed: '刪除失敗',
    deleteForbidden: '無權刪除，請確認已登入且具 Tenant_Admin。',
    uploadModalTitle: '上傳憑證和電話號碼',
    company: '公司',
    companyRequired: '請選擇公司',
    companySelectPlaceholder: '請選擇公司',
    currentCompanyPlaceholder: '當前公司',
    phoneNumberIdSelectLabel: 'Phone Number ID（從公司主檔選取）',
    phoneNumberIdSelectFromCompany: '公司主檔',
    phoneNumberIdSelectPlaceholder: '請選取或輸入 Phone Number ID',
    certificate: '數碼憑證 (Base64)',
    certificateRequired: '請輸入憑證',
    certificateFormatError: '憑證格式可能不正確',
    certificateHelp: '請從 Meta Business Suite 複製 base64 編碼的數碼憑證',
    certificatePlaceholder: '請粘貼 base64 編碼的憑證...',
    submit: '提交',
    cancel: '取消',
    uploadSuccess: '憑證已上傳',
    uploadSuccessTitle: '上傳成功',
    uploadSuccessMessage: '憑證已成功上傳，請將以下 URL 發送給客戶：',
    verificationUrl: '驗證 URL',
    copyUrlButton: '複製 URL',
    urlCopied: 'URL 已複製到剪貼板',
    uploadFailed: '上傳失敗',
    loadFailed: '載入失敗',
    loadVerificationsFailed: '載入驗證記錄失敗',
    viewDetails: '查看詳情',
    loadDetailsFailed: '載入詳情失敗',
    verificationRecordDetails: '驗證記錄詳情',
    verificationMethod: '驗證方式',
    updatedAt: '更新時間',
    errorMessage: '錯誤信息',
    na: 'N/A',
    detailTitle: '驗證記錄詳情',
    detailPhoneNumber: '電話號碼：',
    detailStatus: '狀態：',
    detailCertificateExpiry: '憑證過期時間：',
    detailCodeExpiry: '驗證碼過期時間：',
    detailVerificationMethod: '驗證方式：',
    detailPhoneNumberId: 'Phone Number ID：',
    detailCreatedAt: '創建時間：',
    detailUpdatedAt: '更新時間：',
    detailErrorMessage: '錯誤信息：',
    detailVerificationUrl: '驗證 URL：',
    verificationUrlCopied: '驗證 URL 已複製到剪貼板',
    totalRecords: '共 {total} 條記錄',
    
    // 狀態標籤
    statusPending: '待處理',
    statusRequested: '已請求驗證碼',
    statusVerified: '已驗證',
    statusExpired: '已過期',
    statusFailed: '失敗',
    
    // 表單驗證和提示
    phoneNumberRequired: '請輸入電話號碼（Company.WA_PhoneNo_ID 未配置）',
    phoneNumberInvalid: '請輸入有效的電話號碼（例如：+85296062000 或 85296062000）',
    phoneNumberOptional: '可選：如果留空，系統將從 Meta API 或 Company.Phone 自動獲取',
    phoneNumberRequiredWhenNoId: '必需：因為 Company.WA_PhoneNo_ID 未配置',
    phoneNumberPlaceholderOptional: '可選：留空將自動從 Meta API 獲取',
    phoneNumberPlaceholderRequired: '例如：+85296062000 或 85296062000',
    
    // 錯誤信息
    loadCompanyInfoFailed: '載入公司信息失敗',
    cannotGetCompanyId: '無法獲取公司 ID',
    cannotGetCompanyInfo: '無法獲取公司信息，請重新登入',
    cannotLoadVerifications: '無法載入驗證記錄：公司 ID 為空',
    unknownError: '未知錯誤',
    
    // 國家代碼檢測
    duplicateCountryCodeDetected: '檢測到重複的國家代碼，已自動移除'
  },

  // 權限管理
  permissionManagement: {
    title: '權限管理',
    roleName: '角色名稱',
    description: '描述',
    pageDescription: '管理角色與介面權限',
    interfaces: '介面權限',
    actions: '操作',
    systemDefault: '系統默認',
    companyCustom: '公司自定義',
    selectCompany: '選擇公司',
    noPermissions: '無權限',
    saveSuccess: '權限保存成功',
    saveFailed: '保存權限失敗',
    loadFailed: '載入權限失敗',
    editingCompany: '編輯公司'
  },
  reports: {
    noPermission: '您沒有權限訪問報表功能',
    loadPermissionFailed: '載入權限失敗',
    unauthorized: '未授權',
    noDailyReportsPermission: '您沒有權限訪問任何每日報表',
    noMonthlyReportsPermission: '您沒有權限訪問任何每月報表',
    noRealtimeReportsPermission: '您沒有權限訪問任何實時報表',
    noEformInstanceReportsPermission: '您沒有權限訪問表單實例報表',
    loadStatisticsFailed: '載入統計數據失敗',
    loadDataFailed: '載入報表數據失敗',
    exportComingSoon: '匯出功能即將推出',
    exportSuccess: '匯出成功',
    exportFailed: '匯出失敗',
    totalPending: '待處理總數',
    overdue: '逾期事項',
    urgent: '緊急事項',
    todayNew: '今日新增',
    totalRecords: '共 {total} 條記錄',
    phoneNumber: '電話號碼',
    messageCount: '消息數量',
    workflowTriggers: '工作流觸發',
    formSubmissions: '表單提交',
    activePhoneNumbers: '活躍電話號碼',
    totalMessages: '消息總數',
    totalWorkflowTriggers: '工作流觸發總數',
    totalFormSubmissions: '表單提交總數',
    firstMessageTime: '首次消息時間',
    lastMessageTime: '最後消息時間',
    workflowName: '工作流名稱',
    status: '狀態',
    running: '運行中',
    completed: '已完成',
    failed: '失敗',
    error: '錯誤',
    waiting: '等待中',
    dateRange: '時間範圍',
    eformInstancesTitle: 'EForm Instance 報表',
    eformInstancesDescription: '查詢並預覽表單填寫結果，支援一頁一張 PDF 匯出',
    eformInstancesFilters: '查詢條件',
    eformInstancesKeyword: '關鍵字',
    eformInstancesKeywordPlaceholder: '表單名稱 / 實例名稱 / 表單欄位內容',
    eformInstancesStatus: '狀態',
    eformInstancesPreview: '預覽',
    eformInstancesNoPreview: '沒有可預覽的內容',
    eformInstancesNoData: '沒有符合條件的表單資料',
    eformInstanceManualPending: '待回應表單',
    eformInstanceManualResponded: '已收到回應表單',
    // EForm Pivot Reports
    eformPivot: '表單樞紐分析',
    eformPivotTitle: 'EForm 樞紐分析報表',
    eformPivotDescription: '自訂度量與維度，對表單實例進行分組匯總分析',
    noEformPivotPermission: '您沒有權限訪問表單樞紐分析報表',
    pivotMeasure: '度量 (Measure)',
    pivotCount: '筆數',
    pivotRowDimension: '列維度 (Rows)',
    pivotColDimension: '欄維度 (Columns)',
    pivotSystemFields: '系統欄位',
    pivotFormFields: '表單欄位',
    pivotSwapAxes: '交換列/欄',
    pivotTotal: 'Total',
    pivotRecords: '筆',
    pivotDrillDownTitle: '明細記錄',
    pivotDateYear: '年',
    pivotDateQuarter: '季',
    pivotDateMonth: '月',
    pivotDateDay: '日',
    pivotFilterByForms: '選擇表單（可多選）',
    pivotFilterByFormsPlaceholder: '不選＝全部表單',
    exportExcel: '匯出 Excel',
    exportExcelSuccess: '已匯出 Excel',
    exportExcelFailed: '匯出 Excel 失敗',
    noCommerceReportsPermission: '您沒有權限訪問商務管理報表',
    commerce: {
      title: '商務管理報表',
      statement: 'Statement 月結',
      salesPivot: '銷售訂單 Pivot',
      noStatementPermission: '您沒有權限訪問 Statement 月結報表',
      noSalesPivotPermission: '您沒有權限訪問銷售訂單 Pivot',
      monthRange: '送貨月份範圍',
      month: '月份',
      customers: '客戶',
      allCustomers: '全部客戶',
      selectCustomers: '選擇客戶',
      loadFailed: '載入報表失敗',
      grandTotal: '總計',
      monthTotal: '月小計',
      customerTotal: '客戶小計',
      orderNo: '訂單編號',
      deliveryDate: '送貨日期',
      amount: '金額',
      paymentTerm: '付款條款',
      lineCount: '明細行數',
      qty: '數量',
      total: '金額',
      orderCount: '訂單數',
      pivotMeasure: '度量',
      pivotRowDimension: '列維度',
      pivotColDimension: '欄維度',
      pivotTotal: 'Total',
      exportExcel: '匯出 Excel',
      exportPdf: '匯出 PDF',
      exportSuccess: '匯出成功',
      exportFailed: '匯出失敗',
      noData: '沒有符合條件的資料',
      company: '公司',
      selectCompany: '選擇公司',
      dateRange: '送貨日期範圍'
    },
    expandCollapseAll: '全部展開/收合',
    noFieldSummary: '無欄位摘要設定',
    pdfExportCount: '匯出次數',
    startedAt: '開始時間',
    endedAt: '結束時間',
    duration: '執行時長',
    currentStep: '當前步驟',
    errorMessage: '錯誤信息',
    totalExecutions: '執行總數',
    successRate: '成功率',
    failureRate: '失敗率',
    avgDuration: '平均執行時長',
    totalForms: '表單總數',
    approvalRate: '通過率',
    rejectionRate: '拒絕率',
    avgApprovalTime: '平均審批時間',
    formTypeUsage: '表單類型使用情況',
    formCount: '表單數量',
    approverWorkload: '審批人員工作量',
    weekdayVsWeekend: '工作日 vs 週末',
    weekday: '工作日',
    weekend: '週末',
    approvalTrend: '審批趨勢',
    approved: '已通過',
    rejected: '已拒絕',
    hours: '小時',
    totalProcessTypes: '流程類型總數',
    avgEfficiency: '平均效率',
    bottleneckCount: '瓶頸流程',
    optimizationSuggestions: '優化建議',
    processTypeDistribution: '流程類型分佈',
    efficiencyComparison: '效率對比',
    durationComparison: '執行時長對比',
    usageFrequencyTrend: '流程使用頻率趨勢',
    efficiencyVsDuration: '效率 vs 執行時長',
    bottleneck: '瓶頸識別',
    optimization: '優化建議',
    yes: '是',
    no: '否',
    activeUsers: '活躍用戶',
    totalOperations: '總操作次數',
    workflowUsage: '工作流使用',
    formUsage: '表單使用',
    datasetUsage: '數據集使用',
    whatsappUsage: 'WhatsApp 使用',
    functionName: '功能名稱',
    usageCount: '使用次數',
    growthRate: '增長率',
    functionUsageDistribution: '功能使用分佈',
    functionUsageTrend: '功能使用趨勢',
    workflows: '工作流',
    forms: '表單',
    datasets: '數據集',
    whatsapp: 'WhatsApp',
    datasetUsageRanking: '數據集使用排名',
    queryCount: '查詢次數',
    updateCount: '更新次數',
    userActivityRanking: '用戶活躍度排名',
    operationCount: '操作次數',
    totalSteps: '總步驟數',
    avgStepDuration: '平均步驟執行時長',
    totalWorkflows: '工作流總數',
    stepName: '步驟名稱',
    stepType: '步驟類型',
    stepDurationComparison: '步驟完成時間對比',
    hourlyWorkDistribution: '時間段工作分佈',
    workflowStep3D: '3D 工作分佈可視化',
    time: '時間',
    workflow: '流程',
    step: '步驟',
    selectWorkflow: '選擇工作流',
    allWorkflows: '所有工作流',
    minutes: '分鐘',
    workflowSuccessRate: '工作流成功率',
    formApprovalEfficiency: '表單審批效率',
    whatsappResponseRate: 'WhatsApp 回應率',
    systemAvailability: '系統可用性',
    kpiTrend: 'KPI 趨勢對比',
    anomalyEvents: '異常事件總結',
    improvementSuggestions: '改進建議',
    suggestion: '建議',
    category: '類別',
    priority: '優先級',
    description: '描述',
    approved: '已審批',
    rejected: '已拒絕',
    totalForms: '表單總數',
    approvedAt: '審批時間',
    approver: '審批人',
    processingTime: '處理時長',
    active: '活躍',
    inactive: '未啟用',
    successCount: '成功數',
    failedCount: '失敗數',
    healthScore: '健康度評分',
    lastExecutionTime: '最後執行時間',
    activeWorkflows: '活躍工作流',
    inactiveWorkflows: '未啟用工作流',
    overallHealthScore: '總體健康度評分',
    statusDistribution: '狀態分佈',
    fillTypeDistribution: '填寫類型分佈',
    hourlyTrend: '24小時趨勢',
    newTasks: '新增任務',
    detailTable: '明細表格',
    records: '條記錄',
    formTypes: '種表單類型',
    workflowTypes: '種工作流類型',
    noData: '暫無數據',
    topWorkflows: 'Top 10 工作流執行數量',
    topWorkflowsByExecution: 'Top 20 工作流執行排名',
    workflowExecutionTrend: '30天執行趨勢',
    failureReasons: '失敗原因分佈',
    executionCount: '執行數量',
    executions: '執行次數',
    durationDistribution: '執行時長分佈',
    processingFlow: '處理流程',
    fillTypeProcessingTime: '按填寫類型的平均處理時間',
    hourlySubmissionTrend: '24小時提交趨勢',
    submissions: '提交數量',
    problemWorkflows: '問題工作流排名（健康度最低 Top 10）',
    successRateVsDuration: '成功率 vs 執行時長',
    definitionTypes: '種定義類型',
    topActivePhoneNumbers: 'Top 20 活躍電話號碼排名',
    messageTypeDistribution: '消息類型分佈',
    messageTypeText: '文本',
    messageTypeImage: '圖片',
    messageTypeFile: '文件',
    messageTypeAudio: '語音',
    hourlyInteractionHeatmap: '24小時互動時段熱力圖',
    interactionVsWorkflow: '互動頻率 vs 工作流觸發',
    loginRequired: '請先登入',
    loginExpired: '登入已過期，請重新登入',
    daily: {
      pendingOverview: '待批事項總覽',
      workflowExecution: '工作流執行日報',
      formEfficiency: '表單處理效率',
      workflowHealth: '工作流健康度監控',
      whatsappInteraction: 'WhatsApp 互動分析'
    },
    monthly: {
      workflowPerformance: '工作流效能月報',
      formApproval: '表單審批分析月報',
      businessInsights: '業務流程洞察',
      systemUsage: '系統使用統計',
      operationalOverview: '營運效能總覽',
      processStepExecution: '流程步驟執行分析'
    },
    realtime: {
      workflowActivity: '工作流活動看板',
      description: '實時監控所有正在運行的步驟執行（每 3 秒自動更新）',
      totalActive: '活躍步驟',
      running: '運行中',
      waiting: '等待中',
      completed: '已完成',
      failed: '失敗',
      noActiveWorkflows: '目前沒有活躍的流程',
      noActiveSteps: '目前沒有活躍的步驟執行',
      noItems: '無項目',
      selectWorkflow: '選擇流程定義',
      allWorkflows: '全部流程',
      dateRange: '時間範圍:',
      workflowDefinition: '流程定義:',
      createdAt: '創建時間:',
      executionTime: '執行時間:',
      stepIndex: '步驟索引:',
      initiatedBy: '啟動者:',
      waitingFor: '等待:',
      executionFailed: '執行失敗',
      failedAlert: '有 {count} 個流程執行失敗，請及時處理',
      userReplies: '用戶回復:'
    },
    actionType: {
      startWorkflow: '啟動流程',
      replyQrcode: '回覆QR碼',
      replyMsg: '回覆消息',
      receiveNotification: '接收通知',
      receiveEform: '接收表單',
      fillEform: '填寫表單',
      unknown: '未知操作'
    },
    actionTypes: '種操作類型',
    
    // 流程資料過濾器
    selectWorkflowFirst: '請先選擇工作流名稱以載入流程資料',
    processVariableFilters: '流程資料過濾（用於分組）',
    loadingProcessVariables: '載入流程資料中...',
    noProcessVariables: '該工作流沒有定義流程資料',
    selectProcessVariablesForGrouping: '選擇用於分組的流程資料',
    pvFilterHelp: '選擇的流程資料將用於對媒體文件進行分組',
    selectedForGrouping: '已選中用於分組:',
    groupingNote: '媒體文件將按選中的流程資料值進行分組顯示',
    removeFilter: '移除',
    columnName: '欄位名稱',
    columnNameRequired: '請選擇欄位名稱',
    selectColumn: '選擇欄位',
    operator: '運算子',
    operatorRequired: '請選擇運算子',
    selectOperator: '選擇運算子',
    equals: '等於',
    contains: '包含',
    greaterThan: '大於',
    lessThan: '小於',
    notEquals: '不等於',
    value: '值',
    valueRequired: '請輸入搜尋值',
    enterSearchValue: '輸入搜尋值',
    addSearchCondition: '添加搜尋條件',
    
    // App's Media Reports
    appsMedia: '應用媒體報表',
    eformInstances: '表單實例報表',
    eformPivotReports: '表單樞紐分析報表',
    appsMediaDescription: '按流程實例和流程資料分組展示圖片媒體文件，支持 Windows Gallery 效果的自適應排版，以及 PDF、Word、ZIP 匯出',
    instanceFilters: '流程實例過濾',
    pleaseSetFilters: '請先設置過濾條件',
    loading: '載入中...',
    processingGroup: '正在處理分組',
    found: '找到',
    groups: '個分組',
    statusSubGroups: '個狀態子組',
    images: '張圖片',
    noMediaFound: '沒有找到符合條件的媒體文件',
    loadFailed: '載入失敗',
    noDataToExport: '沒有數據可導出',
    exportingPdf: '正在導出 PDF...',
    exportSuccess: 'PDF 導出成功',
    exportFailed: 'PDF 導出失敗',
    exportPdf: '導出 PDF',
    exportPdfLandscape: '導出 PDF (橫向)',
    exportPdfPortrait: '導出 PDF (縱向)',
    exportDocx: '匯出 Docx',
    exportDocxTooltip: '匯出為 Word，可自行刪除圖片與調整版面',
    exportingDocx: '正在導出 Word...',
    exportDocxSuccess: 'Word 導出成功',
    exportDocxFailed: 'Word 導出失敗',
    exportZip: '下載 ZIP',
    exportZipTooltip: '依分組目錄打包下載所有圖片',
    exportingZip: '正在打包 ZIP...',
    exportZipSuccess: 'ZIP 下載成功',
    exportZipFailed: 'ZIP 下載失敗',
    noMediaData: '沒有媒體數據，請設置過濾條件並點擊「查詢」',
    
    // 畫廊設置
    gallerySettings: '畫廊設置',
    displaySettings: '顯示設置',
    pdfExportSettings: 'PDF 導出設置',
    maxImagesPerPage: '每頁最多圖片數量',
    maxImagesPerPageTooltip: '控制每頁最多顯示的圖片數量，實際數量會根據圖片大小自動調整',
    imageGap: '圖片間距（mm）',
    imageGapTooltip: 'PDF 導出時圖片之間的間距',
    minImageWidth: '最小圖片寬度（mm）',
    minImageWidthTooltip: '防止圖片過小看不清，PDF 導出時圖片不會小於此寬度',
    pdfOrientation: 'A4 方向',
    pdfOrientationTooltip: 'PDF 導出時的紙張方向',
    landscape: '橫向',
    portrait: '縱向',
    imageQuality: '圖片質量',
    imageQualityTooltip: 'PDF 導出時圖片的壓縮質量（0.1-1.0），值越大質量越高但文件也越大',
    expand: '展開',
    collapse: '收合',
    
    // 流程實例過濾器
    workflowName: '工作流名稱',
    selectWorkflowName: '選擇工作流名稱',
    selectStatus: '選擇狀態',
    all: '全部',
    startedDateRange: '開始時間範圍',
    startDate: '開始日期',
    endDate: '結束日期',
    
    // 流程資料過濾器 - 分組
    selectGroupingVariables: '選擇用於分組的流程資料',
    groupingVariablesHelp: '選擇的流程資料將用於對媒體文件進行分組，相同 PV 組合的流程實例會合併到同一組',
    groupedProcessVariables: '分組的流程資料',
    filterConditions: '過濾條件',
    filterConditionsHelp: '設置過濾條件來篩選符合條件的流程實例',
    selectWorkflowNameFirst: '請先選擇工作流名稱以開始查詢',
    printOutSettings: 'Print Out Settings',
    excludeImage: '剔除不列印',
    restoreImage: '還原圖片',
    excludedTag: '已剔除',
    excludedCompanyShared: '點擊圖片右上角可剔除不列印項目；剔除設定全公司共用',
    excludedSaveFailed: '儲存剔除設定失敗',
    excludedSaving: '儲存剔除設定中...',
    eformInstancePdfSettings: 'PDF 匯出設定',
    eformInstancePdfSettingsDescription: '版面依表單 HTML/CSS 與預設邊距。',
    eformInstancePdfFitToPage: '縮放以塞進一頁 (Fit to page)',
    eformInstancePdfFitToPageDescription: '開啟時，每個表單會縮放以塞進一頁 PDF。（Fit to one page）',
    eformInstanceDisplaySettings: '顯示設定',
    eformInstanceBaseFontSize: '基礎字體大小（px）',
    eformInstanceBaseFontSizeTooltip: 'PDF 匯出時表單的基礎字體大小，值越大文字越大',
    eformInstanceContentPadding: '內容內距（px）',
    eformInstanceContentPaddingTooltip: 'PDF 匯出時表單內容與邊緣的間距，值越大間距越大',
    eformInstanceZoomScale: '縮放比例',
    eformInstanceZoomScaleTooltip: 'PDF 匯出時的整體縮放比例，值越大內容越大（建議 1.0-2.0）',
    eformInstanceFillWidth: '優先填滿寬度',
    eformInstanceFillWidthTooltip: '開啟後內容會填滿左右寬度，減少兩側留白；若表單較長會自動分多頁',
    eformInstanceAdvancedSettings: '進階設定',
    eformInstanceMargin: '頁面邊距（mm）',
    eformInstanceMarginTooltip: 'PDF 頁面的邊距，值越小可用空間越大',
    eformInstanceRenderViewportPx: '虛擬視窗寬度（px）',
    eformInstanceRenderViewportPxTooltip: '生成 PDF 時用來排版的虛擬視窗寬度，太窄會令表頭兩欄塌成單欄，可調大直到版面滿意',
    eformInstanceRenderScale: '渲染解析度',
    eformInstanceRenderScaleTooltip: 'HTML 轉換為圖片的解析度倍數，值越大品質越高但處理時間越長（建議 2-3）'
  },
  
  // MetaFlowBuilder 相關
  metaFlowBuilder: {
    componentPropertyEditor: {
      labels: {
        inputType: "輸入類型",
        required: "必填",
        validationPattern: "驗證模式 (Pattern)",
        helperText: "幫助文字",
        defaultValue: "默認值",
        richTextContent: "富文本內容",
        options: "選項",
        optionsSource: "選項來源",
        selectDataset: "選擇 Dataset",
        idField: "ID 字段 (Value)",
        titleField: "標題字段 (Display)",
        maxSelectedItems: "最大選擇數量",
        description: "描述",
        image: "圖片",
        width: "寬度 (width)",
        height: "高度 (height)",
        imageList: "圖片列表",
        altText: "替代文字",
        aspectRatio: "寬高比",
        scaleType: "縮放類型",
        componentId: "組件 ID",
        fieldName: "字段名稱 (Name)",
        title: "標題",
        maxLength: "最大字數",
        actionType: "操作類型",
        targetScreen: "目標 Screen",
        payload: "Payload",
        httpMethod: "HTTP 方法",
        endpointUrl: "端點 URL",
        commerceCollection: "Commerce 集合 (Collection)",
        metaCollectionLimit: "最大返回數量"
      },
      options: {
        manual: "手動輸入",
        dataset: "從 Dataset 選擇",
        metaCollection: "Meta Collection（Commerce 集合）"
      },
      placeholders: {
        patternExample: "例如: [0-9]+",
        helperTextHint: "顯示在輸入框下方的提示文字",
        defaultValueHint: "用戶打開表單時預填的值，例如區號 852",
        richTextContentHint: "輸入富文本內容，支持 Markdown 語法\n例如：\n# 標題\n這是 *粗體* 和 _斜體_ 文本\n~刪除線~",
        optionId: "選項 ID",
        optionTitle: "選項標題",
        maxSelectedItemsExample: "例如: 2",
        descriptionHint: "選擇器的描述文字",
        widthHeightExample: "例如: 200",
        altTextHint: "圖片描述（用於無障礙訪問）",
        fieldNameExample: "例如: customer_name",
        selectScreen: "選擇 Screen",
        payloadHint: "可選的 payload 數據",
        endpointUrlHint: "API 端點 URL",
        selectDataset: "請選擇 Dataset",
        selectIdField: "請選擇 ID 字段",
        selectTitleField: "請選擇標題字段",
        selectCommerceCollection: "請選擇 Commerce 集合"
      },
      tooltips: {
        bold: "粗體 (**文字**)",
        italic: "斜體 (*文字*)",
        strikethrough: "刪除線 (~~文字~~)",
        code: "行內代碼 (`代碼`)",
        heading1: "標題 1 (# 標題)",
        heading2: "標題 2 (## 標題)",
        list: "無序列表 (- 項目)",
        link: "鏈接 ([文字](URL))",
        richTextHint: "支持 Markdown 語法：*粗體*、_斜體_、~刪除線~、# 標題等。每行將作為數組中的一個元素。",
        imageUpload: "上傳圖片，將自動轉換為 base64 格式並作為 src 屬性生成到 JSON 中",
        fieldNameHint: "此名稱將用於 Meta Flow JSON 和 webhook 回覆數據。建議使用有意義的名稱，如 'customer_name', 'order_date' 等。",
        targetScreenHint: "選擇導航到的 Screen ID",
        textAreaMaxLength: "預設 600 字，官方上限 600"
      },
      selectOptions: {
        inputTypes: {
          text: "文字",
          email: "電子郵件",
          phone: "電話",
          number: "數字",
          url: "URL"
        },
        actionTypes: {
          navigate: "導航到 Screen",
          submit: "提交",
          call: "調用",
          url: "打開 URL"
        },
        scaleTypes: {
          contain: "Contain（完整顯示）",
          cover: "Cover（填充）"
        },
        httpMethods: {
          get: "GET",
          post: "POST",
          put: "PUT",
          delete: "DELETE"
        }
      },
      buttons: {
        list: "列表",
        link: "鏈接",
        addOption: "添加選項",
        remove: "移除",
        uploadImage: "上傳圖片",
        deleteImage: "刪除此圖片",
        addImage: "添加圖片",
        saveChanges: "保存更改"
      },
      messages: {
        optionIdRequired: "選項 ID 必填",
        optionTitleRequired: "選項標題必填",
        altTextRequired: "替代文字必填",
        fieldNameRequired: "請輸入字段名稱",
        fieldNamePattern: "名稱只能包含字母、數字和下劃線，且必須以字母開頭",
        titleRequired: "請輸入標題",
        imageReadFailed: "圖片讀取失敗",
        imageFormatError: "只支持 JPEG 和 PNG 格式的圖片！",
        imageSizeExceeded: "圖片大小不能超過 {maxSizeKB}KB（1MB）！",
        imageSizeWarning: "圖片大小 {fileSizeKB}KB 超過推薦值 300KB，可能影響性能",
        maxImagesWarning: "最多只能添加 3 張圖片！",
        maxImagesReached: "已達上限",
        fetchDatasetsFailed: "獲取 Dataset 失敗"
      },
      helperText: {
        richTextHint: "提示：每行將作為數組中的一個元素。支持 Markdown 語法。選中文字後點擊上方按鈕進行格式化。",
        imageConverted: "提示：圖片已轉換為 base64 格式",
        idFieldHint: "此字段將作為選項的唯一標識符",
        titleFieldHint: "此字段將作為選項顯示給用戶",
        photoPickerRequiredHint: "對應 Meta Flows PhotoPicker 的 min-uploaded-photos：開啟為至少 1 張（必填），關閉為 0（選填）。",
        documentPickerRequiredHint: "對應 Meta Flows DocumentPicker 的 min-uploaded-documents：開啟為至少 1 個（必填），關閉為 0（選填）。",
        commerceCollectionHint: "選項內容對應「Commerce 集合」（CommerceCollections）下的商品，顯示為「商品名稱 - 單位」，回傳值為商品 ID（commerce_products.Id）。"
      },
      defaultValues: {
        richTextDefault: "請輸入富文本內容",
        richTextDefaultLine2: "支持 *粗體*、_斜體_、~刪除線~ 等 Markdown 語法",
        imageAltDefault: "圖片 {index}"
      },
      dividers: {
        actionSettings: "操作設置"
      }
    },
    screenEditor: {
      cardTitles: {
        header: "Header（可選）",
        body: "Body（必填）",
        footer: "Footer（必填）",
        actions: "Actions（操作組件）"
      },
      labels: {
        headerType: "Header 類型:",
        headerText: "Header 文字:",
        mediaUrl: "媒體 URL:",
        bodyExamplesTitle: "Body 變數範例值（送 Meta 審核用）",
        flowHeaderText: "Flow 表單內 Header（在 Flow popup 顯示）",
        flowBodyText: "Flow 表單內 Body（在 Flow popup 顯示，建議寫固定話術）",
        templateHeaderText: "WhatsApp 訊息 Header（送 Template 用，可含 {{1}}）",
        templateBodyText: "WhatsApp 訊息 Body（送 Template 用，可含 {{N}} placeholder）"
      },
      selectOptions: {
        headerTypes: {
          text: "文字",
          image: "圖片",
          video: "視頻",
          document: "文檔"
        }
      },
      placeholders: {
        headerText: "Header 文字",
        mediaUrl: "媒體 URL",
        bodyContent: "輸入 Body 內容",
        footerContent: "輸入 Footer 內容（必填）",
        addComponent: "請輸入組件類型 (text_input, rich_text, date_picker, select, checkbox, radio):",
        dropZone: "從左側組件庫拖放組件到此處",
        bodyExampleValue: "{{{n}}} 的範例值",
        templateHeaderText: "例：客戶 {{1}} 您好",
        templateBodyText: "例：Product: {{1}}\\nQuantity: {{2}}\\nDate: {{3}}"
      },
      buttons: {
        removeHeader: "移除 Header",
        addHeader: "添加 Header",
        addComponent: "添加組件"
      },
      tooltips: {
        dragToReorder: "拖拽以調整順序"
      },
      messages: {
        maxImagesError: "每個屏幕最多只能添加 3 張圖片！",
        addRichTextSuccess: "已添加 {componentType} 組件，已自動移除 Header 和 Body",
        addComponentSuccess: "已添加 {componentType} 組件",
        deleteRichTextSuccess: "已刪除 RichText 組件，已自動恢復 Header 和 Body",
        deleteComponentSuccess: "已刪除組件",
        richTextConflict1: "RichText 組件只能與 Footer 配對使用，不能與其他組件共存",
        richTextConflict2: "RichText 組件只能與 Footer 配對使用，請先移除 RichText"
      },
      helperText: {
        footerRequired: "* Footer 是必填項，不能為空",
        bodyExamplesHint: "Body 含 {{N}} placeholder 時，這裡的範例值只用於送 Meta 審核 Flow Template，執行時實際值仍由發送節點的流程資料映射注入。",
        flowHeaderHint: "{{N}} 在這裡不會被替換（會原樣顯示），建議寫成固定標題。",
        flowBodyHint: "{{N}} 在這裡不會被替換（會原樣顯示），建議寫成固定話術，例如「請確認以下資料並按 Reserve」。",
        templateHeaderHint: "出現在 WhatsApp 訊息氣泡上方；發送時會由 body.parameters 動態替換 {{1}}（Meta 限制 HEADER 僅支援單一 {{1}}）。未填則沿用 Flow 表單內 Header（向後相容）。",
        templateBodyHint: "出現在 WhatsApp 訊息氣泡內文；發送時會由 body.parameters 動態替換 {{N}}。{{N}} 必須與發送節點的「模板變量」對應。未填則沿用 Flow 表單內 Body（向後相容）。",
        templateHeaderTooManyPlaceholders: "Meta API 限制 HEADER 僅支援單一 {{1}}，多餘的 placeholder 不會被替換，請只保留一個。"
      },
      defaultValues: {
        headerText: "標題",
        bodyText: "請輸入內容",
        footerText: "提交"
      }
    },
    componentRenderer: {
      placeholders: {
        button: "按鈕",
        textInput: "文字輸入",
        textArea: "多行文字",
        richText: "富文本內容（支持 Markdown）",
        select: "下拉選擇",
        datePicker: "日期選擇",
        option: "選項",
        image: "圖片",
        imageIndex: "圖片 {index}",
        addImages: "請添加圖片（最少 1 張，最多 3 張）",
        unknownComponent: "未知組件",
        component: "組件"
      },
      cardTitles: {
        edit: "編輯 {componentType}"
      },
      buttons: {
        cancel: "取消"
      },
      helperText: {
        imageCarouselSettings: "寬高比: {aspectRatio}, 縮放: {scaleType}"
      },
      altText: {
        preview: "預覽"
      }
    },
    componentPalette: {
      componentLabels: {
        textInput: "文字輸入",
        textArea: "多行文字",
        datePicker: "日期選擇",
        calendarPicker: "日曆選擇",
        select: "下拉選擇",
        checkbox: "複選框組",
        radio: "單選框組",
        chipsSelector: "小標籤選擇器",
        image: "圖片",
        imageCarousel: "圖片輪播",
        photoPicker: "照片選擇器",
        documentPicker: "文檔選擇器",
        embeddedLink: "嵌入式鏈接",
        optIn: "選擇加入",
        if: "條件判斷 (If)",
        switch: "條件渲染 (Switch)",
        navigationList: "導航列表",
        richText: "富文本顯示"
      },
      categories: {
        input: "輸入",
        select: "選擇",
        media: "媒體",
        mediaUpload: "媒體上傳",
        link: "鏈接",
        logic: "邏輯",
        container: "容器",
        textDisplay: "文本顯示",
        other: "其他"
      },
      sectionTitles: {
        componentLibrary: "組件庫"
      }
    },
    page: {
      formInfo: "表單信息",
      flowName: "Flow 名稱:",
      flowNamePlaceholder: "Flow 名稱",
      description: "描述:",
      descriptionPlaceholder: "描述",
      screens: "Screens",
      editScreen: "編輯 Screen: {title}",
      selectScreenToEdit: "請選擇一個 Screen 進行編輯",
      componentProperties: "組件屬性",
      back: "返回",
      screenProperties: "Screen 屬性",
      screenId: "Screen ID:",
      screenTitle: "Screen Title:",
      screenTitlePlaceholder: "Screen 標題",
      componentList: "組件列表",
      noComponents: "暫無組件，請在左側組件庫添加",
      delete: "刪除",
      defaultFlowName: "新 Flow",
      defaultScreenTitle: "新 Screen",
      defaultComponentName: "組件 {index}",
      fieldDisplaySetting: "表單字段顯示設定",
      messages: {
        flowNameRequired: "請輸入 Flow 名稱",
        screenAdded: "已添加新 Screen",
        selectScreenFirst: "請先選擇一個 Screen",
        componentUpdated: "組件已更新",
        noFieldsToConfigure: "請先設計 Flow 並加入輸入組件",
        fieldDisplaySettingPendingSave: "字段設定已暫存，請按「保存」按鈕讓變更生效"
      }
    },
    aiAssistant: {
      tabTitle: "AI 助理",
      chatEmptyHint: "輸入需求，AI 將協助生成或修改 Meta Flow 表單",
      placeholderExample: "例如：建立包含姓名、電話、日期的客戶登記表單",
      includeCurrentFlow: "包含當前 Meta Flow JSON（修改模式）",
      generate: "生成表單",
      pleaseEnterRequirements: "請輸入需求描述",
      generationFailed: "生成失敗：",
      generationSuccess: "AI 已成功生成 Meta Flow 表單",
      updatedSuccess: "已根據您的要求更新 Meta Flow 表單",
      applyFailed: "套用 AI 生成的表單失敗"
    },
    formTypeSelection: {
      title: "選擇表單類型",
      htmlFormDesigner: {
        title: "HTML 表單設計器",
        description: "使用現有的 HTML 表單設計器創建表單"
      },
      metaFlowBuilder: {
        title: "Meta Flow Builder",
        description: "創建 WhatsApp Flows 表單（JSON 格式）"
      }
    }
  },

  // PWA 權限管理（2026-05 起與聯絡人主檔解耦，改為直接管理 PWA Account）
  wpaPermissions: {
    title: 'PWA 權限管理',
    pageTitle: 'PWA 權限管理',
    tabRoles: '角色',
    tabGroups: '群組',
    tabAccounts: 'PWA 帳號',
    rolesTitle: 'PWA 角色',
    groupsTitle: '權限群組',
    accountsTitle: 'PWA 帳號',
    roleKey: '角色代碼',
    displayName: '顯示名稱',
    description: '說明',
    groupCount: '群組數',
    contactCount: '聯絡人數',
    accounts: 'PWA 帳號',
    accountCount: '帳號數',
    editRole: '編輯角色',
    groupName: '群組名稱',
    role: '角色',
    memberCount: '成員數',
    customerCount: '客戶數',
    status: '狀態',
    active: '啟用',
    inactive: '停用',
    disabled: '停用',
    createGroup: '新增群組',
    editGroup: '編輯群組',
    members: '成員',
    customers: '客戶',
    addMember: '新增成員',
    addMembers: '新增成員',
    addCustomer: '新增客戶',
    addCustomers: '新增客戶',
    remove: '移除',
    search: '搜尋',
    name: '名稱',
    phone: '電話',
    phonePlaceholder: '例如 85291234567（不含 +）',
    email: '電郵',
    customerNo: '客戶編號',
    branchNo: '分店',
    customerName: '客戶名稱',
    selectCustomersTable: '以表格選擇客戶',
    selectCustomersTableHint: '開啟與客戶主檔相同的列表，可搜尋、篩選公司（租戶管理員）、多選',
    selectDefaultCustomer: '選擇預設客戶',
    selectDefaultCustomerTable: '以表格選擇預設客戶',
    selectDefaultCustomerOverrideHint: '須為已指派客戶之一；若選擇尚未指派的客戶，將一併加入指派清單',
    effectiveRole: '有效角色',
    roleSource: '來源',
    override: '個別設置',
    accountOverride: '帳號',
    group: '群組繼承',
    overrideCustomerCount: '指定客戶數',
    items: '筆',
    details: '明細',
    // Account（取代原 Contact override）
    createAccount: '新增帳號',
    editAccountFor: '編輯帳號',
    deleteAccount: '刪除帳號',
    deleteAccountConfirm: '確定刪除此 PWA 帳號嗎？相關角色／客戶／群組成員將一併刪除',
    accountSaved: '帳號已儲存',
    saveAndSendNotification: '儲存並發出通知',
    saveAndResendPassword: '儲存並重發密碼',
    saveAndResendPasswordConfirm: '將儲存變更、自動產生新密碼並重發 welcome 訊息（含電郵）。確定繼續？',
    saveAndResendPasswordSuccess: '已儲存、重設密碼並重發 welcome 訊息',
    accountDeleted: '帳號已刪除',
    accountTabIdentity: '帳號／角色',
    accountTabCustomers: '客戶／預設客戶',
    accountIdentityHint: 'PWA 登入帳號（與聯絡人主檔解耦）。Phone 用於 WhatsApp OTP 登入比對。',
    searchAccount: '搜尋 PWA 帳號…',
    loginId: '登入帳號',
    loginIdField: '登入帳號',
    loginIdRequired: '請填寫登入帳號',
    password: '密碼',
    passwordRequiredForCreate: '建立帳號須設定密碼',
    newPassword: '新密碼',
    newPasswordHint: '留空則不變更密碼',
    defaultCustomer: '預設客戶',
    selectCustomers: '選擇客戶',
    selectRole: '選擇角色',
    removeMemberConfirm: '確定移除此成員嗎？',
    removeCustomerConfirm: '確定移除此客戶嗎？',
    deleteGroupConfirm: '確定刪除此群組嗎？',
    memberAdded: '成員已加入',
    memberRemoved: '成員已移除',
    customerAdded: '客戶已加入',
    customerRemoved: '客戶已移除',
    groupSaved: '群組已儲存',
    groupDeleted: '群組已刪除',
    groupCustomersUpdated: '群組客戶已更新',
    roleSaved: '角色已儲存',
    contactName: '聯絡人名稱',
    loginName: '登入帳號',
    loginNamePlaceholder: '請輸入登入帳號',
    hasPassword: '已設密碼',
    selectContact: '選擇聯絡人',
    noData: '無資料',
    saveSuccess: '儲存成功',
    deleteSuccess: '刪除成功',
    confirmDelete: '確定要刪除嗎？',
    tabOtpSettings: 'OTP',
    otpSettingsTitle: 'OTP 設定',
    otpTabWhatsapp: 'WhatsApp',
    otpTabEmail: '電郵模板',
    otpEmailHint: '用於 PWA「忘記密碼」電郵驗證碼。主旨或正文須含 {{1}}，發送時會替換為 6 位 OTP。',
    otpEmailTemplateTitle: '電郵 OTP 模板',
    otpEmailSubject: '郵件主旨',
    otpEmailSubjectPlaceholder: '例如：【公司名稱】密碼重設驗證碼 {{1}}',
    otpEmailBody: '郵件正文（支援 HTML）',
    otpEmailBodyPlaceholder: '<p>您好，</p><p>您的驗證碼為：<strong>{{1}}</strong></p><p>驗證碼 5 分鐘內有效。</p>',
    otpEmailPreview: '效果預覽（{{1}} → 123456）',
    otpEmailRequired: '請填寫電郵主旨與正文',
    otpEmailPlaceholderRequired: '主旨或正文至少須包含 {{1}} 作為 OTP 驗證碼占位符',
    otpEmailSaved: '電郵 OTP 模板已儲存',
    otpWhatsappSaved: 'WhatsApp OTP 設定已儲存',
    tabWelcomeSettings: 'Welcome Message',
    welcomeSettingsTitle: 'Welcome Message',
    welcomeWhatsappHint: '新 PWA 帳號建立成功後，若帳號有電話且已設定模板，將自動發送 WhatsApp 歡迎訊息。正文可使用 {{1}}=登入帳號、{{2}}=顯示名稱。',
    welcomeWhatsappPolicyWarning: 'WhatsApp 模板僅適用於一般通知、說明或介紹，不得傳送密碼等敏感憑證；初始密碼請改以「Welcome Message → 電郵模板」發送。',
    welcomeActiveTemplate: '目前啟用的歡迎 Template',
    welcomeNoTemplate: '尚未設定歡迎 Template',
    welcomeCreateTemplate: '建立新 Welcome Template',
    welcomeCatMarketing: '市場 MARKETING',
    welcomeCatUtility: '工具 UTILITY',
    welcomeCatAuth: '驗證 AUTHENTICATION',
    welcomeAuthHint: 'AUTHENTICATION 類別由 Meta 產生安全文案，不建議用於一般歡迎訊息。',
    welcomeTemplateList: '已建立的 Templates',
    welcomeSelectTemplate: '請先選擇已審批的 Template',
    welcomeWhatsappSaved: 'WhatsApp 歡迎訊息設定已儲存',
    welcomeEmailRequired: '請填寫電郵主旨與正文',
    welcomeEmailSaved: '電郵歡迎訊息模板已儲存',
    welcomeBodyRequired: '請輸入模板正文',
    welcomeTplSubmitted: 'Template 已提交 Meta 審核',
    welcomeEmailHint: '新帳號有電郵時發送。{{login_id}}/{{1}}=帳號、{{display_name}}/{{2}}=名稱、{{password}}/{{3}}=建立時密碼（僅當次）。',
    welcomeEmailTemplateTitle: '電郵歡迎模板',
    welcomeEmailRteHint: '工具列可設定粗體、連結等；右側按鈕可插入帳號／名稱／密碼變量。',
    welcomeInsertLoginId: '插入登入帳號 {{login_id}}',
    welcomeInsertDisplayName: '插入顯示名稱 {{display_name}}',
    welcomeInsertPassword: '插入初始密碼 {{password}}',
    welcomeRteBold: '粗體',
    welcomeRteItalic: '斜體',
    welcomeRteUnderline: '底線',
    welcomeRteStrike: '刪除線',
    welcomeRteHeader: '標題',
    welcomeRteColor: '文字顏色',
    welcomeRteBackground: '背景色',
    welcomeRteListOrdered: '編號清單',
    welcomeRteListBullet: '項目符號',
    welcomeRteAlign: '對齊',
    welcomeRteLink: '插入連結',
    welcomeRteClean: '清除格式'
  },
  chatBotInbox: {
    loadFailed: '載入對話列表失敗',
    searchPlaceholder: '搜尋聯絡人或號碼…',
    filterAll: '全部',
    filterContact: '聯絡人',
    filterAnonymous: '匿名',
    sourceAll: '全部來源',
    sourceChatBot: 'ChatBot',
    sourceChatOrderingCart: '購物車',
    empty: '暫無對話紀錄',
    selectSession: '請從左側選擇一個對話',
    pollingActive: '即時更新中（每 30 秒自動檢查新訊息）',
    newMessagesAvailable: '有新訊息，',
    reloadNow: '立即載入'
  }
};

// Force reload: 2024-01-02 - Added timeout to workflowDesigner
export default zhTC; 